var _defs, _g, _g2, _g3, _g4;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgTopic3(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 1140 602.84",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#d1d5dd;}.cls-1,.cls-2,.cls-3,.cls-4,.cls-5,.cls-6,.cls-7,.cls-8,.cls-9,.cls-10,.cls-11,.cls-12,.cls-13,.cls-14,.cls-15,.cls-16,.cls-17,.cls-18,.cls-19,.cls-20,.cls-21,.cls-22,.cls-23,.cls-24,.cls-25,.cls-26,.cls-27,.cls-28,.cls-29,.cls-30,.cls-31,.cls-32,.cls-33,.cls-34,.cls-35,.cls-36,.cls-37,.cls-38,.cls-39,.cls-40,.cls-41,.cls-42,.cls-43,.cls-44,.cls-45,.cls-46,.cls-47,.cls-48,.cls-49,.cls-50,.cls-51,.cls-52,.cls-53,.cls-54,.cls-55,.cls-56,.cls-57,.cls-58,.cls-59,.cls-60,.cls-61,.cls-62,.cls-63,.cls-64,.cls-65,.cls-66,.cls-67,.cls-68,.cls-69,.cls-70,.cls-71,.cls-72,.cls-73,.cls-74,.cls-75,.cls-76,.cls-77,.cls-78,.cls-79,.cls-80,.cls-81,.cls-82,.cls-83,.cls-84,.cls-85,.cls-86,.cls-87,.cls-88,.cls-89,.cls-90,.cls-91,.cls-92,.cls-93,.cls-94,.cls-95,.cls-96,.cls-97,.cls-98,.cls-99,.cls-100,.cls-101,.cls-102,.cls-103,.cls-104,.cls-105,.cls-106,.cls-107,.cls-108,.cls-109,.cls-110,.cls-111,.cls-112,.cls-113,.cls-114,.cls-115,.cls-116,.cls-117,.cls-118,.cls-119,.cls-120,.cls-121,.cls-122,.cls-123,.cls-124,.cls-125,.cls-126,.cls-127,.cls-128,.cls-129,.cls-130,.cls-131,.cls-132,.cls-133,.cls-134,.cls-135,.cls-136,.cls-137,.cls-138,.cls-139,.cls-140,.cls-141,.cls-142,.cls-143,.cls-144,.cls-145,.cls-146,.cls-147,.cls-148,.cls-149,.cls-150,.cls-151,.cls-152,.cls-153,.cls-154,.cls-155,.cls-156,.cls-157,.cls-158,.cls-159,.cls-160,.cls-161,.cls-162,.cls-163,.cls-164,.cls-165,.cls-166,.cls-167,.cls-168,.cls-169,.cls-170,.cls-171,.cls-172,.cls-173,.cls-174,.cls-175,.cls-176,.cls-177,.cls-178,.cls-179,.cls-180,.cls-181,.cls-182,.cls-183,.cls-184,.cls-185,.cls-186,.cls-187,.cls-188,.cls-189,.cls-190,.cls-191,.cls-192,.cls-193,.cls-194,.cls-195,.cls-196,.cls-197,.cls-198,.cls-199,.cls-200,.cls-201,.cls-202,.cls-203,.cls-204,.cls-205,.cls-206,.cls-207,.cls-208,.cls-209,.cls-210,.cls-211,.cls-212,.cls-213,.cls-214,.cls-215,.cls-216,.cls-217,.cls-218,.cls-219,.cls-220,.cls-221,.cls-222,.cls-223,.cls-224,.cls-225,.cls-226,.cls-227,.cls-228,.cls-229,.cls-230,.cls-231,.cls-232,.cls-233,.cls-234,.cls-235,.cls-236,.cls-237,.cls-238,.cls-239,.cls-240,.cls-241,.cls-242,.cls-243,.cls-244,.cls-245,.cls-246,.cls-247,.cls-248,.cls-249,.cls-250,.cls-251,.cls-252,.cls-253,.cls-254,.cls-255,.cls-256,.cls-257,.cls-258,.cls-259,.cls-260,.cls-261,.cls-262,.cls-263,.cls-264,.cls-265,.cls-266,.cls-267,.cls-268,.cls-269,.cls-270,.cls-271,.cls-272,.cls-273,.cls-274,.cls-275,.cls-276,.cls-277,.cls-278,.cls-279,.cls-280,.cls-281,.cls-282,.cls-283,.cls-284,.cls-285,.cls-286,.cls-287,.cls-288,.cls-289,.cls-290,.cls-291,.cls-292,.cls-293,.cls-294,.cls-295,.cls-296,.cls-297,.cls-298,.cls-299,.cls-300,.cls-301,.cls-302,.cls-303,.cls-304,.cls-305,.cls-306,.cls-307,.cls-308,.cls-309,.cls-310,.cls-311,.cls-312,.cls-313,.cls-314,.cls-315,.cls-316,.cls-317,.cls-318,.cls-319,.cls-320,.cls-321,.cls-322,.cls-323,.cls-324,.cls-325,.cls-326,.cls-327,.cls-328,.cls-329,.cls-330,.cls-331,.cls-332,.cls-333,.cls-334,.cls-335,.cls-336,.cls-337,.cls-338,.cls-339,.cls-340,.cls-341,.cls-342,.cls-343,.cls-344,.cls-345,.cls-346,.cls-347,.cls-348,.cls-349,.cls-350,.cls-351,.cls-352,.cls-353,.cls-354,.cls-355,.cls-356,.cls-357,.cls-358,.cls-359,.cls-360,.cls-361,.cls-362,.cls-363,.cls-364,.cls-365,.cls-366,.cls-367,.cls-368,.cls-369,.cls-370,.cls-371,.cls-372,.cls-373,.cls-374,.cls-375,.cls-376,.cls-377,.cls-378,.cls-379,.cls-380,.cls-381,.cls-382,.cls-383,.cls-384,.cls-385,.cls-386,.cls-387,.cls-388,.cls-389,.cls-390,.cls-391,.cls-392,.cls-393,.cls-394,.cls-395,.cls-396,.cls-397,.cls-398,.cls-399,.cls-400,.cls-401,.cls-402,.cls-403,.cls-404,.cls-405,.cls-406,.cls-407,.cls-408,.cls-409,.cls-410,.cls-411,.cls-412,.cls-413,.cls-414,.cls-415,.cls-416,.cls-417,.cls-418,.cls-419,.cls-420,.cls-421,.cls-422,.cls-423,.cls-424,.cls-425,.cls-426,.cls-427,.cls-428,.cls-429,.cls-430,.cls-431,.cls-432,.cls-433,.cls-434,.cls-435,.cls-436,.cls-437,.cls-438,.cls-439,.cls-440,.cls-441,.cls-442,.cls-443,.cls-444,.cls-445{stroke-width:0px;}.cls-2{fill:#b9bfca;}.cls-3{fill:#b2b8c5;}.cls-446{letter-spacing:-.04em;}.cls-4{fill:#a7715e;}.cls-5{fill:#4c1627;}.cls-6{fill:#6e2d1c;}.cls-7{fill:#e30136;}.cls-8{fill:#aab0be;}.cls-9{fill:#adb3c0;}.cls-10{fill:#3b1828;}.cls-11{fill:#783a28;}.cls-12{fill:#b5bbc7;}.cls-13{fill:#753624;}.cls-14{fill:#c1c6d0;}.cls-15{fill:#b68370;}.cls-16{fill:#aa7461;}.cls-17{fill:#bc072f;}.cls-18{fill:#601425;}.cls-19{fill:#c8cdd6;}.cls-20{fill:#361828;}.cls-21{fill:#894d3b;}.cls-22{fill:#c69481;}.cls-23{fill:#e10235;}.cls-24{fill:#8e5341;}.cls-25{fill:#aab1be;}.cls-26{fill:#8a4e3d;}.cls-27{fill:#7a8498;}.cls-28{fill:#778196;}.cls-29{fill:#2e1929;}.cls-30{fill:url(#linear-gradient);}.cls-31{fill:#7d869a;}.cls-32{fill:#e90037;}.cls-33{fill:#848da0;}.cls-34{fill:#9098aa;}.cls-35{fill:#481627;}.cls-36{fill:#70301f;}.cls-37{fill:#ccd0d9;}.cls-38{fill:#d80334;}.cls-39{fill:#741224;}.cls-40{fill:#2c1a29;}.cls-41{fill:#a9b0bd;}.cls-42{fill:#850f25;}.cls-43{fill:#bbc1cc;}.cls-44{fill:#6c1324;}.cls-45{fill:#531526;}.cls-46{fill:#985f4d;}.cls-47{fill:#a66f5d;}.cls-48{fill:#d1d5dc;}.cls-49{fill:#c90531;}.cls-50{fill:#a3aab8;}.cls-51{fill:#6a2a19;}.cls-52{fill:#b7bdc8;}.cls-53{fill:#743523;}.cls-54{fill:#341929;}.cls-55{fill:#cc9c89;}.cls-56{fill:#aeb4c1;}.cls-57{fill:#3d1828;}.cls-58{fill:#1c1b2a;}.cls-59{fill:#4e1627;}.cls-60{fill:#daac98;}.cls-61{fill:#611425;}.cls-62{fill:#b5082d;}.cls-63{fill:#ea0037;}.cls-64{fill:#713120;}.cls-65{fill:#939bac;}.cls-66{fill:#864a39;}.cls-67{fill:#a7aebc;}.cls-68{fill:#969eae;}.cls-69{fill:#6b2a19;}.cls-70{fill:#223654;}.cls-71{fill:#793a29;}.cls-72{fill:#a0a7b6;}.cls-73{fill:#d20433;}.cls-74{fill:#bb8875;}.cls-75{fill:#7f4130;}.cls-76{fill:#b98673;}.cls-77{fill:#824533;}.cls-78{fill:#1d1b2a;}.cls-79{fill:#a8aebc;}.cls-80{fill:#be8b78;}.cls-81{fill:#9aa2b1;}.cls-82{fill:#bec3ce;}.cls-83{fill:#798398;}.cls-84{fill:#cb9a87;}.cls-85{fill:#a16a57;}.cls-86{fill:#c60630;}.cls-447{font-family:Ubuntu-Bold, Ubuntu;font-size:16.26px;font-weight:700;}.cls-447,.cls-370{fill:#a3ea2a;}.cls-87{fill:#b47f6c;}.cls-88{fill:#969dae;}.cls-448{clip-path:url(#clippath-2);}.cls-89{fill:#929aab;}.cls-90{fill:#b1b7c4;}.cls-91{fill:#bc8976;}.cls-92{fill:#b6082e;}.cls-93{fill:#6c2b1a;}.cls-94{fill:#8b0e26;}.cls-95{fill:#838c9f;}.cls-96{fill:#8c94a6;}.cls-97{fill:#8f5442;}.cls-98{fill:#ae7966;}.cls-99{fill:#d3d7df;}.cls-100{fill:#b3b9c5;}.cls-101{fill:#cdd2da;}.cls-102{fill:#561526;}.cls-103{fill:#7b8599;}.cls-104{fill:#8b4f3e;}.cls-106{fill:#2d1929;}.cls-107{fill:#864938;}.cls-108{fill:#4f1626;}.cls-109{fill:#870f25;}.cls-110{fill:#844736;}.cls-111{fill:#e3b7a3;}.cls-112{fill:#b4bac6;}.cls-113{fill:#ce9e8b;}.cls-114{fill:#811024;}.cls-115{fill:#e1b5a1;}.cls-116{fill:#6f1224;}.cls-117{fill:#781123;}.cls-118{fill:#381828;}.cls-119{fill:#151c2b;}.cls-120{fill:#caced7;}.cls-121{fill:#788297;}.cls-122{fill:#798297;}.cls-123{fill:#391828;}.cls-124{fill:#1c2538;}.cls-449{clip-path:url(#clippath-6);}.cls-125{fill:#291a29;}.cls-126{fill:#bfc4cf;}.cls-127{fill:#b7bdc9;}.cls-128{fill:#818a9d;}.cls-129{fill:#e20135;}.cls-130{fill:#581526;}.cls-131{fill:#ced3db;}.cls-132{fill:#471727;}.cls-133{fill:#831025;}.cls-134{fill:#9c0c29;}.cls-135{fill:#1f1b2a;}.cls-136{fill:#8d5240;}.cls-137{fill:#c20630;}.cls-138{fill:#c70531;}.cls-139{fill:#c8ccd5;}.cls-140{fill:#6d1224;}.cls-141{fill:#d3a490;}.cls-142{fill:#5d1425;}.cls-143{fill:url(#linear-gradient-5);}.cls-144{fill:#d5a692;}.cls-145{fill:#824534;}.cls-146{fill:#7c3f2d;}.cls-147{fill:#975d4b;}.cls-148{fill:#b0b6c2;}.cls-149,.cls-450,.cls-451{fill:none;}.cls-150{fill:#868ea1;}.cls-151{fill:#2a1a29;}.cls-152{fill:#5b1425;}.cls-153{fill:#b17c69;}.cls-154{fill:#9ea5b4;}.cls-155{fill:#788197;}.cls-156{fill:#a06856;}.cls-157{fill:#c0062f;}.cls-158{fill:#501626;}.cls-159{fill:#9ca4b3;}.cls-160{fill:#d60333;}.cls-161{fill:#6b2b1a;}.cls-452{clip-path:url(#clippath-7);}.cls-162{fill:#431727;}.cls-163{fill:#df0235;}.cls-164{fill:#bf8d7a;}.cls-165{fill:#70311f;}.cls-166{fill:#8891a3;}.cls-167{fill:#de0235;}.cls-168{fill:#7c859a;}.cls-169{fill:#804331;}.cls-170{fill:#925745;}.cls-171{fill:#747e93;}.cls-172{fill:#c3c8d2;}.cls-173{fill:#747e94;}.cls-174{fill:#8b94a6;}.cls-175{fill:#c4927f;}.cls-453{clip-path:url(#clippath-1);}.cls-454{clip-path:url(#clippath-4);}.cls-176{fill:#7e879c;}.cls-177{fill:#814432;}.cls-178{fill:#763826;}.cls-179{fill:#cc0531;}.cls-180{fill:#331929;}.cls-181{fill:#461727;}.cls-182{fill:#9a0c29;}.cls-183{fill:#d40333;}.cls-184{fill:#99a1b1;}.cls-185{fill:#cf0432;}.cls-186{fill:#261a2a;}.cls-187{fill:#b9082e;}.cls-188{fill:#a26b59;}.cls-189{fill:#aa0a2b;}.cls-190{fill:#7a3c2a;}.cls-191{fill:#783928;}.cls-192{fill:#9b6350;}.cls-193{fill:#dfb29f;}.cls-194{fill:#d90334;}.cls-195{fill:#691324;}.cls-196{fill:#d0d4db;}.cls-197{fill:#9f6754;}.cls-198{fill:#980c28;}.cls-199{fill:#181c2b;}.cls-200{fill:#271a2a;}.cls-201{fill:#9aa2b2;}.cls-202{fill:#d30433;}.cls-203{fill:#5e1425;}.cls-204{fill:#949cad;}.cls-205{fill:#c2c7d1;}.cls-206{fill:#d2d6dd;}.cls-207{fill:#d6a894;}.cls-208{fill:#c40630;}.cls-209{fill:#ad092c;}.cls-210{fill:#d0d4dc;}.cls-211{fill:#bb072e;}.cls-212{fill:#bf072f;}.cls-213{fill:#d50333;}.cls-214{fill:#af7a68;}.cls-215{fill:#a4abb9;}.cls-216{fill:#641325;}.cls-217{fill:#401728;}.cls-218{fill:#babfca;}.cls-219{fill:#b0092d;}.cls-220{fill:#a00b2a;}.cls-221{fill:#838ca0;}.cls-222{fill:#c5cad3;}.cls-223{fill:#fff;}.cls-224{fill:url(#linear-gradient-7);}.cls-224,.cls-273{isolation:isolate;opacity:.5;}.cls-225{fill:#8992a4;}.cls-226{fill:#e60136;}.cls-227{fill:#b2092d;}.cls-228{fill:#9c6452;}.cls-229{fill:#7b3c2b;}.cls-230{fill:#d2d6de;}.cls-231{fill:#7a1123;}.cls-232{fill:#935846;}.cls-233{fill:#7c1123;}.cls-450{stroke:#a3ea2a;stroke-width:3px;}.cls-450,.cls-451{stroke-miterlimit:10;}.cls-234{fill:#970d28;}.cls-235{fill:#ab7563;}.cls-236{fill:#7e1024;}.cls-237{fill:#371828;}.cls-238{fill:#767f95;}.cls-239{fill:#7a8398;}.cls-240{fill:#1a1b2b;}.cls-241{fill:#ccd1d9;}.cls-242{fill:#aeb5c1;}.cls-243{fill:url(#linear-gradient-2);}.cls-244{fill:#a5acba;}.cls-245{fill:#e50136;}.cls-246{fill:#6d2d1c;}.cls-247{fill:#721224;}.cls-248{fill:#8d0e26;}.cls-249{fill:#d4d8df;}.cls-250{fill:#e80036;}.cls-251{fill:#c7ccd5;}.cls-252{fill:#771123;}.cls-253{fill:#a10b2a;}.cls-451{stroke:#727c92;stroke-width:.75px;}.cls-254{fill:#a46c5a;}.cls-455{letter-spacing:-.02em;}.cls-255{fill:#1e1b2a;}.cls-256{fill:#bdc2cd;}.cls-257{fill:#4a1627;}.cls-258{fill:#c9ced6;}.cls-259{fill:#915644;}.cls-260{fill:#571526;}.cls-261{fill:#1b1b2b;}.cls-262{fill:url(#radial-gradient-2);}.cls-263{fill:#a70a2b;}.cls-264{fill:#7e402f;}.cls-265{fill:#a1a8b7;}.cls-266{fill:#deb09d;}.cls-267{fill:#727c92;}.cls-268{fill:url(#linear-gradient-3);}.cls-269{fill:#751223;}.cls-270{fill:#d3d7de;}.cls-271{fill:#8a93a5;}.cls-272{fill:#3bc81e;}.cls-273{fill:url(#linear-gradient-6);}.cls-274{fill:#733423;}.cls-275{fill:#8f0e27;}.cls-276{fill:#910e27;}.cls-277{fill:#afb5c2;}.cls-278{fill:#e40136;}.cls-279{fill:#979faf;}.cls-280{fill:#6c2c1b;}.cls-281{fill:#541526;}.cls-282{fill:#c4c9d3;}.cls-283{fill:#8d95a7;}.cls-284{fill:#171c2b;}.cls-285{fill:#7b8499;}.cls-286{fill:#2b1a29;}.cls-456{clip-path:url(#clippath);}.cls-287{fill:#b88471;}.cls-288{fill:#7f4230;}.cls-289{fill:#7c869a;}.cls-290{fill:#ac0a2c;}.cls-291{fill:#b2b9c5;}.cls-292{fill:#bdc3cd;}.cls-293{fill:#b5816e;}.cls-294{fill:url(#radial-gradient);}.cls-295{fill:#828b9f;}.cls-296{fill:#acb2bf;}.cls-297{fill:#6f2e1d;}.cls-298{fill:#959dad;}.cls-299{fill:#8f97a9;}.cls-300{fill:#da0334;}.cls-301{fill:#d1a28e;}.cls-302{fill:#768095;}.cls-303{fill:#723322;}.cls-304{fill:#950d28;}.cls-305{fill:#bac0cb;}.cls-306{fill:#221b2a;}.cls-307{fill:#6e2e1d;}.cls-308{fill:#858ea1;}.cls-309{fill:#965c4a;}.cls-310{fill:#161c2b;}.cls-311{fill:#ce0432;}.cls-312{fill:#c9cdd6;}.cls-313{fill:#661325;}.cls-314{fill:#737d92;}.cls-315{fill:#989fb0;}.cls-457{clip-path:url(#clippath-3);}.cls-316{fill:#251a2a;}.cls-317{fill:#521526;}.cls-318{fill:#737d93;}.cls-319{fill:#c6cbd4;}.cls-320{fill:#a56e5b;}.cls-321{fill:#281a29;}.cls-322{fill:#eb0037;}.cls-323{fill:#af092c;}.cls-324{fill:#abb1bf;}.cls-325{fill:#421727;}.cls-326{fill:#201b2a;}.cls-327{fill:#d10432;}.cls-328{fill:#930d27;}.cls-329{fill:#701224;}.cls-330{fill:#6a1324;}.cls-331{fill:#b8082e;}.cls-332{fill:#c79683;}.cls-333{fill:url(#linear-gradient-8);}.cls-334{fill:#778096;}.cls-335{fill:#411728;}.cls-336{fill:#bcc2cc;}.cls-337{fill:#733322;}.cls-338{fill:#b3082d;}.cls-339{fill:#bec4ce;}.cls-340{fill:#ad7764;}.cls-341{fill:#99a0b0;}.cls-342{fill:#9ba3b2;}.cls-343{fill:#a6adbb;}.cls-344{fill:#451727;}.cls-345{fill:#cacfd7;}.cls-346{fill:#dcae9a;}.cls-347{fill:#8790a3;}.cls-348{fill:#351928;}.cls-349{fill:#e00235;}.cls-350{fill:#773827;}.cls-351{fill:#d0a08c;}.cls-352{fill:#8e97a8;}.cls-353{fill:#723221;}.cls-354{fill:#311929;}.cls-355{fill:#d00432;}.cls-356{fill:#301929;}.cls-357{fill:#9098a9;}.cls-358{fill:#99604e;}.cls-359{fill:#a30b2a;}.cls-360{fill:#191c2b;}.cls-361{fill:#a50b2b;}.cls-362{fill:#d8aa96;}.cls-363{fill:#854837;}.cls-364{fill:#8991a4;}.cls-365{fill:#979eaf;}.cls-366{fill:#8890a3;}.cls-367{fill:#3a1828;}.cls-458{clip-path:url(#clippath-5);}.cls-368{fill:#753625;}.cls-369{fill:#241a2a;}.cls-371{fill:#dc0234;}.cls-372{fill:#cbd0d8;}.cls-373{fill:#ca0531;}.cls-374{fill:#a80a2b;}.cls-375{fill:#bbc1cb;}.cls-376{fill:#6a2918;}.cls-377{fill:#868fa2;}.cls-378{fill:#c50630;}.cls-379{fill:#631425;}.cls-380{fill:#9e6553;}.cls-381{fill:#dd0235;}.cls-382{fill:#9199ab;}.cls-383{fill:#6f2f1e;}.cls-384{fill:#db0234;}.cls-385{fill:#cb0531;}.cls-386{fill:#763726;}.cls-387{fill:#9e0c29;}.cls-388{fill:#231a2a;}.cls-389{fill:#955b49;}.cls-390{fill:#80899d;}.cls-391{fill:#c0c5cf;}.cls-392{fill:#2f1929;}.cls-393{fill:#7d3f2e;}.cls-394{fill:#cd0532;}.cls-395{fill:#3c1828;}.cls-396{fill:#757f94;}.cls-397{fill:#c3c8d1;}.cls-398{fill:#4b1627;}.cls-399{fill:url(#radial-gradient-3);}.cls-400{fill:#cfd3db;}.cls-401{fill:#211b2a;}.cls-402{fill:#743524;}.cls-403{fill:#9a614f;}.cls-404{fill:#ced2da;}.cls-405{fill:#671325;}.cls-406{fill:#e5b9a5;}.cls-407{fill:#b6bcc8;}.cls-408{fill:#6d2c1b;}.cls-409{fill:#834635;}.cls-410{fill:#905543;}.cls-411{fill:#c3917d;}.cls-412{fill:url(#linear-gradient-4);}.cls-413{fill:#3f1728;}.cls-414{fill:#793b2a;}.cls-415{fill:#9fa6b5;}.cls-416{fill:#321929;}.cls-417{fill:#7f889c;}.cls-418{fill:#ecbb0a;}.cls-419{fill:#7b3d2c;}.cls-420{fill:#c10630;}.cls-421{fill:#a97260;}.cls-422{fill:#890f26;}.cls-423{fill:#945a48;}.cls-424{fill:#9199aa;}.cls-425{fill:#e80037;}.cls-426{fill:#884c3a;}.cls-427{fill:#8e96a8;}.cls-428{fill:#949bac;}.cls-429{fill:#7c3e2c;}.cls-430{fill:#c99885;}.cls-431{fill:#b27d6b;}.cls-432{fill:#b0b6c3;}.cls-433{fill:#bd072f;}.cls-434{fill:#8c503f;}.cls-435{fill:#874b39;}.cls-436{fill:url(#radial-gradient-4);}.cls-437{fill:#818a9e;}.cls-438{fill:#5a1526;}.cls-439{fill:#c18f7c;}.cls-440{fill:#7e879b;}.cls-441{fill:#757f95;}.cls-442{fill:#b8bec9;}.cls-443{fill:#d70333;}.cls-444{fill:#e70136;}.cls-445{fill:#a8afbd;}"), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    x1: 697.6,
    y1: -77.61,
    x2: 803.12,
    y2: -77.61,
    gradientTransform: "translate(694.44 1188.06) rotate(-90) scale(1 -1)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.34,
    stopColor: "#223654"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4,
    stopColor: "#38554c"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#5e8940"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6,
    stopColor: "#7bb336"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.68,
    stopColor: "#91d12f"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.76,
    stopColor: "#9ee32b"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.81,
    stopColor: "#a3ea2a"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-2",
    x1: 135.14,
    y1: 98.38,
    x2: 814.66,
    y2: 98.38,
    gradientTransform: "matrix(1,0,0,1,0,0)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-3",
    x1: 822.07,
    y1: 361.06,
    x2: 822.07,
    y2: -8.23,
    gradientTransform: "matrix(1,0,0,1,0,0)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-4",
    x1: 84.51,
    y1: 198.46,
    x2: 567.98,
    y2: 198.46,
    gradientTransform: "matrix(1,0,0,1,0,0)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-5",
    x1: 84.51,
    y1: 415.99,
    x2: 567.98,
    y2: 415.99,
    gradientTransform: "matrix(1,0,0,1,0,0)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient",
    cx: 86.86,
    cy: 372.43,
    fx: 86.86,
    fy: 372.43,
    r: 35.84,
    gradientTransform: "translate(0 585.49) scale(1 -1)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#223654"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.37,
    stopColor: "#20324e"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.82,
    stopColor: "#1d293f"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.98,
    stopColor: "#1c2538"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-6",
    x1: 113.56,
    y1: 374.21,
    x2: 129.88,
    y2: 391.03,
    gradientTransform: "translate(0 585.49) scale(1 -1)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#1c2538"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.76,
    stopColor: "#2a59be"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-7",
    x1: 57.81,
    y1: 374.59,
    x2: 51.94,
    y2: 393.69,
    gradientTransform: "translate(0 585.49) scale(1 -1)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.02,
    stopColor: "#1c2538"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.76,
    stopColor: "#2a59be"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient-2",
    cx: 86.65,
    cy: 389.16,
    fx: 86.65,
    fy: 389.16,
    r: 13.85,
    gradientTransform: "translate(0 585.49) scale(1 -1)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#2a59be"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.16,
    stopColor: "#2957b8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.37,
    stopColor: "#2852a9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6,
    stopColor: "#26498f"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.84,
    stopColor: "#233d6b"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.98,
    stopColor: "#223654"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-8",
    x1: 86.76,
    y1: 376.98,
    x2: 86.92,
    y2: 402.29,
    gradientTransform: "translate(0 585.49) scale(1 -1)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#9c6239"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.25,
    stopColor: "#975f36"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.51,
    stopColor: "#8b562e"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.77,
    stopColor: "#764821"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.98,
    stopColor: "#603813"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient-3",
    cx: 91.23,
    cy: 429.16,
    fx: 91.23,
    fy: 429.16,
    r: 31.31,
    gradientTransform: "translate(0 585.49) scale(1 -1)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#1c2538"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.32,
    stopColor: "#1a2335"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.55,
    stopColor: "#151d2b"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.75,
    stopColor: "#0e121c"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.94,
    stopColor: "#030406"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.98,
    stopColor: "#000"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient-4",
    cx: 106.02,
    cy: 412.42,
    fx: 106.02,
    fy: 412.42,
    r: 27.48,
    gradientTransform: "translate(0 585.49) scale(1 -1)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#9c6239"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.23,
    stopColor: "#955d35"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.54,
    stopColor: "#835129"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.91,
    stopColor: "#663c17"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.98,
    stopColor: "#603813"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-149",
    d: "M131.99,448.22c-.45-1.59-4.98-24.69-6.8-26.73-1.81-2.04-8.16-3.62-9.29-3.62,0,0,.04.67.12,1.81l-10.54,1.14v-12.01c1.59-1.13,6.12-19.48,6.12-21.3s-10.42-19.94-11.78-21.52c-1.36-1.59-13.45-5.31-15.81-4.33-5.68,2.35-13.86,9.32-16.47,12.49s-4.42,18.35-3.96,22.2c.45,3.85,7.93,12.46,7.93,12.46l.54.26-15.94,10.72c-1.89.73-4.75,1.49-5.93,3.08-1.91,2.58-3.63,6.53-4.04,8.83-.32,1.78-.91,16.76-2.72,17.67s7.14,2.49,7.14,2.49l9.63-2.04-.98-12,59.47,6.72c.6,3.4,1.27,5.78,1.99,5.96,2.72.68,11.33,1.36,11.33,1.36,0,0,.45-2.04,0-3.62Z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-1"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-149",
    d: "M76.85,410.97s-7.86-13.04-7.16-17.93c.7-4.89,4.13-13.18,6.57-14.23s21.86-2.08,24.48.37c2.62,2.45,7.55,14.38,6.68,18.05s-5.24,15.55-5.24,15.55l-25.33-1.81Z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-2"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-149",
    d: "M102.24,397.49s-.18.98.48.56,2.18-5.44,2.18-5.44v-1.88l-1.34,3.06-1.32,3.71Z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-3"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-149",
    d: "M74.68,397.25s.27,1.19-.33.9-1.15-2.28-1.15-2.28l-.89-2.52v-2.26l1.59,3.82.78,2.34Z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-4"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-149",
    d: "M76.85,410.97s-7.86-13.04-7.16-17.93c.7-4.89,4.13-13.18,6.57-14.23s21.86-2.08,24.48.37c2.62,2.45,7.55,14.38,6.68,18.05s-5.24,15.55-5.24,15.55l-25.33-1.81Z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-5"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-149",
    d: "M75.04,375.47s-3.99,8.7-3.79,10.88,5.64,17.41,6.35,18.49,3.88,4.28,5.04,5,11.54.45,11.54.45c0,0,4.62-4.49,5.16-5.6s6.06-14.5,5.91-17.96-5.43-14.74-5.43-14.74l-24.79,3.49Z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-6"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-149",
    d: "M56.09,448.22v-37.85c0-.61.5-1.11,1.11-1.11h61.89c.61,0,1.11.5,1.11,1.11v37.85H56.09Z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-7"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-149",
    x: 54.06,
    y: 448.22,
    width: 67.96,
    height: 3.62,
    rx: 1.75,
    ry: 1.75
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_4"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-249",
    x: 443.18,
    y: 137.36,
    width: 463.65,
    height: 117.1,
    rx: 7.59,
    ry: 7.59
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-70",
    d: "M450.77,124.25h448.47c4.19,0,7.59,3.4,7.59,7.59v40.09h-463.65v-40.09c0-4.19,3.4-7.59,7.59-7.59Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-249",
    d: "M474.91,137.36h138.8c4.6,0,8.33,3.73,8.33,8.33v27.18h-155.47v-27.18c0-4.6,3.73-8.33,8.33-8.33Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-267",
    d: "M639.2,137.36h138.8c4.6,0,8.33,3.73,8.33,8.33v26.24h-155.47v-26.24c0-4.6,3.73-8.33,8.33-8.33Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-223",
    x: 591.68,
    y: 192,
    width: 294.28,
    height: 42.94,
    rx: 8,
    ry: 8
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-105",
    d: "M645.41,220.59v-15.05l1.28-.24v5.4c.42-.16.85-.28,1.28-.36.43-.08.87-.13,1.3-.13.79,0,1.44.11,1.97.33.53.22.95.54,1.26.96.32.41.54.91.66,1.49s.19,1.21.19,1.91v5.69h-1.28v-5.28c0-.72-.05-1.33-.15-1.83s-.26-.91-.49-1.22c-.23-.31-.54-.54-.92-.68-.38-.14-.86-.21-1.44-.21-.22,0-.46.02-.72.06s-.5.08-.72.13c-.22.05-.42.1-.6.15-.18.05-.29.09-.34.12v8.76h-1.28Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-105",
    d: "M657.82,210.41h4.06v1.08h-4.06v5.42c0,.58.05,1.05.15,1.41.1.36.24.64.42.84.18.2.41.33.67.39.26.07.55.1.87.1.54,0,.97-.06,1.3-.19.33-.12.58-.24.77-.34l.31,1.06c-.18.12-.5.25-.96.4s-.96.23-1.5.23c-.63,0-1.16-.08-1.58-.25-.43-.16-.77-.41-1.02-.75-.26-.33-.44-.75-.54-1.25-.11-.5-.16-1.09-.16-1.77v-9.38l1.28-.24v3.23Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-105",
    d: "M665.45,210.41h4.06v1.08h-4.06v5.42c0,.58.05,1.05.15,1.41.1.36.24.64.42.84.18.2.41.33.67.39.26.07.55.1.87.1.54,0,.97-.06,1.3-.19.33-.12.58-.24.77-.34l.31,1.06c-.18.12-.5.25-.96.4s-.96.23-1.5.23c-.63,0-1.16-.08-1.58-.25-.43-.16-.77-.41-1.02-.75-.26-.33-.44-.75-.54-1.25-.11-.5-.16-1.09-.16-1.77v-9.38l1.28-.24v3.23Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-105",
    d: "M673.15,224.23h-1.28v-13.47c.38-.13.87-.26,1.46-.37s1.34-.18,2.25-.18c.75,0,1.43.12,2.04.36.61.24,1.14.59,1.58,1.05.44.46.78,1.02,1.02,1.67.24.66.36,1.4.36,2.23,0,.77-.1,1.49-.3,2.14-.2.65-.5,1.21-.9,1.67-.39.47-.88.83-1.45,1.09-.57.26-1.22.39-1.96.39-.67,0-1.25-.1-1.74-.29-.49-.19-.85-.37-1.07-.54v4.23ZM673.15,218.76c.12.09.27.19.44.3.18.1.38.2.62.3s.49.17.77.23c.28.06.56.09.87.09.63,0,1.16-.11,1.58-.32.43-.22.77-.51,1.03-.89.26-.37.45-.81.57-1.32s.18-1.04.18-1.61c0-1.34-.33-2.37-1-3.08-.67-.72-1.56-1.07-2.66-1.07-.63,0-1.14.03-1.53.09-.39.06-.68.12-.88.19v7.11Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-105",
    d: "M685.44,219.68c.74,0,1.34-.12,1.82-.36.48-.24.72-.65.72-1.23,0-.28-.04-.51-.13-.71-.09-.2-.23-.37-.42-.53-.2-.16-.46-.31-.78-.45-.32-.14-.72-.31-1.19-.51-.38-.16-.74-.32-1.08-.48-.34-.16-.64-.35-.91-.57-.26-.22-.47-.48-.63-.78-.16-.3-.24-.67-.24-1.1,0-.83.31-1.5.94-2.01.62-.51,1.48-.77,2.57-.77.7,0,1.27.06,1.72.18s.77.22.96.32l-.29,1.14c-.16-.08-.42-.18-.8-.31-.37-.13-.92-.2-1.64-.2-.29,0-.56.03-.82.09-.26.06-.48.15-.68.28s-.35.28-.47.47-.18.42-.18.7.05.51.16.71c.1.2.26.37.46.52.2.15.45.29.75.42.3.13.63.27,1.01.43.39.16.77.32,1.13.48.36.16.68.36.96.59.28.23.5.51.67.83.17.32.26.73.26,1.21,0,.92-.34,1.62-1.03,2.09s-1.63.71-2.83.71c-.89,0-1.58-.08-2.05-.23s-.79-.27-.95-.34l.33-1.16s.12.07.26.13c.13.06.31.12.53.2.22.07.49.13.8.19.31.05.67.08,1.07.08Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-105",
    d: "M693.59,211.49c0,.3-.1.56-.29.77-.19.21-.46.32-.8.32s-.61-.1-.8-.32c-.19-.21-.29-.47-.29-.77s.1-.56.29-.77.46-.32.8-.32.61.11.8.32c.19.21.29.47.29.77ZM693.59,219.74c0,.3-.1.56-.29.77-.19.21-.46.31-.8.31s-.61-.11-.8-.31c-.19-.21-.29-.47-.29-.77s.1-.56.29-.77c.19-.21.46-.31.8-.31s.61.1.8.31c.19.21.29.47.29.77Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-105",
    d: "M695.78,224.23h-1.3l6.72-19.07h1.26l-6.68,19.07Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-105",
    d: "M702.85,224.23h-1.3l6.72-19.07h1.26l-6.68,19.07Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-105",
    d: "M717.34,210.41c.12.66.27,1.36.46,2.1s.4,1.5.63,2.26c.23.77.47,1.53.73,2.27s.52,1.45.78,2.11c.22-.5.46-1.1.71-1.82.25-.71.5-1.47.75-2.26.25-.79.48-1.59.7-2.4.22-.81.4-1.56.54-2.26h1.26c-.47,2-.99,3.83-1.55,5.48-.56,1.65-1.18,3.22-1.85,4.7h-1.19c-.2-.46-.41-.98-.63-1.55-.22-.57-.44-1.18-.67-1.83s-.46-1.33-.67-2.05-.42-1.45-.62-2.19c-.2.75-.4,1.48-.62,2.2-.22.72-.44,1.4-.67,2.05-.23.65-.45,1.26-.67,1.83-.22.57-.42,1.08-.62,1.54h-1.23c-.67-1.48-1.29-3.05-1.85-4.71-.56-1.65-1.07-3.48-1.54-5.48h1.36c.14.7.33,1.45.54,2.25.22.81.45,1.61.7,2.4.25.79.5,1.55.76,2.26.26.71.5,1.31.72,1.81.25-.65.5-1.36.76-2.1s.49-1.51.71-2.27c.22-.76.43-1.51.63-2.26.2-.74.37-1.44.53-2.1h1.1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-105",
    d: "M732.94,210.41c.12.66.27,1.36.46,2.1s.4,1.5.63,2.26c.23.77.47,1.53.73,2.27s.52,1.45.78,2.11c.22-.5.46-1.1.71-1.82.25-.71.5-1.47.75-2.26.25-.79.48-1.59.7-2.4.22-.81.4-1.56.54-2.26h1.26c-.47,2-.99,3.83-1.55,5.48-.56,1.65-1.18,3.22-1.85,4.7h-1.19c-.2-.46-.41-.98-.63-1.55-.22-.57-.44-1.18-.67-1.83s-.46-1.33-.67-2.05-.42-1.45-.62-2.19c-.2.75-.4,1.48-.62,2.2-.22.72-.44,1.4-.67,2.05-.23.65-.45,1.26-.67,1.83-.22.57-.42,1.08-.62,1.54h-1.23c-.67-1.48-1.29-3.05-1.85-4.71-.56-1.65-1.07-3.48-1.54-5.48h1.36c.14.7.33,1.45.54,2.25.22.81.45,1.61.7,2.4.25.79.5,1.55.76,2.26.26.71.5,1.31.72,1.81.25-.65.5-1.36.76-2.1s.49-1.51.71-2.27c.22-.76.43-1.51.63-2.26.2-.74.37-1.44.53-2.1h1.1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-105",
    d: "M748.54,210.41c.12.66.27,1.36.46,2.1s.4,1.5.63,2.26c.23.77.47,1.53.73,2.27s.52,1.45.78,2.11c.22-.5.46-1.1.71-1.82.25-.71.5-1.47.75-2.26.25-.79.48-1.59.7-2.4.22-.81.4-1.56.54-2.26h1.26c-.47,2-.99,3.83-1.55,5.48-.56,1.65-1.18,3.22-1.85,4.7h-1.19c-.2-.46-.41-.98-.63-1.55-.22-.57-.44-1.18-.67-1.83s-.46-1.33-.67-2.05-.42-1.45-.62-2.19c-.2.75-.4,1.48-.62,2.2-.22.72-.44,1.4-.67,2.05-.23.65-.45,1.26-.67,1.83-.22.57-.42,1.08-.62,1.54h-1.23c-.67-1.48-1.29-3.05-1.85-4.71-.56-1.65-1.07-3.48-1.54-5.48h1.36c.14.7.33,1.45.54,2.25.22.81.45,1.61.7,2.4.25.79.5,1.55.76,2.26.26.71.5,1.31.72,1.81.25-.65.5-1.36.76-2.1s.49-1.51.71-2.27c.22-.76.43-1.51.63-2.26.2-.74.37-1.44.53-2.1h1.1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-105",
    d: "M758.63,219.74c0,.3-.1.56-.29.77-.19.21-.46.31-.8.31s-.61-.11-.8-.31c-.19-.21-.29-.47-.29-.77s.1-.56.29-.77c.19-.21.46-.31.8-.31s.61.1.8.31c.19.21.29.47.29.77Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-105",
    d: "M761.66,210.76c.38-.1.88-.22,1.49-.35.61-.13,1.4-.2,2.37-.2,1.29,0,2.22.37,2.8,1.12.07-.05.19-.14.38-.27.19-.12.43-.25.72-.38.29-.13.63-.24,1.01-.33.39-.09.82-.14,1.29-.14.77,0,1.4.12,1.88.34.48.23.85.55,1.11.97.26.41.44.91.53,1.49.09.58.14,1.21.14,1.89v5.69h-1.28v-5.28c0-.67-.03-1.25-.09-1.74-.06-.49-.18-.9-.35-1.22-.18-.32-.43-.56-.76-.73-.33-.16-.75-.25-1.28-.25-.39,0-.75.04-1.07.11-.32.07-.6.16-.84.27-.24.11-.43.21-.58.32-.15.1-.26.18-.33.24.12.34.21.73.27,1.15.06.43.09.88.09,1.35v5.79h-1.28v-5.28c0-.67-.03-1.25-.09-1.74-.06-.49-.18-.9-.36-1.22s-.44-.56-.78-.73c-.33-.16-.78-.25-1.33-.25-.62,0-1.14.03-1.57.1s-.7.12-.82.18v8.94h-1.28v-9.83Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-105",
    d: "M781.43,220.81c-.43-.8-.84-1.64-1.24-2.5-.4-.87-.78-1.74-1.13-2.63s-.67-1.77-.96-2.66c-.29-.89-.54-1.76-.75-2.61h1.36c.14.63.33,1.31.55,2.04.22.73.48,1.48.76,2.26.28.77.59,1.57.93,2.38.34.81.71,1.62,1.12,2.4.29-.81.55-1.58.78-2.3.23-.72.43-1.44.63-2.15s.38-1.45.56-2.19c.18-.75.36-1.56.55-2.43h1.28c-.43,1.91-.91,3.76-1.44,5.56s-1.12,3.45-1.75,4.94c-.25.59-.51,1.1-.77,1.53-.26.43-.56.78-.88,1.05-.32.28-.7.48-1.13.61s-.93.2-1.51.2c-.33,0-.63-.04-.9-.12-.27-.08-.44-.14-.5-.18l.26-1.06c.05.04.2.1.44.17.24.07.5.11.76.11.37,0,.7-.04,1-.12.3-.08.56-.21.8-.4.24-.19.45-.44.64-.74.19-.3.37-.68.55-1.14Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-105",
    d: "M789.27,211.02c.22-.17.58-.35,1.07-.54.49-.19,1.07-.29,1.74-.29.73,0,1.39.13,1.96.39.57.26,1.05.63,1.45,1.1.39.47.69,1.03.9,1.68.2.65.3,1.36.3,2.14,0,.83-.12,1.57-.36,2.23-.24.66-.58,1.21-1.02,1.67-.44.46-.96.81-1.58,1.05-.61.24-1.29.36-2.04.36-.91,0-1.65-.06-2.25-.18s-1.08-.24-1.46-.37v-14.73l1.28-.24v5.71ZM789.27,219.39c.2.07.49.13.88.19.39.06.9.09,1.53.09,1.1,0,1.99-.36,2.66-1.07s1-1.74,1-3.08c0-.56-.06-1.1-.18-1.61-.12-.51-.31-.95-.57-1.32-.26-.37-.61-.67-1.03-.9-.43-.22-.96-.33-1.58-.33-.3,0-.59.03-.87.09-.28.06-.53.13-.77.23-.24.09-.44.19-.62.3-.18.11-.32.2-.44.3v7.13Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-105",
    d: "M802.57,210.17c.67,0,1.24.1,1.7.29.47.19.84.45,1.13.79s.5.73.63,1.19c.13.46.2.96.2,1.5v6.42c-.13.04-.32.08-.57.13-.25.05-.54.1-.87.15s-.69.09-1.09.13c-.4.03-.81.05-1.23.05-.54,0-1.03-.06-1.49-.18-.45-.12-.85-.31-1.18-.56s-.6-.58-.79-.98c-.19-.4-.29-.89-.29-1.47s.11-1.02.32-1.42c.21-.39.5-.72.89-.98s.83-.44,1.36-.56,1.1-.18,1.71-.18c.18,0,.38.01.58.03.2.02.4.05.59.08.19.03.35.07.49.1s.23.06.29.09v-.63c0-.35-.03-.7-.08-1.03-.05-.33-.17-.64-.34-.91-.18-.27-.43-.49-.75-.65-.32-.16-.75-.25-1.27-.25-.75,0-1.31.05-1.67.16s-.64.19-.81.26l-.18-1.12c.22-.1.57-.2,1.03-.3.47-.09,1.03-.14,1.68-.14ZM802.69,219.67c.5,0,.94-.02,1.31-.05.37-.03.69-.08.96-.13v-3.58c-.14-.07-.37-.13-.69-.21-.32-.07-.75-.11-1.3-.11-.31,0-.64.02-.98.07-.34.05-.66.15-.95.3-.29.15-.53.36-.71.62-.18.26-.28.61-.28,1.04,0,.38.06.7.19.97s.3.47.53.63c.23.16.5.27.83.34.32.07.69.11,1.09.11Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-105",
    d: "M809.5,210.76c.38-.1.89-.22,1.54-.35.64-.13,1.43-.2,2.36-.2.77,0,1.42.11,1.94.33.52.22.93.54,1.24.96s.53.91.66,1.49c.13.58.2,1.21.2,1.91v5.69h-1.28v-5.28c0-.72-.05-1.33-.15-1.83s-.26-.91-.49-1.22c-.23-.31-.53-.54-.91-.68-.37-.14-.84-.21-1.41-.21-.6,0-1.13.03-1.57.1-.44.07-.73.12-.86.18v8.94h-1.28v-9.83Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-105",
    d: "M823.27,215.05c.46.33.93.7,1.41,1.13s.94.89,1.4,1.39c.46.5.89,1.01,1.3,1.54.41.53.75,1.02,1.04,1.48h-1.54c-.31-.52-.67-1.02-1.07-1.52-.41-.5-.83-.97-1.28-1.41s-.89-.84-1.34-1.2-.84-.63-1.19-.82v4.95h-1.28v-15.05l1.28-.24v9.49c.27-.23.62-.55,1.02-.96.41-.4.83-.81,1.25-1.22.42-.41.83-.81,1.2-1.19.38-.38.69-.72.95-1.01h1.56c-.3.32-.65.67-1.04,1.05-.39.38-.8.79-1.22,1.2s-.84.83-1.25,1.23c-.41.4-.81.79-1.2,1.15Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-105",
    d: "M832.27,219.74c0,.3-.1.56-.29.77-.19.21-.46.31-.8.31s-.61-.11-.8-.31c-.19-.21-.29-.47-.29-.77s.1-.56.29-.77c.19-.21.46-.31.8-.31s.61.1.8.31c.19.21.29.47.29.77Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-105",
    d: "M836.5,210.41h4.06v1.08h-4.06v5.42c0,.58.05,1.05.15,1.41.1.36.24.64.42.84.18.2.41.33.67.39.26.07.55.1.87.1.54,0,.97-.06,1.3-.19.33-.12.58-.24.77-.34l.31,1.06c-.18.12-.5.25-.96.4s-.96.23-1.5.23c-.63,0-1.16-.08-1.58-.25-.43-.16-.77-.41-1.02-.75-.26-.33-.44-.75-.54-1.25-.11-.5-.16-1.09-.16-1.77v-9.38l1.28-.24v3.23Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-105",
    d: "M842.92,220.59v-15.05l1.28-.24v5.4c.42-.16.85-.28,1.28-.36.43-.08.87-.13,1.3-.13.79,0,1.44.11,1.97.33.53.22.95.54,1.26.96.32.41.54.91.66,1.49s.19,1.21.19,1.91v5.69h-1.28v-5.28c0-.72-.05-1.33-.15-1.83s-.26-.91-.49-1.22c-.23-.31-.54-.54-.92-.68-.38-.14-.86-.21-1.44-.21-.22,0-.46.02-.72.06s-.5.08-.72.13c-.22.05-.42.1-.6.15-.18.05-.29.09-.34.12v8.76h-1.28Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-105",
    d: "M854.13,210.76c.38-.1.88-.22,1.49-.35.61-.13,1.4-.2,2.37-.2,1.29,0,2.22.37,2.8,1.12.07-.05.19-.14.38-.27.19-.12.43-.25.72-.38.29-.13.63-.24,1.01-.33.39-.09.82-.14,1.29-.14.77,0,1.4.12,1.88.34.48.23.85.55,1.11.97.26.41.44.91.53,1.49.09.58.14,1.21.14,1.89v5.69h-1.28v-5.28c0-.67-.03-1.25-.09-1.74-.06-.49-.18-.9-.35-1.22-.18-.32-.43-.56-.76-.73-.33-.16-.75-.25-1.28-.25-.39,0-.75.04-1.07.11-.32.07-.6.16-.84.27-.24.11-.43.21-.58.32-.15.1-.26.18-.33.24.12.34.21.73.27,1.15.06.43.09.88.09,1.35v5.79h-1.28v-5.28c0-.67-.03-1.25-.09-1.74-.06-.49-.18-.9-.36-1.22s-.44-.56-.78-.73c-.33-.16-.78-.25-1.33-.25-.62,0-1.14.03-1.57.1s-.7.12-.82.18v8.94h-1.28v-9.83Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-105",
    d: "M530.52,159.89c-.13-.33-.32-.76-.56-1.3-.24-.54-.52-1.13-.82-1.76-.3-.64-.61-1.29-.93-1.97-.32-.68-.62-1.31-.91-1.9-.29-.59-.55-1.11-.77-1.56-.22-.45-.39-.76-.5-.95-.17,1.64-.3,3.42-.4,5.35-.1,1.92-.19,3.94-.27,6.06h-1.32c.12-2.48.25-4.86.4-7.13.15-2.27.34-4.44.56-6.52h1.18c.39.66.82,1.42,1.26,2.27.45.86.89,1.75,1.33,2.68s.87,1.84,1.28,2.74c.41.9.78,1.71,1.09,2.43.32-.72.68-1.53,1.1-2.43.41-.9.84-1.81,1.28-2.74.44-.93.88-1.82,1.33-2.68.45-.86.87-1.62,1.26-2.27h1.12c.22,2.07.41,4.25.56,6.52.15,2.27.29,4.65.4,7.13h-1.36c-.08-2.11-.17-4.13-.27-6.06-.1-1.92-.23-3.71-.4-5.35-.1.18-.27.5-.49.95s-.48.96-.77,1.56c-.29.59-.59,1.22-.91,1.9s-.62,1.33-.93,1.97-.57,1.22-.82,1.76c-.24.54-.43.97-.56,1.3h-1.2Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-105",
    d: "M544.11,162.08c-.43-.8-.84-1.64-1.24-2.5-.4-.87-.78-1.74-1.13-2.63s-.67-1.77-.96-2.66c-.29-.89-.54-1.76-.75-2.61h1.36c.14.63.33,1.31.55,2.04.22.73.48,1.48.76,2.26.28.77.59,1.57.93,2.38.34.81.71,1.62,1.12,2.4.29-.81.55-1.58.78-2.3.23-.72.43-1.44.63-2.15s.38-1.45.56-2.19c.18-.75.36-1.56.55-2.43h1.28c-.43,1.91-.91,3.76-1.44,5.56s-1.12,3.45-1.75,4.94c-.25.59-.51,1.1-.77,1.53-.26.43-.56.78-.88,1.05-.32.28-.7.48-1.13.61s-.93.2-1.51.2c-.33,0-.63-.04-.9-.12-.27-.08-.44-.14-.5-.18l.26-1.06c.05.04.2.1.44.17.24.07.5.11.76.11.37,0,.7-.04,1-.12.3-.08.56-.21.8-.4.24-.19.45-.44.64-.74.19-.3.37-.68.55-1.14Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-105",
    d: "M558.51,161.98c-.22,0-.48,0-.78-.03-.3-.02-.6-.05-.91-.08s-.6-.07-.88-.12c-.28-.05-.51-.1-.71-.15v-13.14c.24-.07.5-.12.79-.17s.59-.09.9-.12c.31-.03.61-.06.91-.07.3-.01.57-.02.82-.02.74,0,1.43.06,2.1.18.66.12,1.24.31,1.74.59s.9.64,1.19,1.09c.29.45.44,1.01.44,1.68,0,.73-.19,1.36-.56,1.88-.38.52-.88.88-1.51,1.07.39.09.75.22,1.08.39.33.17.62.39.87.66.25.27.44.6.58.99s.21.85.21,1.39c0,1.29-.51,2.27-1.54,2.95-1.02.68-2.61,1.02-4.75,1.02ZM556.58,154.16h2.6c.49,0,.95-.04,1.38-.11.43-.07.81-.2,1.13-.39.32-.19.58-.44.76-.77s.28-.73.28-1.23c0-.44-.1-.82-.29-1.13-.2-.31-.48-.56-.84-.75-.36-.2-.79-.34-1.29-.42-.5-.08-1.05-.13-1.66-.13-.49,0-.9.01-1.23.04-.33.03-.61.06-.84.1v4.79ZM556.58,155.31v5.4c.2.03.49.06.89.09.39.03.79.05,1.2.05.6,0,1.19-.04,1.76-.12s1.07-.22,1.51-.44c.43-.21.78-.5,1.04-.87.26-.37.39-.84.39-1.42,0-.53-.09-.97-.28-1.31-.18-.35-.45-.63-.79-.83-.34-.2-.76-.35-1.25-.42s-1.04-.12-1.64-.12h-2.84Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-105",
    d: "M570.66,151.45c.67,0,1.24.1,1.7.29.47.19.84.45,1.13.79s.5.73.63,1.19c.13.46.2.96.2,1.5v6.42c-.13.04-.32.08-.57.13-.25.05-.54.1-.87.15s-.69.09-1.09.13c-.4.03-.81.05-1.23.05-.54,0-1.03-.06-1.49-.18-.45-.12-.85-.31-1.18-.56s-.6-.58-.79-.98c-.19-.4-.29-.89-.29-1.47s.11-1.02.32-1.42c.21-.39.5-.72.89-.98s.83-.44,1.36-.56,1.1-.18,1.71-.18c.18,0,.38.01.58.03.2.02.4.05.59.08.19.03.35.07.49.1s.23.06.29.09v-.63c0-.35-.03-.7-.08-1.03-.05-.33-.17-.64-.34-.91-.18-.27-.43-.49-.75-.65-.32-.16-.75-.25-1.27-.25-.75,0-1.31.05-1.67.16s-.64.19-.81.26l-.18-1.12c.22-.1.57-.2,1.03-.3.47-.09,1.03-.14,1.68-.14ZM570.78,160.94c.5,0,.94-.02,1.31-.05.37-.03.69-.08.96-.13v-3.58c-.14-.07-.37-.13-.69-.21-.32-.07-.75-.11-1.3-.11-.31,0-.64.02-.98.07-.34.05-.66.15-.95.3-.29.15-.53.36-.71.62-.18.26-.28.61-.28,1.04,0,.38.06.7.19.97s.3.47.53.63c.23.16.5.27.83.34.32.07.69.11,1.09.11Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-105",
    d: "M577.59,152.04c.38-.1.89-.22,1.54-.35.64-.13,1.43-.2,2.36-.2.77,0,1.42.11,1.94.33.52.22.93.54,1.24.96s.53.91.66,1.49c.13.58.2,1.21.2,1.91v5.69h-1.28v-5.28c0-.72-.05-1.33-.15-1.83s-.26-.91-.49-1.22c-.23-.31-.53-.54-.91-.68-.37-.14-.84-.21-1.41-.21-.6,0-1.13.03-1.57.1-.44.07-.73.12-.86.18v8.94h-1.28v-9.83Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-105",
    d: "M591.36,156.32c.46.33.93.7,1.41,1.13s.94.89,1.4,1.39c.46.5.89,1.01,1.3,1.54.41.53.75,1.02,1.04,1.48h-1.54c-.31-.52-.67-1.02-1.07-1.52-.41-.5-.83-.97-1.28-1.41s-.89-.84-1.34-1.2-.84-.63-1.19-.82v4.95h-1.28v-15.05l1.28-.24v9.49c.27-.23.62-.55,1.02-.96.41-.4.83-.81,1.25-1.22.42-.41.83-.81,1.2-1.19.38-.38.69-.72.95-1.01h1.56c-.3.32-.65.67-1.04,1.05-.39.38-.8.79-1.22,1.2s-.84.83-1.25,1.23c-.41.4-.81.79-1.2,1.15Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-223",
    d: "M698.14,159.89c-.13-.33-.32-.76-.56-1.3-.24-.54-.52-1.13-.82-1.76-.3-.64-.61-1.29-.93-1.97-.32-.68-.62-1.31-.91-1.9-.29-.59-.55-1.11-.77-1.56-.22-.45-.39-.76-.5-.95-.17,1.64-.3,3.42-.4,5.35-.1,1.92-.19,3.94-.27,6.06h-1.32c.12-2.48.25-4.86.4-7.13.15-2.27.34-4.44.56-6.52h1.18c.39.66.82,1.42,1.26,2.27.45.86.89,1.75,1.33,2.68s.87,1.84,1.28,2.74c.41.9.78,1.71,1.09,2.43.32-.72.68-1.53,1.1-2.43.41-.9.84-1.81,1.28-2.74.44-.93.88-1.82,1.33-2.68.45-.86.87-1.62,1.26-2.27h1.12c.22,2.07.41,4.25.56,6.52.15,2.27.29,4.65.4,7.13h-1.36c-.08-2.11-.17-4.13-.27-6.06-.1-1.92-.23-3.71-.4-5.35-.1.18-.27.5-.49.95s-.48.96-.77,1.56c-.29.59-.59,1.22-.91,1.9s-.62,1.33-.93,1.97-.57,1.22-.82,1.76c-.24.54-.43.97-.56,1.3h-1.2Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-223",
    d: "M712.05,151.45c.67,0,1.24.1,1.7.29.47.19.84.45,1.13.79s.5.73.63,1.19c.13.46.2.96.2,1.5v6.42c-.13.04-.32.08-.57.13-.25.05-.54.1-.87.15s-.69.09-1.09.13c-.4.03-.81.05-1.23.05-.54,0-1.03-.06-1.49-.18-.45-.12-.85-.31-1.18-.56s-.6-.58-.79-.98c-.19-.4-.29-.89-.29-1.47s.11-1.02.32-1.42c.21-.39.5-.72.89-.98s.83-.44,1.36-.56,1.1-.18,1.71-.18c.18,0,.38.01.58.03.2.02.4.05.59.08.19.03.35.07.49.1s.23.06.29.09v-.63c0-.35-.03-.7-.08-1.03-.05-.33-.17-.64-.34-.91-.18-.27-.43-.49-.75-.65-.32-.16-.75-.25-1.27-.25-.75,0-1.31.05-1.67.16s-.64.19-.81.26l-.18-1.12c.22-.1.57-.2,1.03-.3.47-.09,1.03-.14,1.68-.14ZM712.17,160.94c.5,0,.94-.02,1.31-.05.37-.03.69-.08.96-.13v-3.58c-.14-.07-.37-.13-.69-.21-.32-.07-.75-.11-1.3-.11-.31,0-.64.02-.98.07-.34.05-.66.15-.95.3-.29.15-.53.36-.71.62-.18.26-.28.61-.28,1.04,0,.38.06.7.19.97s.3.47.53.63c.23.16.5.27.83.34.32.07.69.11,1.09.11Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-223",
    d: "M720.56,148.61c0,.3-.09.54-.28.72-.18.18-.41.27-.67.27s-.49-.09-.67-.27-.28-.42-.28-.72.09-.54.28-.72c.18-.18.41-.27.67-.27s.49.09.67.27c.18.18.28.42.28.72ZM720.26,161.86h-1.28v-10.18h1.28v10.18Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-223",
    d: "M726.23,162.04c-.43-.01-.81-.07-1.13-.17-.32-.1-.59-.25-.81-.45-.22-.2-.38-.47-.49-.79-.11-.32-.17-.73-.17-1.21v-12.61l1.28-.24v12.8c0,.32.03.57.09.76.06.19.15.34.27.45.12.11.27.19.46.25.19.05.42.1.68.14l-.18,1.06Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-451",
    points: "630.75 225.68 608.52 225.68 608.52 201.27 624.35 201.27 630.75 207.61 630.75 225.68"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "cls-451",
    points: "624.35 201.27 624.35 207.51 630.75 207.51"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-451",
    points: "504.41 167.32 482.19 167.32 482.19 142.91 498.02 142.91 504.41 149.25 504.41 167.32"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "cls-451",
    points: "498.02 142.91 498.02 149.16 504.41 149.16"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-70",
    x: 443.18,
    y: 366.28,
    width: 275.88,
    height: 99.42,
    rx: 15.55,
    ry: 15.55
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-70",
    x: 738.82,
    y: 488.95,
    width: 380.6,
    height: 91.99,
    rx: 18.64,
    ry: 18.64
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-370",
    d: "M553.02,399.93c.69-1.16,1.34-2.31,1.96-3.46.62-1.16,1.19-2.32,1.71-3.49h4.21c-.93,1.83-1.89,3.6-2.89,5.31-1,1.71-2.05,3.43-3.16,5.16v6.48h-3.82v-6.44c-1.11-1.73-2.17-3.46-3.17-5.19-1-1.73-1.97-3.51-2.9-5.33h4.43c.52,1.17,1.08,2.33,1.69,3.49.6,1.16,1.25,2.31,1.93,3.46Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-370",
    d: "M572.63,403.47c0,1.01-.15,1.94-.44,2.78-.29.84-.72,1.56-1.27,2.15s-1.22,1.06-1.99,1.38c-.77.33-1.64.49-2.61.49s-1.81-.16-2.58-.49c-.78-.33-1.44-.79-1.99-1.38-.56-.6-.99-1.31-1.3-2.15-.31-.84-.46-1.77-.46-2.78s.16-1.93.48-2.76.76-1.54,1.32-2.13,1.23-1.04,2.01-1.37c.77-.33,1.62-.49,2.53-.49s1.78.16,2.56.49,1.44.78,1.99,1.37.99,1.3,1.3,2.13.46,1.75.46,2.76ZM568.91,403.47c0-1.12-.22-2.01-.67-2.65-.45-.64-1.09-.97-1.92-.97s-1.48.32-1.93.97c-.46.64-.69,1.53-.69,2.65s.23,2.02.69,2.68c.46.66,1.1.99,1.93.99s1.47-.33,1.92-.99c.45-.66.67-1.55.67-2.68Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-370",
    d: "M586.43,409.49c-.62.18-1.42.35-2.4.5-.98.15-2.01.23-3.08.23s-2-.15-2.73-.44c-.73-.29-1.3-.71-1.73-1.24-.42-.53-.73-1.16-.91-1.9-.18-.73-.27-1.54-.27-2.42v-7.17h3.65v6.73c0,1.17.15,2.02.46,2.54.31.52.89.78,1.74.78.26,0,.54-.01.83-.04.29-.02.55-.05.78-.09v-9.93h3.65v12.43Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-370",
    d: "M595.72,409.93v-18.4l3.65-.59v6.17c.25-.08.56-.16.94-.23.38-.07.75-.11,1.11-.11,1.04,0,1.91.14,2.61.43.69.29,1.25.69,1.66,1.21s.71,1.14.88,1.86.26,1.52.26,2.4v7.27h-3.65v-6.83c0-1.17-.15-2.01-.45-2.5s-.86-.73-1.68-.73c-.33,0-.63.03-.92.09-.29.06-.54.12-.77.18v9.79h-3.65Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-370",
    d: "M614.76,396.72c1.08,0,1.97.12,2.69.37.72.24,1.29.6,1.72,1.05.43.46.74,1.01.92,1.66.18.65.27,1.38.27,2.18v7.58c-.52.11-1.25.25-2.18.4-.93.15-2.05.23-3.38.23-.83,0-1.59-.07-2.26-.22s-1.26-.39-1.75-.72c-.49-.33-.86-.77-1.12-1.31-.26-.54-.39-1.2-.39-1.98s.15-1.39.45-1.91c.3-.52.71-.94,1.21-1.25.5-.31,1.08-.53,1.74-.67.65-.14,1.33-.21,2.03-.21.47,0,.89.02,1.26.06.37.04.66.09.89.16v-.34c0-.62-.19-1.12-.56-1.49-.38-.38-1.03-.56-1.96-.56-.62,0-1.23.04-1.83.13s-1.12.22-1.57.38l-.46-2.94c.21-.06.48-.13.79-.21.32-.07.66-.14,1.04-.2.38-.06.77-.11,1.19-.15.42-.04.84-.06,1.26-.06ZM615.05,407.39c.36,0,.7,0,1.03-.02.33-.02.59-.04.78-.07v-2.76c-.15-.03-.37-.07-.66-.1-.29-.03-.56-.05-.81-.05-.34,0-.67.02-.97.06-.3.04-.57.12-.79.23s-.41.27-.54.46c-.13.2-.2.44-.2.73,0,.57.19.97.58,1.19.38.22.91.33,1.58.33Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-370",
    d: "M626.87,409.93c-.83-1.63-1.68-3.54-2.54-5.73-.86-2.19-1.67-4.57-2.44-7.14h3.87c.16.64.36,1.33.58,2.07.22.74.45,1.49.69,2.25.24.76.47,1.5.71,2.21.24.72.47,1.37.7,1.96.21-.59.44-1.24.69-1.96s.49-1.46.72-2.21.47-1.51.69-2.25.41-1.43.58-2.07h3.77c-.77,2.58-1.58,4.96-2.44,7.14-.86,2.19-1.71,4.09-2.54,5.73h-3.03Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-370",
    d: "M635.85,403.59c0-1.14.17-2.14.53-3s.81-1.57,1.38-2.14c.57-.57,1.23-1,1.97-1.3s1.5-.44,2.29-.44c1.83,0,3.27.56,4.33,1.68,1.06,1.12,1.59,2.76,1.59,4.93,0,.21,0,.44-.02.7-.02.25-.03.48-.05.67h-8.27c.08.75.43,1.35,1.05,1.79s1.45.66,2.5.66c.67,0,1.33-.06,1.97-.18.64-.12,1.17-.27,1.58-.45l.49,2.96c-.2.1-.46.2-.78.29-.33.1-.69.18-1.09.26-.4.07-.83.13-1.29.18s-.91.07-1.37.07c-1.16,0-2.17-.17-3.02-.51-.86-.34-1.57-.81-2.13-1.41-.56-.6-.98-1.3-1.25-2.12s-.4-1.7-.4-2.64ZM644.42,402.2c-.02-.31-.07-.61-.16-.91-.09-.29-.23-.55-.42-.78s-.42-.42-.71-.56c-.29-.15-.64-.22-1.06-.22s-.76.07-1.05.21c-.29.14-.54.32-.73.55-.2.23-.35.49-.45.79-.11.3-.18.61-.23.92h4.82Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-370",
    d: "M664.47,402.54c-.33,1.24-.67,2.47-1.04,3.7-.37,1.22-.75,2.46-1.16,3.69h-2.84c-.29-.69-.61-1.5-.96-2.45-.34-.95-.7-1.98-1.07-3.09-.37-1.12-.74-2.3-1.13-3.55s-.76-2.51-1.12-3.78h3.84c.13.59.27,1.23.43,1.92s.32,1.41.49,2.14c.17.73.35,1.47.54,2.21.19.74.38,1.46.58,2.14.21-.72.42-1.45.62-2.2s.4-1.49.59-2.21c.19-.73.37-1.43.54-2.1s.32-1.31.45-1.9h2.64c.13.59.28,1.22.44,1.9s.33,1.38.51,2.1c.18.73.37,1.46.56,2.21.2.75.4,1.48.61,2.2.2-.69.39-1.4.59-2.14.2-.74.38-1.48.55-2.21.17-.73.34-1.45.49-2.14.16-.69.3-1.33.43-1.92h3.79c-.36,1.27-.73,2.53-1.12,3.78-.38,1.25-.76,2.43-1.13,3.55s-.73,2.15-1.08,3.09c-.35.95-.67,1.76-.97,2.45h-2.84c-.41-1.24-.81-2.47-1.2-3.69-.39-1.22-.75-2.46-1.08-3.7Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-370",
    d: "M687.55,403.47c0,1.01-.15,1.94-.44,2.78-.29.84-.72,1.56-1.27,2.15s-1.22,1.06-1.99,1.38c-.77.33-1.64.49-2.61.49s-1.81-.16-2.58-.49c-.78-.33-1.44-.79-1.99-1.38-.56-.6-.99-1.31-1.3-2.15-.31-.84-.46-1.77-.46-2.78s.16-1.93.48-2.76.76-1.54,1.32-2.13,1.23-1.04,2.01-1.37c.77-.33,1.62-.49,2.53-.49s1.78.16,2.56.49,1.44.78,1.99,1.37.99,1.3,1.3,2.13.46,1.75.46,2.76ZM683.83,403.47c0-1.12-.22-2.01-.67-2.65-.45-.64-1.09-.97-1.92-.97s-1.48.32-1.93.97c-.46.64-.69,1.53-.69,2.65s.23,2.02.69,2.68c.46.66,1.1.99,1.93.99s1.47-.33,1.92-.99c.45-.66.67-1.55.67-2.68Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-370",
    d: "M690.37,397.5c.62-.18,1.42-.35,2.4-.5.98-.15,2.01-.23,3.08-.23s2,.14,2.73.43c.73.29,1.3.69,1.73,1.21.42.52.73,1.14.91,1.86.18.72.27,1.52.27,2.4v7.27h-3.65v-6.83c0-1.17-.16-2.01-.46-2.5-.31-.49-.89-.73-1.74-.73-.26,0-.54.01-.83.04s-.55.05-.78.08v9.93h-3.65v-12.43Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-370",
    d: "M595.45,429.65h4.06v2.96h-4.06c-.02.57-.05,1.18-.11,1.83-.06.65-.13,1.25-.21,1.79h6.39v3.06h-10.4c.29-1.3.49-2.51.59-3.62.1-1.11.16-2.13.2-3.06h-2.13v-2.96h2.13v-1.3c0-1.22.15-2.24.44-3.05s.7-1.46,1.21-1.95c.51-.49,1.13-.84,1.85-1.04s1.5-.31,2.35-.31c.65,0,1.26.07,1.84.2.57.13,1.12.31,1.66.54l-.91,2.86c-.38-.18-.73-.31-1.06-.39-.33-.08-.74-.13-1.21-.15-.39,0-.75.04-1.06.12-.32.08-.59.24-.82.46s-.41.54-.54.93c-.13.39-.2.88-.2,1.47v1.59Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-370",
    d: "M604.83,425.86c.47-.2.97-.42,1.48-.67.51-.25,1.02-.53,1.5-.83s.96-.62,1.41-.96c.45-.33.85-.69,1.21-1.06h2.54v16.96h-3.65v-12.21c-.49.33-1.04.62-1.64.89-.6.27-1.19.5-1.76.7l-1.1-2.81Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-370",
    d: "M630.08,430.78c0,2.85-.54,5.04-1.63,6.57-1.09,1.53-2.58,2.29-4.49,2.29s-3.41-.76-4.49-2.29-1.63-3.71-1.63-6.57c0-1.42.14-2.68.43-3.77s.7-2.01,1.24-2.76c.54-.75,1.18-1.32,1.93-1.71s1.59-.59,2.52-.59c1.91,0,3.4.76,4.49,2.29,1.08,1.53,1.63,3.71,1.63,6.55ZM626.36,430.78c0-.85-.04-1.62-.12-2.31-.08-.69-.21-1.29-.39-1.8-.18-.5-.42-.9-.73-1.17-.31-.28-.69-.42-1.15-.42s-.84.14-1.14.42c-.3.28-.55.67-.73,1.17-.19.51-.32,1.11-.4,1.8-.08.69-.12,1.46-.12,2.31s.04,1.62.12,2.32c.08.7.22,1.3.4,1.81s.43.9.73,1.17c.3.28.68.42,1.14.42s.84-.14,1.15-.42c.31-.28.55-.67.73-1.17s.31-1.11.39-1.81c.08-.7.12-1.48.12-2.32Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-370",
    d: "M643.98,430.78c0,2.85-.54,5.04-1.63,6.57-1.09,1.53-2.58,2.29-4.49,2.29s-3.41-.76-4.49-2.29-1.63-3.71-1.63-6.57c0-1.42.14-2.68.43-3.77s.7-2.01,1.24-2.76c.54-.75,1.18-1.32,1.93-1.71s1.59-.59,2.52-.59c1.91,0,3.4.76,4.49,2.29,1.08,1.53,1.63,3.71,1.63,6.55ZM640.26,430.78c0-.85-.04-1.62-.12-2.31-.08-.69-.21-1.29-.39-1.8-.18-.5-.42-.9-.73-1.17-.31-.28-.69-.42-1.15-.42s-.84.14-1.14.42c-.3.28-.55.67-.73,1.17-.19.51-.32,1.11-.4,1.8-.08.69-.12,1.46-.12,2.31s.04,1.62.12,2.32c.08.7.22,1.3.4,1.81s.43.9.73,1.17c.3.28.68.42,1.14.42s.84-.14,1.15-.42c.31-.28.55-.67.73-1.17s.31-1.11.39-1.81c.08-.7.12-1.48.12-2.32Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-370",
    d: "M657.87,430.78c0,2.85-.54,5.04-1.63,6.57-1.09,1.53-2.58,2.29-4.49,2.29s-3.41-.76-4.49-2.29-1.63-3.71-1.63-6.57c0-1.42.14-2.68.43-3.77s.7-2.01,1.24-2.76c.54-.75,1.18-1.32,1.93-1.71s1.59-.59,2.52-.59c1.91,0,3.4.76,4.49,2.29,1.08,1.53,1.63,3.71,1.63,6.55ZM654.15,430.78c0-.85-.04-1.62-.12-2.31-.08-.69-.21-1.29-.39-1.8-.18-.5-.42-.9-.73-1.17-.31-.28-.69-.42-1.15-.42s-.84.14-1.14.42c-.3.28-.55.67-.73,1.17-.19.51-.32,1.11-.4,1.8-.08.69-.12,1.46-.12,2.31s.04,1.62.12,2.32c.08.7.22,1.3.4,1.81s.43.9.73,1.17c.3.28.68.42,1.14.42s.84-.14,1.15-.42c.31-.28.55-.67.73-1.17s.31-1.11.39-1.81c.08-.7.12-1.48.12-2.32Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-450",
    d: "M522.76,436.01h-42.34c-3.81,0-6.93-3.12-6.93-6.93v-26.17c0-1.91.78-3.64,2.04-4.89s2.99-2.04,4.89-2.04h42.34c3.81,0,6.93,3.12,6.93,6.93v26.17c0,3.81-3.12,6.93-6.93,6.93Z"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "cls-450",
    points: "527.76 398.13 501.59 415.99 475.53 398.02"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-30",
    d: "M740.42,403.7v8.67h90.4c.24,0,.47.04.7.07h.43c1.96,0,3.54,1.59,3.54,3.54v79.39c0,1.96-1.59,3.54-3.54,3.54h-9.16c-1.96,0-3.54-1.59-3.54-3.54v-66.76h-78.83v8.67c0,1-1.08,1.62-1.94,1.12l-29.22-16.81c-.86-.49-.86-1.73,0-2.22l29.22-16.81c.86-.49,1.94.13,1.94,1.12Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-243",
    d: "M700.96,102.44h-8.67v-53.36c0-.24-.04-.47-.07-.7v-.43c0-1.96-1.59-3.54-3.54-3.54H96.96s-16.25,0-16.25,0v107.94h16.25V60.66h577.77c.72,0,1.31.59,1.31,1.31v40.48h-8.67c-1,0-1.62,1.08-1.12,1.94l16.81,29.22c.49.86,1.73.86,2.22,0l16.81-29.22c.49-.86-.13-1.94-1.12-1.94Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-268",
    d: "M984.89,44.41h0s-255.05,0-255.05,0h-7.95c-1.96,0-3.54,1.59-3.54,3.54v.43c-.03.23-.07.46-.07.7v53.36h-8.67c-1,0-1.62,1.08-1.12,1.94l16.81,29.22c.49.86,1.73.86,2.22,0l16.81-29.22c.49-.86-.13-1.94-1.12-1.94h-8.67v-40.57c0-.67.54-1.22,1.22-1.22h247.9c.69,0,1.25.56,1.25,1.25v261.04c0,.79-.64,1.43-1.43,1.43h-337.59c-1.59,0-2.89,1.29-2.89,2.89h0v43.86h16.25v-28.95c0-.85.69-1.55,1.55-1.55h336.58c2.09,0,3.78-1.69,3.78-3.78V47.36c0-1.63-1.32-2.95-2.95-2.95h-1.1s-12.2,0-12.2,0Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-70",
    x: 22.57,
    y: 350.89,
    width: 130.21,
    height: 130.21,
    rx: 12.01,
    ry: 12.01
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "Layer_9"
  }, /*#__PURE__*/React.createElement("g", {
    id: "arrow_styles_for_diagrams_etc"
  }, /*#__PURE__*/React.createElement("g", {
    id: "arrow_styles_for_diagrams_etc-2"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-412",
    d: "M456.29,199.57l-29.22,16.81c-.86.49-1.94-.13-1.94-1.12v-8.67H147.39c-2.59,0-4.69-2.1-4.69-4.69v-6.88c0-2.58,2.09-4.68,4.68-4.68h277.74v-8.67c0-1,1.08-1.62,1.94-1.12l29.22,16.81c.86.49.86,1.73,0,2.22Z"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "arrow_styles_for_diagrams_etc-3"
  }, /*#__PURE__*/React.createElement("g", {
    id: "arrow_styles_for_diagrams_etc-4"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-143",
    d: "M456.29,417.11l-29.22,16.81c-.86.49-1.94-.13-1.94-1.12v-8.67H147.39c-2.59,0-4.69-2.1-4.69-4.69v-6.88c0-2.58,2.09-4.68,4.68-4.68h277.74v-8.67c0-1,1.08-1.62,1.94-1.12l29.22,16.81c.86.49.86,1.73,0,2.22Z"
  }))))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    id: "Layer_7"
  }, /*#__PURE__*/React.createElement("circle", {
    className: "cls-272",
    cx: 821.4,
    cy: 148.09,
    r: 9.77
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-418",
    cx: 852.83,
    cy: 148.09,
    r: 9.77
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-322",
    cx: 884.25,
    cy: 148.09,
    r: 9.77
  }))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    id: "Layer_10"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-294",
    d: "M70.79,192.68c-8.55,4.73-15.72,2.08-24.22,11.11-8.51,9.03-9.31,23.13-9.31,23.13h94.11s-.8-16.75-6.64-24.46c-5.84-7.71-14-2.17-22.98-9.79-8.99-7.61-30.95,0-30.95,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-273",
    d: "M101.74,192.68c-.57-.49-1.2-.91-1.88-1.28l.78,6.56c3.91,2.68,15.05.69,18.81,3.96,3.76,3.28,3.76,13.47,3.76,13.47,0,0,5.65-4.28,4.71,4.6-.51,4.83-2.64,6.46-4.48,6.94h7.93s-.8-16.75-6.64-24.46c-5.84-7.71-14-2.17-22.98-9.79h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-224",
    d: "M45.41,209.29c2.19-4.79,20.07-4.94,29.63-10.51l-2.13-3.34-2.22-2.77c-8.5,4.66-15.66,2.06-24.13,11.07-1.57,1.68-2.88,3.51-3.97,5.41l-3.61,8.62h0s4.23-3.71,6.43-8.49h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-124",
    d: "M70.79,192.68c.99,11.63,9.31,16.08,9.31,16.08,0,0,.15-3.13,4.22-3.27s5.35,4.85,5.35,4.85l-1.87-12.85-17-4.82Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-124",
    d: "M90.55,208.12s.99-5.17,4.65-4.58c3.66.58,4.25,1.68,4.25,1.68l1.19-7.25-9.59-.56-.5,10.71Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-262",
    d: "M78.49,184.98c-3.9,1.24-5.15,5.16-7.11,5.79s.72,5.25,2.41,8.28,5.79,8.2,5.79,8.2c0,0,3.8-9.75,8.18-3.62l4.73-1.71s5.67-5.07,6.31,5.79c0,0,2.69-3.74,3.31-7.39.62-3.65.92-7.27-.62-8.87-4.14-4.3-22.99-6.44-22.99-6.44v-.02Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-333",
    d: "M80.23,168.79c.07,5.5-1.79,20.05-5.19,22.62,0,0,7.18,5.98,10.32,8.37,3.14,2.39,4.78,13.22,4.78,13.22,0,0,2.4-9.69,2.33-12.47s2.96-.12,5.47-4.03c2.52-3.91-2.36-11.54-2.36-11.54l-15.37-16.19h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-70",
    d: "M59.1,214c.55,6.12,2.96,8.1,3.28,12.93,0,0,1.31-4.73,0-7.9-1.31-3.16-3.28-5.03-3.28-5.03h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-70",
    d: "M107.66,226.93c-.66-12.35,3.5-13.87,3.5-13.87,0,0-2.08,3.68-2.3,7.12-.22,3.44-1.2,6.75-1.2,6.75Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-399",
    d: "M110.92,151.75c2.69-2.54,1.62-8.91-6.9-13.56-8.52-4.65-24.53-3.7-28.98,4.82-4.45,8.52-5.63,9.46-4.25,18.29,1.37,8.83,8.76,15.95,8.76,15.95l.97-7.99s30.4-17.51,30.4-17.51Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-436",
    d: "M110.92,151.75s.03-.16.05-.43h0c.1-1.22.17-4.63-2.36-4.79-3.09-.2-6.57,4.64-11.14,3.48-4.57-1.16-13.78-4.64-16.1-2.32-2.32,2.32,3.22,2.96,3.28,6.82.07,3.87-1.42,5.28-1.09,7.86.32,2.58-.2,4.38-1.42,4.06s-.58-5.8-2.51-7.79-5.73-.13-3.99,3.67c1.74,3.8,1.74,3.99,1.93,5.53.2,1.54,1.36,2.9,2.96,1.42h0l.44,5.91c.4,4.07,1.68,5.51,5.17,7.91,4.42,3.05,7.81,6.22,11.44,6.2,4.26-.02,6.58-.51,7.74-1.6,2.61-2.46,7.35-11.48,5.95-17.59-.33-3.37.05-6.31.48-9.66.46-3.54-.33-5.67-.73-8.74-.07.03-.09.05-.09.05h0Z"
  }), /*#__PURE__*/React.createElement("text", {
    className: "cls-447",
    transform: "translate(42.6 245.47)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "Victim User")), /*#__PURE__*/React.createElement("text", {
    className: "cls-447",
    transform: "translate(53.6 472.87)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "At"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-455",
    x: 18.95,
    y: 0
  }, "t"), /*#__PURE__*/React.createElement("tspan", {
    x: 25.84,
    y: 0
  }, "ac"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-446",
    x: 42.97,
    y: 0
  }, "k"), /*#__PURE__*/React.createElement("tspan", {
    x: 51.8,
    y: 0
  }, "er")), /*#__PURE__*/React.createElement("g", {
    className: "cls-456"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-231",
    points: "41.6 443.86 132.44 445.03 132.44 451.85 41.6 451.85 41.6 443.86"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-231",
    points: "41.6 443.14 132.44 444.31 132.44 445.03 41.6 443.86 41.6 443.14"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-233",
    points: "41.6 442.42 132.44 443.59 132.44 444.31 41.6 443.14 41.6 442.42"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-236",
    points: "41.6 441.7 132.44 442.88 132.44 443.59 41.6 442.42 41.6 441.7"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-114",
    points: "41.6 440.99 132.44 442.16 132.44 442.88 41.6 441.7 41.6 440.99"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-133",
    points: "41.6 440.27 132.44 441.44 132.44 442.16 41.6 440.99 41.6 440.27"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-42",
    points: "41.6 439.55 132.44 440.73 132.44 441.44 41.6 440.27 41.6 439.55"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-109",
    points: "41.6 438.84 132.44 440.01 132.44 440.73 41.6 439.55 41.6 438.84"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-422",
    points: "41.6 438.12 132.44 439.29 132.44 440.01 41.6 438.84 41.6 438.12"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-94",
    points: "41.6 437.4 132.44 438.57 132.44 439.29 41.6 438.12 41.6 437.4"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-248",
    points: "41.6 436.68 132.44 437.86 132.44 438.57 41.6 437.4 41.6 436.68"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-275",
    points: "41.6 435.97 132.44 437.14 132.44 437.86 41.6 436.68 41.6 435.97"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-276",
    points: "41.6 435.25 132.44 436.42 132.44 437.14 41.6 435.97 41.6 435.25"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-328",
    points: "41.6 434.53 132.44 435.71 132.44 436.42 41.6 435.25 41.6 434.53"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-304",
    points: "41.6 433.82 132.44 434.99 132.44 435.71 41.6 434.53 41.6 433.82"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-234",
    points: "41.6 433.1 132.44 434.27 132.44 434.99 41.6 433.82 41.6 433.1"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-198",
    points: "41.6 432.38 132.44 433.55 132.44 434.27 41.6 433.1 41.6 432.38"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-182",
    points: "41.6 431.66 132.44 432.84 132.44 433.55 41.6 432.38 41.6 431.66"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-134",
    points: "41.6 430.95 132.44 432.12 132.44 432.84 41.6 431.66 41.6 430.95"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-387",
    points: "41.6 430.23 132.44 431.4 132.44 432.12 41.6 430.95 41.6 430.23"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-220",
    points: "41.6 429.51 132.44 430.68 132.44 431.4 41.6 430.23 41.6 429.51"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-253",
    points: "41.6 428.79 132.44 429.97 132.44 430.68 41.6 429.51 41.6 428.79"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-359",
    points: "41.6 428.08 132.44 429.25 132.44 429.97 41.6 428.79 41.6 428.08"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-361",
    points: "41.6 427.36 132.44 428.53 132.44 429.25 41.6 428.08 41.6 427.36"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-263",
    points: "41.6 426.64 132.44 427.82 132.44 428.53 41.6 427.36 41.6 426.64"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-374",
    points: "41.6 425.93 132.44 427.1 132.44 427.82 41.6 426.64 41.6 425.93"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-189",
    points: "41.6 425.21 132.44 426.38 132.44 427.1 41.6 425.93 41.6 425.21"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-290",
    points: "41.6 424.49 132.44 425.66 132.44 426.38 41.6 425.21 41.6 424.49"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-209",
    points: "41.6 423.77 132.44 424.95 132.44 425.66 41.6 424.49 41.6 423.77"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-323",
    points: "41.6 423.06 132.44 424.23 132.44 424.95 41.6 423.77 41.6 423.06"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-219",
    points: "41.6 422.34 132.44 423.51 132.44 424.23 41.6 423.06 41.6 422.34"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-227",
    points: "41.6 421.62 132.44 422.79 132.44 423.51 41.6 422.34 41.6 421.62"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-338",
    points: "41.6 420.9 132.44 422.08 132.44 422.79 41.6 421.62 41.6 420.9"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-62",
    points: "41.6 420.19 132.44 421.36 132.44 422.08 41.6 420.9 41.6 420.19"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-92",
    points: "41.6 419.47 132.44 420.64 132.44 421.36 41.6 420.19 41.6 419.47"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-331",
    points: "41.6 418.75 132.44 419.93 132.44 420.64 41.6 419.47 41.6 418.75"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-187",
    points: "41.6 418.04 132.44 419.21 132.44 419.93 41.6 418.75 41.6 418.04"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-211",
    points: "41.6 417.32 132.44 418.49 132.44 419.21 41.6 418.04 41.6 417.32"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-17",
    points: "41.6 416.6 132.44 417.77 132.44 418.49 41.6 417.32 41.6 416.6"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-433",
    points: "41.6 415.88 132.44 417.06 132.44 417.77 41.6 416.6 41.6 415.88"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-212",
    points: "41.6 415.17 132.44 416.34 132.44 417.06 41.6 415.88 41.6 415.17"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-157",
    points: "41.6 414.45 132.44 415.62 132.44 416.34 41.6 415.17 41.6 414.45"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-420",
    points: "41.6 413.73 132.44 414.91 132.44 415.62 41.6 414.45 41.6 413.73"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-137",
    points: "41.6 413.02 132.44 414.19 132.44 414.91 41.6 413.73 41.6 413.02"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-208",
    points: "41.6 412.3 132.44 413.47 132.44 414.19 41.6 413.02 41.6 412.3"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-378",
    points: "41.6 411.58 132.44 412.75 132.44 413.47 41.6 412.3 41.6 411.58"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-86",
    points: "41.6 410.86 132.44 412.04 132.44 412.75 41.6 411.58 41.6 410.86"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-138",
    points: "41.6 410.15 132.44 411.32 132.44 412.04 41.6 410.86 41.6 410.15"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-49",
    points: "41.6 409.43 132.44 410.6 132.44 411.32 41.6 410.15 41.6 409.43"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-373",
    points: "41.6 408.71 132.44 409.88 132.44 410.6 41.6 409.43 41.6 408.71"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-385",
    points: "41.6 407.99 132.44 409.17 132.44 409.88 41.6 408.71 41.6 407.99"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-179",
    points: "41.6 407.28 132.44 408.45 132.44 409.17 41.6 407.99 41.6 407.28"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-394",
    points: "41.6 406.56 132.44 407.73 132.44 408.45 41.6 407.28 41.6 406.56"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-311",
    points: "41.6 405.84 132.44 407.02 132.44 407.73 41.6 406.56 41.6 405.84"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-185",
    points: "41.6 405.13 132.44 406.3 132.44 407.02 41.6 405.84 41.6 405.13"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-355",
    points: "41.6 404.41 132.44 405.58 132.44 406.3 41.6 405.13 41.6 404.41"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-327",
    points: "41.6 403.69 132.44 404.86 132.44 405.58 41.6 404.41 41.6 403.69"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-73",
    points: "41.6 402.98 41.6 402.97 132.44 404.15 132.44 404.86 41.6 403.69 41.6 402.98"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-202",
    points: "41.6 402.97 41.6 402.26 132.44 403.43 132.44 404.15 41.6 402.97"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-183",
    points: "41.6 402.26 41.61 401.54 132.44 402.71 132.44 403.43 41.6 402.26"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-213",
    points: "41.61 401.54 41.62 400.82 132.44 402 132.44 402.71 41.61 401.54"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-160",
    points: "41.62 400.82 41.63 400.11 132.44 401.28 132.44 402 41.62 400.82"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-443",
    points: "41.63 400.11 41.64 399.39 132.44 400.56 132.44 401.28 41.63 400.11"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-38",
    points: "41.64 399.39 41.65 398.67 132.44 399.84 132.44 400.56 41.64 399.39"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-38",
    points: "41.65 398.67 41.66 397.95 132.44 399.13 132.44 399.84 41.65 398.67"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-194",
    points: "41.66 397.95 41.67 397.24 132.44 398.41 132.44 399.13 41.66 397.95"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-300",
    points: "41.67 397.24 41.68 396.52 132.44 397.69 132.44 398.41 41.67 397.24"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-384",
    points: "41.68 396.52 41.69 395.8 132.44 396.97 132.44 397.69 41.68 396.52"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-371",
    points: "41.69 395.8 41.7 395.09 132.44 396.26 132.44 396.97 41.69 395.8"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-371",
    points: "41.7 395.09 41.71 394.37 132.44 395.54 132.44 396.26 41.7 395.09"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-381",
    points: "41.71 394.37 41.72 393.65 132.44 394.82 132.44 395.54 41.71 394.37"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-167",
    points: "41.72 393.65 41.72 392.93 132.44 394.11 132.44 394.82 41.72 393.65"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-167",
    points: "41.72 392.93 41.73 392.22 132.44 393.39 132.44 394.11 41.72 392.93"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-163",
    points: "41.73 392.22 41.74 391.5 132.44 392.67 132.44 393.39 41.73 392.22"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-349",
    points: "41.74 391.5 41.75 390.78 132.44 391.95 132.44 392.67 41.74 391.5"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-349",
    points: "41.75 390.78 41.76 390.07 132.44 391.24 132.44 391.95 41.75 390.78"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-23",
    points: "41.76 390.07 41.77 389.35 132.44 390.52 132.44 391.24 41.76 390.07"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-129",
    points: "41.77 389.35 41.78 388.63 132.44 389.8 132.44 390.52 41.77 389.35"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-129",
    points: "41.78 388.63 41.79 387.91 132.44 389.08 132.44 389.8 41.78 388.63"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-7",
    points: "41.79 387.91 41.8 387.2 132.44 388.37 132.44 389.08 41.79 387.91"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-7",
    points: "41.8 387.2 41.81 386.48 132.44 387.65 132.44 388.37 41.8 387.2"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-278",
    points: "41.81 386.48 41.82 385.76 132.44 386.93 132.44 387.65 41.81 386.48"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-278",
    points: "41.82 385.76 41.83 385.05 132.44 386.22 132.44 386.93 41.82 385.76"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-245",
    points: "41.83 385.05 41.84 384.33 132.44 385.5 132.44 386.22 41.83 385.05"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-245",
    points: "41.84 384.33 41.85 383.61 132.44 384.78 132.44 385.5 41.84 384.33"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-226",
    points: "41.85 383.61 41.85 382.89 132.44 384.06 132.44 384.78 41.85 383.61"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-226",
    points: "41.85 382.89 41.86 382.18 132.44 383.35 132.44 384.06 41.85 382.89"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-226",
    points: "41.86 382.18 41.87 381.46 132.44 382.63 132.44 383.35 41.86 382.18"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-444",
    points: "41.87 381.46 41.88 380.74 132.44 381.91 132.44 382.63 41.87 381.46"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-444",
    points: "41.88 380.74 41.89 380.03 132.44 381.2 132.44 381.91 41.88 380.74"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-444",
    points: "41.89 380.03 41.9 379.31 132.44 380.48 132.44 381.2 41.89 380.03"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-250",
    points: "41.9 379.31 41.91 378.59 132.44 379.76 132.44 380.48 41.9 379.31"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-250",
    points: "41.91 378.59 41.92 377.88 132.44 379.04 132.44 379.76 41.91 378.59"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-425",
    points: "41.92 377.88 41.93 377.16 132.44 378.33 132.44 379.04 41.92 377.88"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-32",
    points: "41.93 377.16 41.94 376.44 132.44 377.61 132.44 378.33 41.93 377.16"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-32",
    points: "41.94 376.44 41.95 375.72 132.44 376.89 132.44 377.61 41.94 376.44"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-32",
    points: "41.95 375.72 41.96 375.01 132.44 376.17 132.44 376.89 41.95 375.72"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-32",
    points: "41.96 375.01 41.97 374.29 132.44 375.46 132.44 376.17 41.96 375.01"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-63",
    points: "41.97 374.29 41.97 373.57 132.44 374.74 132.44 375.46 41.97 374.29"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-63",
    points: "41.97 373.57 41.98 372.86 132.44 374.02 132.44 374.74 41.97 373.57"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-63",
    points: "41.98 372.86 41.99 372.14 132.44 373.31 132.44 374.02 41.98 372.86"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-63",
    points: "41.99 372.14 42 371.42 132.44 372.59 132.44 373.31 41.99 372.14"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-63",
    points: "42 371.42 42.01 370.7 132.44 371.87 132.44 372.59 42 371.42"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-63",
    points: "42.01 370.7 42.02 369.99 132.44 371.15 132.44 371.87 42.01 370.7"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-322",
    points: "42.02 369.99 42.03 369.27 132.44 370.44 132.44 371.15 42.02 369.99"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-322",
    points: "42.03 369.27 42.04 368.55 132.44 369.72 132.44 370.44 42.03 369.27"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-322",
    points: "42.04 368.55 42.05 367.84 132.44 369 132.44 369.72 42.04 368.55"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-322",
    points: "42.05 367.84 42.06 367.12 132.44 368.29 132.44 369 42.05 367.84"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-322",
    points: "42.06 367.12 42.07 366.4 132.44 367.57 132.44 368.29 42.06 367.12"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-322",
    points: "42.07 366.4 42.08 365.68 132.44 366.85 132.44 367.57 42.07 366.4"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-322",
    points: "42.08 365.68 42.09 364.97 132.44 366.13 132.44 366.85 42.08 365.68"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-322",
    points: "42.09 364.97 42.1 364.25 132.44 365.42 132.44 366.13 42.09 364.97"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-322",
    points: "42.1 364.25 42.1 363.53 132.44 364.7 132.44 365.42 42.1 364.25"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-322",
    points: "42.1 363.53 42.11 362.82 132.44 363.98 132.44 364.7 42.1 363.53"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-322",
    points: "42.11 362.82 42.18 357.61 132.44 357.61 132.44 363.98 42.11 362.82"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-453"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-119",
    points: "98.87 376.73 68.99 377.64 68.99 376.73 98.87 376.73"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-119",
    points: "108.3 376.8 68.99 378 68.99 377.64 98.87 376.73 108.3 376.73 108.3 376.8"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-119",
    points: "108.3 377.16 68.99 378.36 68.99 378 108.3 376.8 108.3 377.16"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-119",
    points: "108.3 377.52 68.99 378.72 68.99 378.36 108.3 377.16 108.3 377.52"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-119",
    points: "108.3 377.88 68.99 379.08 68.99 378.72 108.3 377.52 108.3 377.88"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-310",
    points: "108.3 378.24 68.99 379.44 68.99 379.08 108.3 377.88 108.3 378.24"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-310",
    points: "108.3 378.6 68.99 379.8 68.99 379.44 108.3 378.24 108.3 378.6"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-310",
    points: "108.3 378.96 68.99 380.16 68.99 379.8 108.3 378.6 108.3 378.96"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-310",
    points: "108.3 379.32 68.99 380.52 68.99 380.16 108.3 378.96 108.3 379.32"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-284",
    points: "108.3 379.68 68.99 380.88 68.99 380.52 108.3 379.32 108.3 379.68"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-284",
    points: "108.3 380.04 68.99 381.24 68.99 380.88 108.3 379.68 108.3 380.04"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-284",
    points: "108.3 380.4 68.99 381.6 68.99 381.24 108.3 380.04 108.3 380.4"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-199",
    points: "108.3 380.76 68.99 381.96 68.99 381.6 108.3 380.4 108.3 380.76"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-199",
    points: "108.3 381.12 68.99 382.32 68.99 381.96 108.3 380.76 108.3 381.12"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-360",
    points: "108.3 381.48 68.99 382.68 68.99 382.32 108.3 381.12 108.3 381.48"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-360",
    points: "108.3 381.84 68.99 383.04 68.99 382.68 108.3 381.48 108.3 381.84"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-240",
    points: "108.3 382.2 68.99 383.4 68.99 383.04 108.3 381.84 108.3 382.2"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-240",
    points: "108.3 382.56 68.99 383.76 68.99 383.4 108.3 382.2 108.3 382.56"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-261",
    points: "108.3 382.92 68.99 384.12 68.99 383.76 108.3 382.56 108.3 382.92"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-261",
    points: "108.3 383.28 68.99 384.48 68.99 384.12 108.3 382.92 108.3 383.28"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-58",
    points: "108.3 383.64 68.99 384.84 68.99 384.48 108.3 383.28 108.3 383.64"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-58",
    points: "108.3 384 68.99 385.2 68.99 384.84 108.3 383.64 108.3 384"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-78",
    points: "108.3 384.36 68.99 385.56 68.99 385.2 108.3 384 108.3 384.36"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-255",
    points: "108.3 384.72 68.99 385.92 68.99 385.56 108.3 384.36 108.3 384.72"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-255",
    points: "108.3 385.08 68.99 386.28 68.99 385.92 108.3 384.72 108.3 385.08"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-135",
    points: "108.3 385.44 68.99 386.64 68.99 386.28 108.3 385.08 108.3 385.44"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-326",
    points: "108.3 385.8 68.99 387 68.99 386.64 108.3 385.44 108.3 385.8"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-326",
    points: "108.3 386.16 68.99 387.36 68.99 387 108.3 385.8 108.3 386.16"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-401",
    points: "108.3 386.52 68.99 387.72 68.99 387.36 108.3 386.16 108.3 386.52"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-306",
    points: "108.3 386.88 68.99 388.08 68.99 387.72 108.3 386.52 108.3 386.88"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-306",
    points: "108.3 387.24 68.99 388.44 68.99 388.08 108.3 386.88 108.3 387.24"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-388",
    points: "108.3 387.6 68.99 388.8 68.99 388.44 108.3 387.24 108.3 387.6"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-369",
    points: "108.3 387.96 68.99 389.16 68.99 388.8 108.3 387.6 108.3 387.96"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-316",
    points: "108.3 388.32 68.99 389.52 68.99 389.16 108.3 387.96 108.3 388.32"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-186",
    points: "108.3 388.68 68.99 389.88 68.99 389.52 108.3 388.32 108.3 388.68"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-186",
    points: "108.3 389.04 68.99 390.24 68.99 389.88 108.3 388.68 108.3 389.04"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-200",
    points: "108.3 389.4 68.99 390.6 68.99 390.24 108.3 389.04 108.3 389.4"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-321",
    points: "108.3 389.76 68.99 390.96 68.99 390.6 108.3 389.4 108.3 389.76"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-125",
    points: "108.3 390.12 68.99 391.32 68.99 390.96 108.3 389.76 108.3 390.12"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-151",
    points: "108.3 390.48 68.99 391.68 68.99 391.32 108.3 390.12 108.3 390.48"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-286",
    points: "108.3 390.84 68.99 392.04 68.99 391.68 108.3 390.48 108.3 390.84"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-40",
    points: "108.3 391.2 68.99 392.4 68.99 392.04 108.3 390.84 108.3 391.2"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-106",
    points: "108.3 391.56 68.99 392.76 68.99 392.4 108.3 391.2 108.3 391.56"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-29",
    points: "108.3 391.92 68.99 393.12 68.99 392.76 108.3 391.56 108.3 391.92"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-392",
    points: "108.3 392.28 68.99 393.48 68.99 393.12 108.3 391.92 108.3 392.28"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-356",
    points: "108.3 392.64 68.99 393.84 68.99 393.48 108.3 392.28 108.3 392.64"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-354",
    points: "108.3 393 68.99 394.2 68.99 393.84 108.3 392.64 108.3 393"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-416",
    points: "108.3 393.36 68.99 394.56 68.99 394.2 108.3 393 108.3 393.36"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-180",
    points: "108.3 393.72 68.99 394.92 68.99 394.56 108.3 393.36 108.3 393.72"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-54",
    points: "108.3 394.08 68.99 395.28 68.99 394.92 108.3 393.72 108.3 394.08"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-348",
    points: "108.3 394.44 68.99 395.64 68.99 395.28 108.3 394.08 108.3 394.44"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-20",
    points: "108.3 394.8 68.99 396 68.99 395.64 108.3 394.44 108.3 394.8"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-237",
    points: "108.3 395.16 68.99 396.36 68.99 396 108.3 394.8 108.3 395.16"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-118",
    points: "108.3 395.52 68.99 396.72 68.99 396.36 108.3 395.16 108.3 395.52"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-123",
    points: "108.3 395.88 68.99 397.08 68.99 396.72 108.3 395.52 108.3 395.88"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-367",
    points: "108.3 396.24 68.99 397.44 68.99 397.08 108.3 395.88 108.3 396.24"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-10",
    points: "108.3 396.6 68.99 397.8 68.99 397.44 108.3 396.24 108.3 396.6"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-395",
    points: "108.3 396.96 68.99 398.16 68.99 397.8 108.3 396.6 108.3 396.96"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-57",
    points: "108.3 397.32 68.99 398.52 68.99 398.16 108.3 396.96 108.3 397.32"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-413",
    points: "108.3 397.68 68.99 398.88 68.99 398.52 108.3 397.32 108.3 397.68"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-217",
    points: "108.3 398.04 68.99 399.24 68.99 398.88 108.3 397.68 108.3 398.04"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-335",
    points: "108.3 398.4 68.99 399.6 68.99 399.24 108.3 398.04 108.3 398.4"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-325",
    points: "108.3 398.76 68.99 399.96 68.99 399.6 108.3 398.4 108.3 398.76"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-162",
    points: "108.3 399.12 68.99 400.32 68.99 399.96 108.3 398.76 108.3 399.12"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-344",
    points: "108.3 399.48 68.99 400.68 68.99 400.32 108.3 399.12 108.3 399.48"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-181",
    points: "108.3 399.84 68.99 401.04 68.99 400.68 108.3 399.48 108.3 399.84"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-132",
    points: "108.3 400.2 68.99 401.4 68.99 401.04 108.3 399.84 108.3 400.2"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-35",
    points: "108.3 400.56 68.99 401.76 68.99 401.4 108.3 400.2 108.3 400.56"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-257",
    points: "108.3 400.92 68.99 402.12 68.99 401.76 108.3 400.56 108.3 400.92"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-398",
    points: "108.3 401.28 68.99 402.48 68.99 402.12 108.3 400.92 108.3 401.28"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-5",
    points: "108.3 401.64 68.99 402.84 68.99 402.48 108.3 401.28 108.3 401.64"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-59",
    points: "108.3 402 68.99 403.2 68.99 402.84 108.3 401.64 108.3 402"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-108",
    points: "108.3 402.36 68.99 403.56 68.99 403.2 108.3 402 108.3 402.36"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-158",
    points: "108.3 402.72 68.99 403.92 68.99 403.56 108.3 402.36 108.3 402.72"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-317",
    points: "108.3 403.08 68.99 404.28 68.99 403.92 108.3 402.72 108.3 403.08"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-45",
    points: "108.3 403.44 68.99 404.64 68.99 404.28 108.3 403.08 108.3 403.44"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-281",
    points: "108.3 403.8 68.99 405 68.99 404.64 108.3 403.44 108.3 403.8"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-102",
    points: "108.3 404.16 68.99 405.36 68.99 405 108.3 403.8 108.3 404.16"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-260",
    points: "108.3 404.52 68.99 405.72 68.99 405.36 108.3 404.16 108.3 404.52"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-130",
    points: "108.3 404.88 68.99 406.08 68.99 405.72 108.3 404.52 108.3 404.88"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-438",
    points: "108.3 405.24 68.99 406.44 68.99 406.08 108.3 404.88 108.3 405.24"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-152",
    points: "108.3 405.6 68.99 406.8 68.99 406.44 108.3 405.24 108.3 405.6"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-142",
    points: "108.3 405.96 68.99 407.16 68.99 406.8 108.3 405.6 108.3 405.96"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-203",
    points: "108.3 406.32 68.99 407.52 68.99 407.16 108.3 405.96 108.3 406.32"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-18",
    points: "108.3 406.68 68.99 407.88 68.99 407.52 108.3 406.32 108.3 406.68"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-61",
    points: "108.3 407.04 68.99 408.24 68.99 407.88 108.3 406.68 108.3 407.04"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-379",
    points: "108.3 407.4 68.99 408.6 68.99 408.24 108.3 407.04 108.3 407.4"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-216",
    points: "108.3 407.76 68.99 408.96 68.99 408.6 108.3 407.4 108.3 407.76"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-313",
    points: "108.3 408.12 68.99 409.32 68.99 408.96 108.3 407.76 108.3 408.12"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-405",
    points: "108.3 408.48 68.99 409.68 68.99 409.32 108.3 408.12 108.3 408.48"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-195",
    points: "108.3 408.84 68.99 410.04 68.99 409.68 108.3 408.48 108.3 408.84"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-330",
    points: "108.3 409.2 68.99 410.4 68.99 410.04 108.3 408.84 108.3 409.2"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-44",
    points: "108.3 409.56 68.99 410.76 68.99 410.4 108.3 409.2 108.3 409.56"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-140",
    points: "108.3 409.92 68.99 411.12 68.99 410.76 108.3 409.56 108.3 409.92"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-116",
    points: "108.3 410.28 68.99 411.48 68.99 411.12 108.3 409.92 108.3 410.28"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-329",
    points: "108.3 410.64 68.99 411.84 68.99 411.48 108.3 410.28 108.3 410.64"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-247",
    points: "108.3 411 68.99 412.2 68.99 411.84 108.3 410.64 108.3 411"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-39",
    points: "108.3 411.36 68.99 412.56 68.99 412.2 108.3 411 108.3 411.36"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-269",
    points: "108.3 411.72 73.87 412.78 68.99 412.78 68.99 412.56 108.3 411.36 108.3 411.72"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-252",
    points: "108.3 412.08 85.63 412.78 73.87 412.78 108.3 411.72 108.3 412.08"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-117",
    points: "108.3 412.44 97.4 412.78 85.63 412.78 108.3 412.08 108.3 412.44"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-231",
    points: "97.4 412.78 108.3 412.44 108.3 412.78 97.4 412.78"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-448"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-406",
    x: 102.05,
    y: 394.85,
    width: 2.84,
    height: 3.62
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-406",
    x: 102.05,
    y: 394.8,
    width: 2.84,
    height: 0.05
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-111",
    x: 102.05,
    y: 394.76,
    width: 2.84,
    height: 0.05
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-115",
    x: 102.05,
    y: 394.71,
    width: 2.84,
    height: 0.05
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-193",
    x: 102.05,
    y: 394.67,
    width: 2.84,
    height: 0.05
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-266",
    x: 102.05,
    y: 394.62,
    width: 2.84,
    height: 0.05
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-346",
    x: 102.05,
    y: 394.58,
    width: 2.84,
    height: 0.05
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-60",
    x: 102.05,
    y: 394.53,
    width: 2.84,
    height: 0.05
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-362",
    x: 102.05,
    y: 394.48,
    width: 2.84,
    height: 0.05
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-207",
    x: 102.05,
    y: 394.44,
    width: 2.84,
    height: 0.05
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-144",
    x: 102.05,
    y: 394.39,
    width: 2.84,
    height: 0.05
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-141",
    x: 102.05,
    y: 394.35,
    width: 2.84,
    height: 0.05
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-301",
    x: 102.05,
    y: 394.3,
    width: 2.84,
    height: 0.05
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-351",
    x: 102.05,
    y: 394.26,
    width: 2.84,
    height: 0.05
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-113",
    x: 102.05,
    y: 394.21,
    width: 2.84,
    height: 0.05
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-55",
    x: 102.05,
    y: 394.16,
    width: 2.84,
    height: 0.05
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-84",
    x: 102.05,
    y: 394.12,
    width: 2.84,
    height: 0.05
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-430",
    x: 102.05,
    y: 394.07,
    width: 2.84,
    height: 0.05
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-332",
    x: 102.05,
    y: 394.03,
    width: 2.84,
    height: 0.05
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-22",
    x: 102.05,
    y: 393.98,
    width: 2.84,
    height: 0.05
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-175",
    x: 102.05,
    y: 393.94,
    width: 2.84,
    height: 0.05
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-411",
    x: 102.05,
    y: 393.89,
    width: 2.84,
    height: 0.05
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-439",
    x: 102.05,
    y: 393.84,
    width: 2.84,
    height: 0.05
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-164",
    x: 102.05,
    y: 393.8,
    width: 2.84,
    height: 0.05
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-80",
    x: 102.05,
    y: 393.75,
    width: 2.84,
    height: 0.05
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-91",
    x: 102.05,
    y: 393.71,
    width: 2.84,
    height: 0.05
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-74",
    x: 102.05,
    y: 393.66,
    width: 2.84,
    height: 0.05
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-76",
    x: 102.05,
    y: 393.61,
    width: 2.84,
    height: 0.05
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-287",
    x: 102.05,
    y: 393.57,
    width: 2.84,
    height: 0.05
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-15",
    x: 102.05,
    y: 393.52,
    width: 2.84,
    height: 0.05
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-293",
    x: 102.05,
    y: 393.48,
    width: 2.84,
    height: 0.05
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-87",
    x: 102.05,
    y: 393.43,
    width: 2.84,
    height: 0.05
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-431",
    x: 102.05,
    y: 393.39,
    width: 2.84,
    height: 0.05
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-153",
    x: 102.05,
    y: 393.34,
    width: 2.84,
    height: 0.05
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-214",
    x: 102.05,
    y: 393.29,
    width: 2.84,
    height: 0.05
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-98",
    x: 102.05,
    y: 393.25,
    width: 2.84,
    height: 0.05
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-340",
    x: 102.05,
    y: 393.2,
    width: 2.84,
    height: 0.05
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-235",
    x: 102.05,
    y: 393.16,
    width: 2.84,
    height: 0.05
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-16",
    x: 102.05,
    y: 393.11,
    width: 2.84,
    height: 0.05
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-421",
    x: 102.05,
    y: 393.07,
    width: 2.84,
    height: 0.05
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 102.05,
    y: 393.02,
    width: 2.84,
    height: 0.05
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-47",
    x: 102.05,
    y: 392.97,
    width: 2.84,
    height: 0.05
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-320",
    x: 102.05,
    y: 392.93,
    width: 2.84,
    height: 0.05
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-254",
    x: 102.05,
    y: 392.88,
    width: 2.84,
    height: 0.05
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-188",
    x: 102.05,
    y: 392.84,
    width: 2.84,
    height: 0.05
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-85",
    x: 102.05,
    y: 392.79,
    width: 2.84,
    height: 0.05
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-156",
    x: 102.05,
    y: 392.75,
    width: 2.84,
    height: 0.05
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-197",
    x: 102.05,
    y: 392.7,
    width: 2.84,
    height: 0.05
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-380",
    x: 102.05,
    y: 392.65,
    width: 2.84,
    height: 0.05
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-228",
    x: 102.05,
    y: 392.61,
    width: 2.84,
    height: 0.05
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-192",
    x: 102.05,
    y: 392.56,
    width: 2.84,
    height: 0.05
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-403",
    x: 102.05,
    y: 392.52,
    width: 2.84,
    height: 0.05
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-358",
    x: 102.05,
    y: 392.47,
    width: 2.84,
    height: 0.05
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-46",
    x: 102.05,
    y: 392.43,
    width: 2.84,
    height: 0.05
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-147",
    x: 102.05,
    y: 392.38,
    width: 2.84,
    height: 0.05
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-309",
    x: 102.05,
    y: 392.33,
    width: 2.84,
    height: 0.05
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-389",
    x: 102.05,
    y: 392.29,
    width: 2.84,
    height: 0.05
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-423",
    x: 102.05,
    y: 392.24,
    width: 2.84,
    height: 0.05
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-232",
    x: 102.05,
    y: 392.2,
    width: 2.84,
    height: 0.05
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-170",
    x: 102.05,
    y: 392.15,
    width: 2.84,
    height: 0.05
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-259",
    x: 102.05,
    y: 392.11,
    width: 2.84,
    height: 0.05
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-410",
    x: 102.05,
    y: 392.06,
    width: 2.84,
    height: 0.05
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-97",
    x: 102.05,
    y: 392.01,
    width: 2.84,
    height: 0.05
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-24",
    x: 102.05,
    y: 391.97,
    width: 2.84,
    height: 0.05
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-136",
    x: 102.05,
    y: 391.92,
    width: 2.84,
    height: 0.05
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-434",
    x: 102.05,
    y: 391.88,
    width: 2.84,
    height: 0.05
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-104",
    x: 102.05,
    y: 391.83,
    width: 2.84,
    height: 0.05
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-26",
    x: 102.05,
    y: 391.79,
    width: 2.84,
    height: 0.05
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-21",
    x: 102.05,
    y: 391.74,
    width: 2.84,
    height: 0.05
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-426",
    x: 102.05,
    y: 391.69,
    width: 2.84,
    height: 0.05
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-435",
    x: 102.05,
    y: 391.65,
    width: 2.84,
    height: 0.05
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-66",
    x: 102.05,
    y: 391.6,
    width: 2.84,
    height: 0.05
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-107",
    x: 102.05,
    y: 391.56,
    width: 2.84,
    height: 0.05
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-363",
    x: 102.05,
    y: 391.51,
    width: 2.84,
    height: 0.05
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-110",
    x: 102.05,
    y: 391.47,
    width: 2.84,
    height: 0.05
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-409",
    x: 102.05,
    y: 391.42,
    width: 2.84,
    height: 0.05
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-145",
    x: 102.05,
    y: 391.37,
    width: 2.84,
    height: 0.05
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-77",
    x: 102.05,
    y: 391.33,
    width: 2.84,
    height: 0.05
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-177",
    x: 102.05,
    y: 391.28,
    width: 2.84,
    height: 0.05
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-169",
    x: 102.05,
    y: 391.24,
    width: 2.84,
    height: 0.05
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-288",
    x: 102.05,
    y: 391.19,
    width: 2.84,
    height: 0.05
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-75",
    x: 102.05,
    y: 391.14,
    width: 2.84,
    height: 0.05
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-264",
    x: 102.05,
    y: 391.1,
    width: 2.84,
    height: 0.05
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-393",
    x: 102.05,
    y: 391.05,
    width: 2.84,
    height: 0.05
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-146",
    x: 102.05,
    y: 391.01,
    width: 2.84,
    height: 0.05
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-429",
    x: 102.05,
    y: 390.96,
    width: 2.84,
    height: 0.05
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-419",
    x: 102.05,
    y: 390.92,
    width: 2.84,
    height: 0.05
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-229",
    x: 102.05,
    y: 390.87,
    width: 2.84,
    height: 0.05
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-190",
    x: 102.05,
    y: 390.82,
    width: 2.84,
    height: 0.05
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-414",
    x: 102.05,
    y: 390.78,
    width: 2.84,
    height: 0.05
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-71",
    x: 102.05,
    y: 390.73,
    width: 2.84,
    height: 0.05
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-11",
    x: 102.05,
    y: 390.73,
    width: 2.84,
    height: 0
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-457"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-406",
    x: 72.31,
    y: 396.99,
    width: 2.65,
    height: 1.45
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-406",
    x: 72.31,
    y: 396.94,
    width: 2.65,
    height: 0.04
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-111",
    x: 72.31,
    y: 396.9,
    width: 2.65,
    height: 0.04
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-115",
    x: 72.31,
    y: 396.86,
    width: 2.65,
    height: 0.04
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-193",
    x: 72.31,
    y: 396.81,
    width: 2.65,
    height: 0.04
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-266",
    x: 72.31,
    y: 396.77,
    width: 2.65,
    height: 0.04
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-346",
    x: 72.31,
    y: 396.73,
    width: 2.65,
    height: 0.04
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-60",
    x: 72.31,
    y: 396.68,
    width: 2.65,
    height: 0.04
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-362",
    x: 72.31,
    y: 396.64,
    width: 2.65,
    height: 0.04
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-207",
    x: 72.31,
    y: 396.59,
    width: 2.65,
    height: 0.04
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-144",
    x: 72.31,
    y: 396.55,
    width: 2.65,
    height: 0.04
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-141",
    x: 72.31,
    y: 396.51,
    width: 2.65,
    height: 0.04
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-301",
    x: 72.31,
    y: 396.46,
    width: 2.65,
    height: 0.04
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-351",
    x: 72.31,
    y: 396.42,
    width: 2.65,
    height: 0.04
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-113",
    x: 72.31,
    y: 396.38,
    width: 2.65,
    height: 0.04
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-55",
    x: 72.31,
    y: 396.33,
    width: 2.65,
    height: 0.04
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-84",
    x: 72.31,
    y: 396.29,
    width: 2.65,
    height: 0.04
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-430",
    x: 72.31,
    y: 396.24,
    width: 2.65,
    height: 0.04
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-332",
    x: 72.31,
    y: 396.2,
    width: 2.65,
    height: 0.04
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-22",
    x: 72.31,
    y: 396.16,
    width: 2.65,
    height: 0.04
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-175",
    x: 72.31,
    y: 396.11,
    width: 2.65,
    height: 0.04
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-411",
    x: 72.31,
    y: 396.07,
    width: 2.65,
    height: 0.04
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-439",
    x: 72.31,
    y: 396.03,
    width: 2.65,
    height: 0.04
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-164",
    x: 72.31,
    y: 395.98,
    width: 2.65,
    height: 0.04
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-80",
    x: 72.31,
    y: 395.94,
    width: 2.65,
    height: 0.04
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-91",
    x: 72.31,
    y: 395.89,
    width: 2.65,
    height: 0.04
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-74",
    x: 72.31,
    y: 395.85,
    width: 2.65,
    height: 0.04
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-76",
    x: 72.31,
    y: 395.81,
    width: 2.65,
    height: 0.04
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-287",
    x: 72.31,
    y: 395.76,
    width: 2.65,
    height: 0.04
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-15",
    x: 72.31,
    y: 395.72,
    width: 2.65,
    height: 0.04
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-293",
    x: 72.31,
    y: 395.68,
    width: 2.65,
    height: 0.04
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-87",
    x: 72.31,
    y: 395.63,
    width: 2.65,
    height: 0.04
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-431",
    x: 72.31,
    y: 395.59,
    width: 2.65,
    height: 0.04
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-153",
    x: 72.31,
    y: 395.54,
    width: 2.65,
    height: 0.04
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-214",
    x: 72.31,
    y: 395.5,
    width: 2.65,
    height: 0.04
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-98",
    x: 72.31,
    y: 395.46,
    width: 2.65,
    height: 0.04
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-340",
    x: 72.31,
    y: 395.41,
    width: 2.65,
    height: 0.04
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-235",
    x: 72.31,
    y: 395.37,
    width: 2.65,
    height: 0.04
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-16",
    x: 72.31,
    y: 395.33,
    width: 2.65,
    height: 0.04
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-421",
    x: 72.31,
    y: 395.28,
    width: 2.65,
    height: 0.04
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 72.31,
    y: 395.24,
    width: 2.65,
    height: 0.04
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-47",
    x: 72.31,
    y: 395.19,
    width: 2.65,
    height: 0.04
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-320",
    x: 72.31,
    y: 395.15,
    width: 2.65,
    height: 0.04
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-254",
    x: 72.31,
    y: 395.11,
    width: 2.65,
    height: 0.04
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-188",
    x: 72.31,
    y: 395.06,
    width: 2.65,
    height: 0.04
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-85",
    x: 72.31,
    y: 395.02,
    width: 2.65,
    height: 0.04
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-156",
    x: 72.31,
    y: 394.97,
    width: 2.65,
    height: 0.04
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-197",
    x: 72.31,
    y: 394.93,
    width: 2.65,
    height: 0.04
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-380",
    x: 72.31,
    y: 394.89,
    width: 2.65,
    height: 0.04
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-228",
    x: 72.31,
    y: 394.84,
    width: 2.65,
    height: 0.04
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-192",
    x: 72.31,
    y: 394.8,
    width: 2.65,
    height: 0.04
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-403",
    x: 72.31,
    y: 394.76,
    width: 2.65,
    height: 0.04
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-358",
    x: 72.31,
    y: 394.71,
    width: 2.65,
    height: 0.04
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-46",
    x: 72.31,
    y: 394.67,
    width: 2.65,
    height: 0.04
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-147",
    x: 72.31,
    y: 394.62,
    width: 2.65,
    height: 0.04
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-309",
    x: 72.31,
    y: 394.58,
    width: 2.65,
    height: 0.04
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-389",
    x: 72.31,
    y: 394.54,
    width: 2.65,
    height: 0.04
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-423",
    x: 72.31,
    y: 394.49,
    width: 2.65,
    height: 0.04
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-232",
    x: 72.31,
    y: 394.45,
    width: 2.65,
    height: 0.04
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-170",
    x: 72.31,
    y: 394.41,
    width: 2.65,
    height: 0.04
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-259",
    x: 72.31,
    y: 394.36,
    width: 2.65,
    height: 0.04
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-410",
    x: 72.31,
    y: 394.32,
    width: 2.65,
    height: 0.04
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-97",
    x: 72.31,
    y: 394.27,
    width: 2.65,
    height: 0.04
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-24",
    x: 72.31,
    y: 394.23,
    width: 2.65,
    height: 0.04
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-136",
    x: 72.31,
    y: 394.19,
    width: 2.65,
    height: 0.04
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-434",
    x: 72.31,
    y: 394.14,
    width: 2.65,
    height: 0.04
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-104",
    x: 72.31,
    y: 394.1,
    width: 2.65,
    height: 0.04
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-26",
    x: 72.31,
    y: 394.06,
    width: 2.65,
    height: 0.04
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-21",
    x: 72.31,
    y: 394.01,
    width: 2.65,
    height: 0.04
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-426",
    x: 72.31,
    y: 393.97,
    width: 2.65,
    height: 0.04
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-435",
    x: 72.31,
    y: 393.92,
    width: 2.65,
    height: 0.04
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-66",
    x: 72.31,
    y: 393.88,
    width: 2.65,
    height: 0.04
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-107",
    x: 72.31,
    y: 393.84,
    width: 2.65,
    height: 0.04
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-363",
    x: 72.31,
    y: 393.79,
    width: 2.65,
    height: 0.04
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-110",
    x: 72.31,
    y: 393.75,
    width: 2.65,
    height: 0.04
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-409",
    x: 72.31,
    y: 393.71,
    width: 2.65,
    height: 0.04
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-145",
    x: 72.31,
    y: 393.66,
    width: 2.65,
    height: 0.04
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-77",
    x: 72.31,
    y: 393.62,
    width: 2.65,
    height: 0.04
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-177",
    x: 72.31,
    y: 393.57,
    width: 2.65,
    height: 0.04
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-169",
    x: 72.31,
    y: 393.53,
    width: 2.65,
    height: 0.04
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-288",
    x: 72.31,
    y: 393.49,
    width: 2.65,
    height: 0.04
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-75",
    x: 72.31,
    y: 393.44,
    width: 2.65,
    height: 0.04
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-264",
    x: 72.31,
    y: 393.4,
    width: 2.65,
    height: 0.04
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-393",
    x: 72.31,
    y: 393.35,
    width: 2.65,
    height: 0.04
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-146",
    x: 72.31,
    y: 393.31,
    width: 2.65,
    height: 0.04
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-429",
    x: 72.31,
    y: 393.27,
    width: 2.65,
    height: 0.04
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-419",
    x: 72.31,
    y: 393.22,
    width: 2.65,
    height: 0.04
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-229",
    x: 72.31,
    y: 393.18,
    width: 2.65,
    height: 0.04
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-190",
    x: 72.31,
    y: 393.14,
    width: 2.65,
    height: 0.04
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-414",
    x: 72.31,
    y: 393.09,
    width: 2.65,
    height: 0.04
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-71",
    x: 72.31,
    y: 393.05,
    width: 2.65,
    height: 0.04
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-11",
    x: 72.31,
    y: 393,
    width: 2.65,
    height: 0.04
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-191",
    x: 72.31,
    y: 392.96,
    width: 2.65,
    height: 0.04
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-350",
    x: 72.31,
    y: 392.92,
    width: 2.65,
    height: 0.04
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-178",
    x: 72.31,
    y: 392.87,
    width: 2.65,
    height: 0.04
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-386",
    x: 72.31,
    y: 392.83,
    width: 2.65,
    height: 0.04
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-368",
    x: 72.31,
    y: 392.79,
    width: 2.65,
    height: 0.04
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-13",
    x: 72.31,
    y: 392.74,
    width: 2.65,
    height: 0.04
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-402",
    x: 72.31,
    y: 392.7,
    width: 2.65,
    height: 0.04
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-53",
    x: 72.31,
    y: 392.65,
    width: 2.65,
    height: 0.04
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-274",
    x: 72.31,
    y: 392.61,
    width: 2.65,
    height: 0.04
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-337",
    x: 72.31,
    y: 392.57,
    width: 2.65,
    height: 0.04
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-303",
    x: 72.31,
    y: 392.52,
    width: 2.65,
    height: 0.04
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-353",
    x: 72.31,
    y: 392.48,
    width: 2.65,
    height: 0.04
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-353",
    x: 72.31,
    y: 392.44,
    width: 2.65,
    height: 0.04
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-64",
    x: 72.31,
    y: 392.39,
    width: 2.65,
    height: 0.04
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-64",
    x: 72.31,
    y: 392.35,
    width: 2.65,
    height: 0.04
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-165",
    x: 72.31,
    y: 392.3,
    width: 2.65,
    height: 0.04
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-36",
    x: 72.31,
    y: 392.26,
    width: 2.65,
    height: 0.04
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-36",
    x: 72.31,
    y: 392.22,
    width: 2.65,
    height: 0.04
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-383",
    x: 72.31,
    y: 392.17,
    width: 2.65,
    height: 0.04
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-383",
    x: 72.31,
    y: 392.13,
    width: 2.65,
    height: 0.04
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-297",
    x: 72.31,
    y: 392.09,
    width: 2.65,
    height: 0.04
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-307",
    x: 72.31,
    y: 392.04,
    width: 2.65,
    height: 0.04
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-307",
    x: 72.31,
    y: 392,
    width: 2.65,
    height: 0.04
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-6",
    x: 72.31,
    y: 391.95,
    width: 2.65,
    height: 0.04
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-6",
    x: 72.31,
    y: 391.91,
    width: 2.65,
    height: 0.04
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-246",
    x: 72.31,
    y: 391.87,
    width: 2.65,
    height: 0.04
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-408",
    x: 72.31,
    y: 391.82,
    width: 2.65,
    height: 0.04
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-408",
    x: 72.31,
    y: 391.78,
    width: 2.65,
    height: 0.04
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-408",
    x: 72.31,
    y: 391.73,
    width: 2.65,
    height: 0.04
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-280",
    x: 72.31,
    y: 391.69,
    width: 2.65,
    height: 0.04
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-93",
    x: 72.31,
    y: 391.65,
    width: 2.65,
    height: 0.04
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-93",
    x: 72.31,
    y: 391.6,
    width: 2.65,
    height: 0.04
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-93",
    x: 72.31,
    y: 391.56,
    width: 2.65,
    height: 0.04
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-93",
    x: 72.31,
    y: 391.52,
    width: 2.65,
    height: 0.04
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-161",
    x: 72.31,
    y: 391.47,
    width: 2.65,
    height: 0.04
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-69",
    x: 72.31,
    y: 391.43,
    width: 2.65,
    height: 0.04
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-69",
    x: 72.31,
    y: 391.38,
    width: 2.65,
    height: 0.04
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-69",
    x: 72.31,
    y: 391.34,
    width: 2.65,
    height: 0.04
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-69",
    x: 72.31,
    y: 391.3,
    width: 2.65,
    height: 0.04
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-69",
    x: 72.31,
    y: 391.25,
    width: 2.65,
    height: 0.04
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-69",
    x: 72.31,
    y: 391.21,
    width: 2.65,
    height: 0.04
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-51",
    x: 72.31,
    y: 391.17,
    width: 2.65,
    height: 0.04
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-376",
    x: 72.31,
    y: 391.12,
    width: 2.65,
    height: 0.04
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-376",
    x: 72.31,
    y: 391.09,
    width: 2.65,
    height: 0.03
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-454"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-458"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-406",
    x: 71.05,
    y: 393.27,
    width: 34.37,
    height: 17.28
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-406",
    x: 71.05,
    y: 393.04,
    width: 34.37,
    height: 0.24
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-111",
    x: 71.05,
    y: 392.8,
    width: 34.37,
    height: 0.24
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-115",
    x: 71.05,
    y: 392.56,
    width: 34.37,
    height: 0.24
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-193",
    x: 71.05,
    y: 392.33,
    width: 34.37,
    height: 0.24
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-266",
    x: 71.05,
    y: 392.09,
    width: 34.37,
    height: 0.24
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-346",
    x: 71.05,
    y: 391.85,
    width: 34.37,
    height: 0.24
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-60",
    x: 71.05,
    y: 391.62,
    width: 34.37,
    height: 0.24
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-362",
    x: 71.05,
    y: 391.38,
    width: 34.37,
    height: 0.24
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-207",
    x: 71.05,
    y: 391.15,
    width: 34.37,
    height: 0.24
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-144",
    x: 71.05,
    y: 390.91,
    width: 34.37,
    height: 0.24
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-141",
    x: 71.05,
    y: 390.67,
    width: 34.37,
    height: 0.24
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-301",
    x: 71.05,
    y: 390.44,
    width: 34.37,
    height: 0.24
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-351",
    x: 71.05,
    y: 390.2,
    width: 34.37,
    height: 0.24
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-113",
    x: 71.05,
    y: 389.96,
    width: 34.37,
    height: 0.24
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-55",
    x: 71.05,
    y: 389.73,
    width: 34.37,
    height: 0.24
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-84",
    x: 71.05,
    y: 389.49,
    width: 34.37,
    height: 0.24
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-430",
    x: 71.05,
    y: 389.26,
    width: 34.37,
    height: 0.24
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-332",
    x: 71.05,
    y: 389.02,
    width: 34.37,
    height: 0.24
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-22",
    x: 71.05,
    y: 388.78,
    width: 34.37,
    height: 0.24
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-175",
    x: 71.05,
    y: 388.55,
    width: 34.37,
    height: 0.24
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-411",
    x: 71.05,
    y: 388.31,
    width: 34.37,
    height: 0.24
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-439",
    x: 71.05,
    y: 388.07,
    width: 34.37,
    height: 0.24
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-164",
    x: 71.05,
    y: 387.84,
    width: 34.37,
    height: 0.24
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-80",
    x: 71.05,
    y: 387.6,
    width: 34.37,
    height: 0.24
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-91",
    x: 71.05,
    y: 387.37,
    width: 34.37,
    height: 0.24
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-74",
    x: 71.05,
    y: 387.13,
    width: 34.37,
    height: 0.24
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-76",
    x: 71.05,
    y: 386.89,
    width: 34.37,
    height: 0.24
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-287",
    x: 71.05,
    y: 386.66,
    width: 34.37,
    height: 0.24
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-15",
    x: 71.05,
    y: 386.42,
    width: 34.37,
    height: 0.24
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-293",
    x: 71.05,
    y: 386.18,
    width: 34.37,
    height: 0.24
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-87",
    x: 71.05,
    y: 385.95,
    width: 34.37,
    height: 0.24
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-431",
    x: 71.05,
    y: 385.71,
    width: 34.37,
    height: 0.24
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-153",
    x: 71.05,
    y: 385.48,
    width: 34.37,
    height: 0.24
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-214",
    x: 71.05,
    y: 385.24,
    width: 34.37,
    height: 0.24
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-98",
    x: 71.05,
    y: 385,
    width: 34.37,
    height: 0.24
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-340",
    x: 71.05,
    y: 384.77,
    width: 34.37,
    height: 0.24
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-235",
    x: 71.05,
    y: 384.53,
    width: 34.37,
    height: 0.24
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-16",
    x: 71.05,
    y: 384.29,
    width: 34.37,
    height: 0.24
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-421",
    x: 71.05,
    y: 384.06,
    width: 34.37,
    height: 0.24
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 71.05,
    y: 383.82,
    width: 34.37,
    height: 0.24
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-47",
    x: 71.05,
    y: 383.59,
    width: 34.37,
    height: 0.24
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-320",
    x: 71.05,
    y: 383.35,
    width: 34.37,
    height: 0.24
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-254",
    x: 71.05,
    y: 383.11,
    width: 34.37,
    height: 0.24
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-188",
    x: 71.05,
    y: 382.88,
    width: 34.37,
    height: 0.24
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-85",
    x: 71.05,
    y: 382.64,
    width: 34.37,
    height: 0.24
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-156",
    x: 71.05,
    y: 382.4,
    width: 34.37,
    height: 0.24
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-197",
    x: 71.05,
    y: 382.17,
    width: 34.37,
    height: 0.24
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-380",
    x: 71.05,
    y: 381.93,
    width: 34.37,
    height: 0.24
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-228",
    x: 71.05,
    y: 381.7,
    width: 34.37,
    height: 0.24
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-192",
    x: 71.05,
    y: 381.46,
    width: 34.37,
    height: 0.24
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-403",
    x: 71.05,
    y: 381.22,
    width: 34.37,
    height: 0.24
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-358",
    x: 71.05,
    y: 380.99,
    width: 34.37,
    height: 0.24
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-46",
    x: 71.05,
    y: 380.75,
    width: 34.37,
    height: 0.24
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-147",
    x: 71.05,
    y: 380.51,
    width: 34.37,
    height: 0.24
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-309",
    x: 71.05,
    y: 380.28,
    width: 34.37,
    height: 0.24
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-389",
    x: 71.05,
    y: 380.04,
    width: 34.37,
    height: 0.24
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-423",
    x: 71.05,
    y: 379.81,
    width: 34.37,
    height: 0.24
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-232",
    x: 71.05,
    y: 379.57,
    width: 34.37,
    height: 0.24
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-170",
    x: 71.05,
    y: 379.33,
    width: 34.37,
    height: 0.24
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-259",
    x: 71.05,
    y: 379.1,
    width: 34.37,
    height: 0.24
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-410",
    x: 71.05,
    y: 378.86,
    width: 34.37,
    height: 0.24
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-97",
    x: 71.05,
    y: 378.62,
    width: 34.37,
    height: 0.24
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-24",
    x: 71.05,
    y: 378.39,
    width: 34.37,
    height: 0.24
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-136",
    x: 71.05,
    y: 378.15,
    width: 34.37,
    height: 0.24
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-434",
    x: 71.05,
    y: 377.92,
    width: 34.37,
    height: 0.24
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-104",
    x: 71.05,
    y: 377.68,
    width: 34.37,
    height: 0.24
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-26",
    x: 71.05,
    y: 377.44,
    width: 34.37,
    height: 0.24
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-21",
    x: 71.05,
    y: 377.21,
    width: 34.37,
    height: 0.24
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-426",
    x: 71.05,
    y: 376.97,
    width: 34.37,
    height: 0.24
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-435",
    x: 71.05,
    y: 376.73,
    width: 34.37,
    height: 0.24
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-66",
    x: 71.05,
    y: 376.5,
    width: 34.37,
    height: 0.24
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-107",
    x: 71.05,
    y: 376.26,
    width: 34.37,
    height: 0.24
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-363",
    x: 71.05,
    y: 376.03,
    width: 34.37,
    height: 0.24
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-110",
    x: 71.05,
    y: 375.79,
    width: 34.37,
    height: 0.24
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-409",
    x: 71.05,
    y: 375.55,
    width: 34.37,
    height: 0.24
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-145",
    x: 71.05,
    y: 375.32,
    width: 34.37,
    height: 0.24
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-77",
    x: 71.05,
    y: 375.08,
    width: 34.37,
    height: 0.24
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-177",
    x: 71.05,
    y: 374.84,
    width: 34.37,
    height: 0.24
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-169",
    x: 71.05,
    y: 374.61,
    width: 34.37,
    height: 0.24
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-288",
    x: 71.05,
    y: 374.37,
    width: 34.37,
    height: 0.24
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-75",
    x: 71.05,
    y: 374.14,
    width: 34.37,
    height: 0.24
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-264",
    x: 71.05,
    y: 373.9,
    width: 34.37,
    height: 0.24
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-393",
    x: 71.05,
    y: 373.66,
    width: 34.37,
    height: 0.24
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-146",
    x: 71.05,
    y: 373.43,
    width: 34.37,
    height: 0.24
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-429",
    x: 71.05,
    y: 373.19,
    width: 34.37,
    height: 0.24
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-419",
    x: 71.05,
    y: 372.95,
    width: 34.37,
    height: 0.24
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-229",
    x: 71.05,
    y: 372.72,
    width: 34.37,
    height: 0.24
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-190",
    x: 71.05,
    y: 372.48,
    width: 34.37,
    height: 0.24
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-414",
    x: 71.05,
    y: 372.25,
    width: 34.37,
    height: 0.24
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-71",
    x: 71.05,
    y: 372.01,
    width: 34.37,
    height: 0.24
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-11",
    x: 71.05,
    y: 371.98,
    width: 34.37,
    height: 0.03
  })), /*#__PURE__*/React.createElement("path", {
    className: "cls-119",
    d: "M71.17,385.19c2-2.53,4.36-2.85,5.85-3.07,4.48-.66,8.28,1.3,9.05,2.14.06.07.37.29.76.61.69.56,1.62.51,2.44.34.65-.14,1.44-1.1,1.56-1.21,1.29-1.26,3.45-1.31,4.53-1.49,0,0,4.74-.78,9.2,1.56.25.13.62.35.96.74.89,1.06.22,2.46.15,3.15-.04.47-.15,2.3-1.11,4.36-.77,1.65-2.34,2.18-2.64,2.34-.75.41-3.15,1.66-5.95.81-2.14-.65-4.94-3.03-5.53-5.38,0,0-.18-1.15-.97-2.37-.22-.33-.91-.45-1.02-.47-.4-.06-.73.16-.85.24-.9.59-1.16,2.34-1.18,2.44-.38,2.52-3.32,4.47-4.9,5.2-3.57,1.65-7.15.11-7.74-.15-.96-.43-2.22-2.24-2.58-5.43-.25-2.16-.5-3.78-.04-4.36Z"
  })), /*#__PURE__*/React.createElement("path", {
    className: "cls-70",
    d: "M74.93,382.55l3.9,13.3s1.92-.27,2.88-.8l-3.93-13.02s-1.9.15-2.85.52Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-70",
    d: "M92.05,383.21l3.23,12s1.7.7,2.91.55l-3.63-13.15s-1.85.24-2.51.59Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-231",
    d: "M117.49,438.76s1.24-15.26,2.71-16.54c1.48-1.28,1.85-1.62,1.85-1.62,0,0-1.85,2.56-1.85,4.53s1.16,14.21,1.26,16.3,1.85,6.06,1.85,6.06c0,0,1.4-1.51,3.03-1.98s5.64,6.34,5.64,6.34c0,0-9.88-.86-11.78-1.1s-3.3-8.04-3.3-8.04l.58-3.96Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-231",
    d: "M54.06,421.32s2.04,2.62,2.04,4.09,1.18,10.79-1.02,12.1l.5,3.01s-1.93,1.85-3.86,3.62c-1.93,1.77-1.93-1.7-1.93-1.7l-4.98,8.08s4.91,1.5,5.73,1.32l5.55-1.18s3.8-9.15,3.88-9.84.69-17.27.69-17.81-6.61-1.7-6.61-1.7Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-231",
    d: "M75.86,409.26s-4.64-2.41-5.9-3.78c-1.27-1.37-4.32-4.49-4.32-4.49l6.39,8.79,3.84-.52"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-231",
    d: "M102.96,409.78s2.72-.95,5.76-9.84c0,0-1.71,7.13-3.24,9.32s-2.52.52-2.52.52Z"
  }), /*#__PURE__*/React.createElement("g", {
    className: "cls-449"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-267",
    points: "108.28 448.22 120.21 426.81 120.21 448.22 108.28 448.22"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-267",
    points: "107.75 448.22 120.21 425.86 120.21 426.81 108.28 448.22 107.75 448.22"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-318",
    points: "107.21 448.22 120.21 424.9 120.21 425.86 107.75 448.22 107.21 448.22"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-396",
    points: "106.68 448.22 120.21 423.95 120.21 424.9 107.21 448.22 106.68 448.22"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-302",
    points: "106.15 448.22 120.21 422.99 120.21 423.95 106.68 448.22 106.15 448.22"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-121",
    points: "105.62 448.22 120.21 422.04 120.21 422.99 106.15 448.22 105.62 448.22"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-83",
    points: "105.09 448.22 120.21 421.08 120.21 422.04 105.62 448.22 105.09 448.22"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-285",
    points: "104.55 448.22 120.21 420.13 120.21 421.08 105.09 448.22 104.55 448.22"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-289",
    points: "104.02 448.22 120.21 419.17 120.21 420.13 104.55 448.22 104.02 448.22"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-440",
    points: "103.49 448.22 120.21 418.22 120.21 419.17 104.02 448.22 103.49 448.22"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-417",
    points: "102.96 448.22 120.21 417.26 120.21 418.22 103.49 448.22 102.96 448.22"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-128",
    points: "102.43 448.22 120.21 416.31 120.21 417.26 102.96 448.22 102.43 448.22"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-295",
    points: "101.89 448.22 120.21 415.35 120.21 416.31 102.43 448.22 101.89 448.22"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-221",
    points: "101.36 448.22 120.21 414.4 120.21 415.35 101.89 448.22 101.36 448.22"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-308",
    points: "100.83 448.22 120.21 413.44 120.21 414.4 101.36 448.22 100.83 448.22"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-377",
    points: "100.3 448.22 120.21 412.49 120.21 413.44 100.83 448.22 100.3 448.22"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-366",
    points: "99.77 448.22 120.21 411.53 120.21 412.49 100.3 448.22 99.77 448.22"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-364",
    points: "99.23 448.22 120.21 410.58 120.21 411.53 99.77 448.22 99.23 448.22"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-271",
    points: "98.7 448.22 120.21 409.62 120.21 410.58 99.23 448.22 98.7 448.22"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-96",
    points: "98.17 448.22 119.88 409.26 120.21 409.26 120.21 409.62 98.7 448.22 98.17 448.22"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-283",
    points: "97.64 448.22 119.35 409.26 119.88 409.26 98.17 448.22 97.64 448.22"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-352",
    points: "97.11 448.22 118.81 409.26 119.35 409.26 97.64 448.22 97.11 448.22"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-357",
    points: "96.57 448.22 118.28 409.26 118.81 409.26 97.11 448.22 96.57 448.22"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-424",
    points: "96.04 448.22 117.75 409.26 118.28 409.26 96.57 448.22 96.04 448.22"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-89",
    points: "95.51 448.22 117.22 409.26 117.75 409.26 96.04 448.22 95.51 448.22"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-428",
    points: "94.98 448.22 116.69 409.26 117.22 409.26 95.51 448.22 94.98 448.22"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-298",
    points: "94.44 448.22 116.15 409.26 116.69 409.26 94.98 448.22 94.44 448.22"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-68",
    points: "93.91 448.22 115.62 409.26 116.15 409.26 94.44 448.22 93.91 448.22"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-279",
    points: "93.38 448.22 115.09 409.26 115.62 409.26 93.91 448.22 93.38 448.22"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-341",
    points: "92.85 448.22 114.56 409.26 115.09 409.26 93.38 448.22 92.85 448.22"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-81",
    points: "92.32 448.22 114.03 409.26 114.56 409.26 92.85 448.22 92.32 448.22"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-342",
    points: "91.78 448.22 113.49 409.26 114.03 409.26 92.32 448.22 91.78 448.22"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-159",
    points: "91.25 448.22 112.96 409.26 113.49 409.26 91.78 448.22 91.25 448.22"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-154",
    points: "90.72 448.22 112.43 409.26 112.96 409.26 91.25 448.22 90.72 448.22"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-415",
    points: "90.19 448.22 111.9 409.26 112.43 409.26 90.72 448.22 90.19 448.22"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-72",
    points: "89.66 448.22 111.37 409.26 111.9 409.26 90.19 448.22 89.66 448.22"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-265",
    points: "89.12 448.22 110.83 409.26 111.37 409.26 89.66 448.22 89.12 448.22"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-50",
    points: "88.59 448.22 110.3 409.26 110.83 409.26 89.12 448.22 88.59 448.22"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-215",
    points: "88.06 448.22 109.77 409.26 110.3 409.26 88.59 448.22 88.06 448.22"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-244",
    points: "87.53 448.22 109.24 409.26 109.77 409.26 88.06 448.22 87.53 448.22"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-343",
    points: "87 448.22 108.71 409.26 109.24 409.26 87.53 448.22 87 448.22"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-67",
    points: "86.46 448.22 108.17 409.26 108.71 409.26 87 448.22 86.46 448.22"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-445",
    points: "85.93 448.22 107.64 409.26 108.17 409.26 86.46 448.22 85.93 448.22"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-8",
    points: "85.4 448.22 107.11 409.26 107.64 409.26 85.93 448.22 85.4 448.22"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-324",
    points: "84.87 448.22 106.58 409.26 107.11 409.26 85.4 448.22 84.87 448.22"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-296",
    points: "84.34 448.22 106.04 409.26 106.58 409.26 84.87 448.22 84.34 448.22"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-9",
    points: "83.8 448.22 105.51 409.26 106.04 409.26 84.34 448.22 83.8 448.22"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-56",
    points: "83.27 448.22 104.98 409.26 105.51 409.26 83.8 448.22 83.27 448.22"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-277",
    points: "82.74 448.22 104.45 409.26 104.98 409.26 83.27 448.22 82.74 448.22"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-432",
    points: "82.21 448.22 103.92 409.26 104.45 409.26 82.74 448.22 82.21 448.22"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-90",
    points: "81.67 448.22 103.38 409.26 103.92 409.26 82.21 448.22 81.67 448.22"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-3",
    points: "81.14 448.22 102.85 409.26 103.38 409.26 81.67 448.22 81.14 448.22"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-100",
    points: "80.61 448.22 102.32 409.26 102.85 409.26 81.14 448.22 80.61 448.22"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-112",
    points: "80.08 448.22 101.79 409.26 102.32 409.26 80.61 448.22 80.08 448.22"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-12",
    points: "79.55 448.22 101.26 409.26 101.79 409.26 80.08 448.22 79.55 448.22"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-407",
    points: "79.01 448.22 100.72 409.26 101.26 409.26 79.55 448.22 79.01 448.22"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-127",
    points: "78.48 448.22 100.19 409.26 100.72 409.26 79.01 448.22 78.48 448.22"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-442",
    points: "77.95 448.22 99.66 409.26 100.19 409.26 78.48 448.22 77.95 448.22"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "77.42 448.22 99.13 409.26 99.66 409.26 77.95 448.22 77.42 448.22"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-305",
    points: "76.89 448.22 98.6 409.26 99.13 409.26 77.42 448.22 76.89 448.22"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-43",
    points: "76.35 448.22 98.06 409.26 98.6 409.26 76.89 448.22 76.35 448.22"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-336",
    points: "75.82 448.22 97.53 409.26 98.06 409.26 76.35 448.22 75.82 448.22"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-292",
    points: "75.29 448.22 97 409.26 97.53 409.26 75.82 448.22 75.29 448.22"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-339",
    points: "74.76 448.22 96.47 409.26 97 409.26 75.29 448.22 74.76 448.22"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-126",
    points: "74.23 448.22 95.93 409.26 96.47 409.26 74.76 448.22 74.23 448.22"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-391",
    points: "73.69 448.22 95.4 409.26 95.93 409.26 74.23 448.22 73.69 448.22"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-14",
    points: "73.16 448.22 94.87 409.26 95.4 409.26 73.69 448.22 73.16 448.22"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-205",
    points: "72.63 448.22 94.34 409.26 94.87 409.26 73.16 448.22 72.63 448.22"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-397",
    points: "72.1 448.22 93.81 409.26 94.34 409.26 72.63 448.22 72.1 448.22"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-172",
    points: "71.56 448.22 93.27 409.26 93.81 409.26 72.1 448.22 71.56 448.22"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-282",
    points: "71.03 448.22 92.74 409.26 93.27 409.26 71.56 448.22 71.03 448.22"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-222",
    points: "70.5 448.22 92.21 409.26 92.74 409.26 71.03 448.22 70.5 448.22"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-319",
    points: "69.97 448.22 91.68 409.26 92.21 409.26 70.5 448.22 69.97 448.22"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-251",
    points: "69.44 448.22 91.15 409.26 91.68 409.26 69.97 448.22 69.44 448.22"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-139",
    points: "68.9 448.22 90.61 409.26 91.15 409.26 69.44 448.22 68.9 448.22"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-19",
    points: "68.37 448.22 90.08 409.26 90.61 409.26 68.9 448.22 68.37 448.22"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-258",
    points: "67.84 448.22 89.55 409.26 90.08 409.26 68.37 448.22 67.84 448.22"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-120",
    points: "67.31 448.22 89.02 409.26 89.55 409.26 67.84 448.22 67.31 448.22"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-345",
    points: "66.78 448.22 88.49 409.26 89.02 409.26 67.31 448.22 66.78 448.22"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-372",
    points: "66.24 448.22 87.95 409.26 88.49 409.26 66.78 448.22 66.24 448.22"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-37",
    points: "65.71 448.22 87.42 409.26 87.95 409.26 66.24 448.22 65.71 448.22"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-241",
    points: "65.18 448.22 86.89 409.26 87.42 409.26 65.71 448.22 65.18 448.22"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-101",
    points: "64.65 448.22 86.36 409.26 86.89 409.26 65.18 448.22 64.65 448.22"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-404",
    points: "64.12 448.22 85.83 409.26 86.36 409.26 64.65 448.22 64.12 448.22"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-131",
    points: "63.58 448.22 85.29 409.26 85.83 409.26 64.12 448.22 63.58 448.22"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-400",
    points: "63.05 448.22 84.76 409.26 85.29 409.26 63.58 448.22 63.05 448.22"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-196",
    points: "62.52 448.22 84.23 409.26 84.76 409.26 63.05 448.22 62.52 448.22"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-210",
    points: "61.99 448.22 83.7 409.26 84.23 409.26 62.52 448.22 61.99 448.22"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-48",
    points: "61.46 448.22 83.16 409.26 83.7 409.26 61.99 448.22 61.46 448.22"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "60.92 448.22 82.63 409.26 83.16 409.26 61.46 448.22 60.92 448.22"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-206",
    points: "60.39 448.22 82.1 409.26 82.63 409.26 60.92 448.22 60.39 448.22"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-206",
    points: "59.86 448.22 81.57 409.26 82.1 409.26 60.39 448.22 59.86 448.22"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-230",
    points: "59.33 448.22 81.04 409.26 81.57 409.26 59.86 448.22 59.33 448.22"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-270",
    points: "58.79 448.22 80.5 409.26 81.04 409.26 59.33 448.22 58.79 448.22"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-270",
    points: "58.26 448.22 79.97 409.26 80.5 409.26 58.79 448.22 58.26 448.22"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-99",
    points: "57.73 448.22 79.44 409.26 79.97 409.26 58.26 448.22 57.73 448.22"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-249",
    points: "57.2 448.22 78.91 409.26 79.44 409.26 57.73 448.22 57.2 448.22"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-249",
    points: "56.67 448.22 78.38 409.26 78.91 409.26 57.2 448.22 56.67 448.22"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-249",
    points: "56.13 448.22 77.84 409.26 78.38 409.26 56.67 448.22 56.13 448.22"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-249",
    points: "77.84 409.26 56.13 448.22 56.09 448.22 56.09 409.26 77.84 409.26"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-452"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-267",
    x: 54.06,
    y: 448.22,
    width: 0.69,
    height: 3.62
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-267",
    x: 54.75,
    y: 448.22,
    width: 0.69,
    height: 3.62
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-267",
    x: 55.44,
    y: 448.22,
    width: 0.69,
    height: 3.62
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-267",
    x: 56.14,
    y: 448.22,
    width: 0.69,
    height: 3.62
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-314",
    x: 56.83,
    y: 448.22,
    width: 0.69,
    height: 3.62
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-318",
    x: 57.52,
    y: 448.22,
    width: 0.69,
    height: 3.62
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-318",
    x: 58.22,
    y: 448.22,
    width: 0.69,
    height: 3.62
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-318",
    x: 58.91,
    y: 448.22,
    width: 0.69,
    height: 3.62
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-171",
    x: 59.6,
    y: 448.22,
    width: 0.69,
    height: 3.62
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-173",
    x: 60.3,
    y: 448.22,
    width: 0.69,
    height: 3.62
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-173",
    x: 60.99,
    y: 448.22,
    width: 0.69,
    height: 3.62
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-396",
    x: 61.68,
    y: 448.22,
    width: 0.69,
    height: 3.62
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-441",
    x: 62.38,
    y: 448.22,
    width: 0.69,
    height: 3.62
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-238",
    x: 63.07,
    y: 448.22,
    width: 0.69,
    height: 3.62
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-302",
    x: 63.76,
    y: 448.22,
    width: 0.69,
    height: 3.62
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-334",
    x: 64.46,
    y: 448.22,
    width: 0.69,
    height: 3.62
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-28",
    x: 65.15,
    y: 448.22,
    width: 0.69,
    height: 3.62
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-155",
    x: 65.85,
    y: 448.22,
    width: 0.69,
    height: 3.62
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-121",
    x: 66.54,
    y: 448.22,
    width: 0.69,
    height: 3.62
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-122",
    x: 67.23,
    y: 448.22,
    width: 0.69,
    height: 3.62
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-239",
    x: 67.93,
    y: 448.22,
    width: 0.69,
    height: 3.62
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-27",
    x: 68.62,
    y: 448.22,
    width: 0.69,
    height: 3.62
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-285",
    x: 69.31,
    y: 448.22,
    width: 0.69,
    height: 3.62
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-103",
    x: 70.01,
    y: 448.22,
    width: 0.69,
    height: 3.62
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-168",
    x: 70.7,
    y: 448.22,
    width: 0.69,
    height: 3.62
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-31",
    x: 71.39,
    y: 448.22,
    width: 0.69,
    height: 3.62
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-440",
    x: 72.09,
    y: 448.22,
    width: 0.69,
    height: 3.62
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-176",
    x: 72.78,
    y: 448.22,
    width: 0.69,
    height: 3.62
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-417",
    x: 73.47,
    y: 448.22,
    width: 0.69,
    height: 3.62
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-390",
    x: 74.17,
    y: 448.22,
    width: 0.69,
    height: 3.62
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-128",
    x: 74.86,
    y: 448.22,
    width: 0.69,
    height: 3.62
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-437",
    x: 75.55,
    y: 448.22,
    width: 0.69,
    height: 3.62
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-295",
    x: 76.25,
    y: 448.22,
    width: 0.69,
    height: 3.62
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-95",
    x: 76.94,
    y: 448.22,
    width: 0.69,
    height: 3.62
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-33",
    x: 77.63,
    y: 448.22,
    width: 0.69,
    height: 3.62
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-308",
    x: 78.33,
    y: 448.22,
    width: 0.69,
    height: 3.62
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-150",
    x: 79.02,
    y: 448.22,
    width: 0.69,
    height: 3.62
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-377",
    x: 79.72,
    y: 448.22,
    width: 0.69,
    height: 3.62
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-347",
    x: 80.41,
    y: 448.22,
    width: 0.69,
    height: 3.62
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-166",
    x: 81.1,
    y: 448.22,
    width: 0.69,
    height: 3.62
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-225",
    x: 81.8,
    y: 448.22,
    width: 0.69,
    height: 3.62
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-271",
    x: 82.49,
    y: 448.22,
    width: 0.69,
    height: 3.62
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-174",
    x: 83.18,
    y: 448.22,
    width: 0.69,
    height: 3.62
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-96",
    x: 83.88,
    y: 448.22,
    width: 0.69,
    height: 3.62
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-283",
    x: 84.57,
    y: 448.22,
    width: 0.69,
    height: 3.62
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-427",
    x: 85.26,
    y: 448.22,
    width: 0.69,
    height: 3.62
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-299",
    x: 85.96,
    y: 448.22,
    width: 0.69,
    height: 3.62
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-34",
    x: 86.65,
    y: 448.22,
    width: 0.69,
    height: 3.62
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-382",
    x: 87.34,
    y: 448.22,
    width: 0.69,
    height: 3.62
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-89",
    x: 88.04,
    y: 448.22,
    width: 0.69,
    height: 3.62
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-65",
    x: 88.73,
    y: 448.22,
    width: 0.69,
    height: 3.62
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-204",
    x: 89.42,
    y: 448.22,
    width: 0.69,
    height: 3.62
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-88",
    x: 90.12,
    y: 448.22,
    width: 0.69,
    height: 3.62
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-365",
    x: 90.81,
    y: 448.22,
    width: 0.69,
    height: 3.62
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-315",
    x: 91.5,
    y: 448.22,
    width: 0.69,
    height: 3.62
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-184",
    x: 92.2,
    y: 448.22,
    width: 0.69,
    height: 3.62
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-201",
    x: 92.89,
    y: 448.22,
    width: 0.69,
    height: 3.62
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-342",
    x: 93.59,
    y: 448.22,
    width: 0.69,
    height: 3.62
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-159",
    x: 94.28,
    y: 448.22,
    width: 0.69,
    height: 3.62
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-154",
    x: 94.97,
    y: 448.22,
    width: 0.69,
    height: 3.62
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-415",
    x: 95.67,
    y: 448.22,
    width: 0.69,
    height: 3.62
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-72",
    x: 96.36,
    y: 448.22,
    width: 0.69,
    height: 3.62
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-265",
    x: 97.05,
    y: 448.22,
    width: 0.69,
    height: 3.62
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-50",
    x: 97.75,
    y: 448.22,
    width: 0.69,
    height: 3.62
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-215",
    x: 98.44,
    y: 448.22,
    width: 0.69,
    height: 3.62
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-244",
    x: 99.13,
    y: 448.22,
    width: 0.69,
    height: 3.62
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-343",
    x: 99.83,
    y: 448.22,
    width: 0.69,
    height: 3.62
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-79",
    x: 100.52,
    y: 448.22,
    width: 0.69,
    height: 3.62
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-41",
    x: 101.21,
    y: 448.22,
    width: 0.69,
    height: 3.62
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-25",
    x: 101.91,
    y: 448.22,
    width: 0.69,
    height: 3.62
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-296",
    x: 102.6,
    y: 448.22,
    width: 0.69,
    height: 3.62
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-9",
    x: 103.29,
    y: 448.22,
    width: 0.69,
    height: 3.62
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-242",
    x: 103.99,
    y: 448.22,
    width: 0.69,
    height: 3.62
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-148",
    x: 104.68,
    y: 448.22,
    width: 0.69,
    height: 3.62
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-90",
    x: 105.38,
    y: 448.22,
    width: 0.69,
    height: 3.62
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-291",
    x: 106.07,
    y: 448.22,
    width: 0.69,
    height: 3.62
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-112",
    x: 106.76,
    y: 448.22,
    width: 0.69,
    height: 3.62
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-12",
    x: 107.46,
    y: 448.22,
    width: 0.69,
    height: 3.62
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-52",
    x: 108.15,
    y: 448.22,
    width: 0.69,
    height: 3.62
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-442",
    x: 108.84,
    y: 448.22,
    width: 0.69,
    height: 3.62
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-218",
    x: 109.54,
    y: 448.22,
    width: 0.69,
    height: 3.62
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-375",
    x: 110.23,
    y: 448.22,
    width: 0.69,
    height: 3.62
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-256",
    x: 110.92,
    y: 448.22,
    width: 0.69,
    height: 3.62
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-82",
    x: 111.62,
    y: 448.22,
    width: 0.69,
    height: 3.62
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-391",
    x: 112.31,
    y: 448.22,
    width: 0.69,
    height: 3.62
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-14",
    x: 113,
    y: 448.22,
    width: 0.69,
    height: 3.62
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-397",
    x: 113.7,
    y: 448.22,
    width: 0.69,
    height: 3.62
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-282",
    x: 114.39,
    y: 448.22,
    width: 0.69,
    height: 3.62
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-319",
    x: 115.08,
    y: 448.22,
    width: 0.69,
    height: 3.62
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-251",
    x: 115.78,
    y: 448.22,
    width: 0.69,
    height: 3.62
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-312",
    x: 116.47,
    y: 448.22,
    width: 0.69,
    height: 3.62
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-345",
    x: 117.16,
    y: 448.22,
    width: 0.69,
    height: 3.62
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-37",
    x: 117.86,
    y: 448.22,
    width: 0.69,
    height: 3.62
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-404",
    x: 118.55,
    y: 448.22,
    width: 0.69,
    height: 3.62
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-400",
    x: 119.25,
    y: 448.22,
    width: 0.69,
    height: 3.62
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-48",
    x: 119.94,
    y: 448.22,
    width: 0.69,
    height: 3.62
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-230",
    x: 120.63,
    y: 448.22,
    width: 0.69,
    height: 3.62
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-249",
    x: 121.33,
    y: 448.22,
    width: 0.69,
    height: 3.62
  })), /*#__PURE__*/React.createElement("circle", {
    className: "cls-223",
    cx: 88.59,
    cy: 429.2,
    r: 2.85
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-272",
    d: "M263.56,23.65v1.93h-3.03v8.12h-2.26v-8.12h-3.03v-1.93h8.32Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-272",
    d: "M268.46,27.98c-.19-.05-.42-.1-.68-.15-.26-.05-.54-.08-.84-.08-.14,0-.3.01-.49.04s-.33.05-.43.08v5.83h-2.16v-7.22c.39-.14.84-.26,1.37-.38.53-.12,1.11-.18,1.76-.18.12,0,.26,0,.42.02.16.01.33.03.49.06.16.02.33.05.49.09.16.03.3.07.42.12l-.36,1.78Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-272",
    d: "M272.34,23.86c0,.4-.13.71-.38.94-.26.23-.56.34-.91.34s-.65-.11-.91-.34c-.26-.23-.38-.54-.38-.94s.13-.71.38-.94.56-.34.91-.34.65.11.91.34.38.54.38.94ZM272.14,33.7h-2.16v-7.63h2.16v7.63Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-272",
    d: "M273.81,29.88c0-.55.09-1.07.27-1.56.18-.49.44-.91.78-1.28.34-.36.75-.65,1.23-.86.48-.21,1.03-.32,1.65-.32.41,0,.78.04,1.12.11.34.07.67.18.99.31l-.45,1.73c-.2-.08-.43-.15-.67-.2-.24-.06-.51-.09-.81-.09-.64,0-1.11.2-1.43.59-.31.4-.47.92-.47,1.57,0,.69.15,1.22.44,1.59.29.38.81.57,1.54.57.26,0,.54-.02.84-.07.3-.05.58-.13.83-.23l.3,1.77c-.25.11-.57.2-.94.28-.38.08-.79.12-1.25.12-.7,0-1.3-.1-1.8-.31-.5-.21-.92-.49-1.24-.85-.32-.36-.56-.78-.71-1.27-.15-.49-.22-1.02-.22-1.59Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-272",
    d: "M283.58,28.81c.21-.23.43-.47.66-.72.23-.25.45-.5.66-.74.21-.25.41-.48.6-.7s.35-.41.49-.58h2.57c-.51.59-1.01,1.15-1.5,1.69s-1.02,1.09-1.6,1.66c.29.26.59.57.9.94.31.36.61.74.9,1.13s.56.77.8,1.16c.24.39.44.74.61,1.06h-2.48c-.16-.25-.33-.53-.53-.84-.2-.31-.41-.61-.63-.92s-.46-.6-.7-.88c-.25-.28-.49-.52-.73-.71v3.34h-2.16v-10.9l2.16-.35v6.36Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-272",
    d: "M288.93,29.94c0-.68.1-1.27.31-1.78s.48-.93.82-1.27c.34-.34.73-.59,1.17-.77.44-.17.89-.26,1.36-.26,1.08,0,1.94.33,2.57.99.63.66.94,1.64.94,2.92,0,.13,0,.26-.01.41,0,.15-.02.28-.03.4h-4.9c.05.44.26.8.62,1.06.37.26.86.39,1.48.39.4,0,.79-.04,1.17-.11.38-.07.69-.16.94-.27l.29,1.75c-.12.06-.27.12-.46.17s-.41.11-.65.15c-.24.04-.49.08-.76.11-.27.03-.54.04-.81.04-.69,0-1.28-.1-1.79-.3-.51-.2-.93-.48-1.26-.83-.33-.35-.58-.77-.74-1.25s-.24-1.01-.24-1.57ZM294.01,29.11c0-.18-.04-.36-.09-.54-.05-.17-.13-.33-.25-.46s-.25-.25-.42-.33c-.17-.09-.38-.13-.63-.13s-.45.04-.62.12c-.17.08-.32.19-.43.33-.12.14-.21.29-.27.47-.06.18-.11.36-.14.54h2.86Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-272",
    d: "M304.49,33.45c-.19.06-.42.11-.67.17-.25.05-.51.1-.79.14-.28.04-.56.07-.84.09-.29.02-.56.04-.82.04-.63,0-1.19-.09-1.68-.28s-.91-.45-1.25-.79c-.34-.34-.6-.76-.78-1.25-.18-.49-.27-1.04-.27-1.65s.08-1.18.23-1.67c.15-.5.38-.92.67-1.27.29-.35.64-.61,1.07-.8.42-.18.9-.28,1.44-.28.3,0,.57.03.81.09.24.06.48.14.72.25v-3.45l2.16-.35v11.01ZM299.6,29.82c0,.67.15,1.2.45,1.61.3.41.74.61,1.33.61.19,0,.37,0,.54-.02.16-.01.3-.03.41-.05v-3.93c-.14-.09-.31-.16-.53-.22-.22-.06-.44-.09-.66-.09-1.02,0-1.54.7-1.54,2.09Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-272",
    d: "M312.36,23.86c0,.4-.13.71-.38.94-.26.23-.56.34-.91.34s-.65-.11-.91-.34c-.26-.23-.38-.54-.38-.94s.13-.71.38-.94.56-.34.91-.34.65.11.91.34.38.54.38.94ZM312.16,33.7h-2.16v-7.63h2.16v7.63Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-272",
    d: "M314.19,26.33c.37-.11.84-.21,1.42-.3.58-.09,1.19-.14,1.83-.14s1.19.08,1.62.25c.43.17.77.41,1.02.72.25.31.43.68.54,1.1s.16.9.16,1.42v4.31h-2.16v-4.05c0-.7-.09-1.19-.28-1.48s-.53-.44-1.03-.44c-.16,0-.32,0-.49.02-.17.01-.33.03-.46.05v5.89h-2.16v-7.37Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-272",
    d: "M322.66,24.17l2.16-.35v2.25h2.6v1.8h-2.6v2.68c0,.45.08.82.24,1.09.16.27.48.41.96.41.23,0,.47-.02.72-.07.25-.04.47-.1.67-.18l.3,1.68c-.26.11-.55.2-.87.28-.32.08-.71.12-1.17.12-.59,0-1.08-.08-1.46-.24-.39-.16-.7-.38-.93-.67-.23-.28-.39-.63-.49-1.04-.09-.41-.14-.86-.14-1.35v-6.41Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-272",
    d: "M336.01,29.87c0,.6-.09,1.15-.26,1.65-.17.5-.42.92-.75,1.28-.33.35-.72.63-1.18.82s-.97.29-1.54.29-1.07-.1-1.53-.29-.85-.47-1.18-.82c-.33-.35-.58-.78-.77-1.28s-.28-1.05-.28-1.65.09-1.15.28-1.64c.19-.49.45-.91.78-1.26.33-.35.73-.62,1.19-.81s.96-.29,1.5-.29,1.06.1,1.51.29.85.46,1.18.81c.33.35.58.77.77,1.26.18.49.28,1.04.28,1.64ZM333.81,29.87c0-.67-.13-1.19-.4-1.57-.27-.38-.64-.57-1.14-.57s-.88.19-1.15.57-.41.91-.41,1.57.14,1.2.41,1.59.65.59,1.15.59.87-.2,1.14-.59c.27-.39.4-.92.4-1.59Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-272",
    d: "M340.8,29.88c0-.55.09-1.07.27-1.56.18-.49.44-.91.78-1.28.34-.36.75-.65,1.23-.86.48-.21,1.03-.32,1.65-.32.41,0,.78.04,1.12.11.34.07.67.18.99.31l-.45,1.73c-.2-.08-.43-.15-.67-.2-.24-.06-.51-.09-.81-.09-.64,0-1.11.2-1.43.59-.31.4-.47.92-.47,1.57,0,.69.15,1.22.44,1.59.29.38.81.57,1.54.57.26,0,.54-.02.84-.07.3-.05.58-.13.83-.23l.3,1.77c-.25.11-.57.2-.94.28-.38.08-.79.12-1.25.12-.7,0-1.3-.1-1.8-.31-.5-.21-.92-.49-1.24-.85-.32-.36-.56-.78-.71-1.27-.15-.49-.22-1.02-.22-1.59Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-272",
    d: "M351.45,33.84c-.63,0-1.14-.08-1.53-.2s-.7-.3-.93-.53c-.23-.23-.38-.5-.46-.83-.08-.32-.12-.69-.12-1.09v-8.4l2.16-.35v8.31c0,.19.01.37.04.52.03.15.08.29.17.39s.2.19.36.26c.15.07.36.11.62.13l-.3,1.78Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-272",
    d: "M355.35,23.86c0,.4-.13.71-.38.94-.26.23-.56.34-.91.34s-.65-.11-.91-.34c-.26-.23-.38-.54-.38-.94s.13-.71.38-.94.56-.34.91-.34.65.11.91.34.38.54.38.94ZM355.15,33.7h-2.16v-7.63h2.16v7.63Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-272",
    d: "M356.82,29.88c0-.55.09-1.07.27-1.56.18-.49.44-.91.78-1.28.34-.36.75-.65,1.23-.86.48-.21,1.03-.32,1.65-.32.41,0,.78.04,1.12.11.34.07.67.18.99.31l-.45,1.73c-.2-.08-.43-.15-.67-.2-.24-.06-.51-.09-.81-.09-.64,0-1.11.2-1.43.59-.31.4-.47.92-.47,1.57,0,.69.15,1.22.44,1.59.29.38.81.57,1.54.57.26,0,.54-.02.84-.07.3-.05.58-.13.83-.23l.3,1.77c-.25.11-.57.2-.94.28-.38.08-.79.12-1.25.12-.7,0-1.3-.1-1.8-.31-.5-.21-.92-.49-1.24-.85-.32-.36-.56-.78-.71-1.27-.15-.49-.22-1.02-.22-1.59Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-272",
    d: "M366.59,28.81c.21-.23.43-.47.66-.72.23-.25.45-.5.66-.74.21-.25.41-.48.6-.7s.35-.41.49-.58h2.57c-.51.59-1.01,1.15-1.5,1.69s-1.02,1.09-1.6,1.66c.29.26.59.57.9.94.31.36.61.74.9,1.13s.56.77.8,1.16c.24.39.44.74.61,1.06h-2.48c-.16-.25-.33-.53-.53-.84-.2-.31-.41-.61-.63-.92s-.46-.6-.7-.88c-.25-.28-.49-.52-.73-.71v3.34h-2.16v-10.9l2.16-.35v6.36Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-272",
    d: "M375.19,23.86c0,.4-.13.71-.38.94-.26.23-.56.34-.91.34s-.65-.11-.91-.34c-.26-.23-.38-.54-.38-.94s.13-.71.38-.94.56-.34.91-.34.65.11.91.34.38.54.38.94ZM374.99,33.7h-2.16v-7.63h2.16v7.63Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-272",
    d: "M377.02,26.33c.37-.11.84-.21,1.42-.3.58-.09,1.19-.14,1.83-.14s1.19.08,1.62.25c.43.17.77.41,1.02.72.25.31.43.68.54,1.1s.16.9.16,1.42v4.31h-2.16v-4.05c0-.7-.09-1.19-.28-1.48s-.53-.44-1.03-.44c-.16,0-.32,0-.49.02-.17.01-.33.03-.46.05v5.89h-2.16v-7.37Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-272",
    d: "M392.14,32.74c0,1.25-.32,2.17-.95,2.78-.63.6-1.61.91-2.94.91-.46,0-.93-.04-1.39-.12s-.89-.19-1.29-.33l.38-1.81c.34.14.69.24,1.07.32.37.08.79.12,1.27.12.62,0,1.06-.14,1.31-.41.26-.27.38-.62.38-1.04v-.28c-.23.11-.47.19-.72.24-.25.05-.51.08-.8.08-1.05,0-1.86-.31-2.42-.94s-.84-1.5-.84-2.62c0-.56.09-1.07.26-1.53.17-.46.43-.85.76-1.18.33-.33.74-.58,1.23-.76.48-.18,1.03-.27,1.64-.27.26,0,.53.01.81.04.28.02.55.06.82.09s.53.08.78.14c.25.05.47.11.66.17v6.41ZM387.4,29.64c0,1.21.49,1.81,1.46,1.81.22,0,.43-.03.62-.09s.36-.13.49-.2v-3.45c-.11-.02-.23-.04-.38-.05-.14-.01-.31-.02-.51-.02-.57,0-1,.19-1.28.57-.28.38-.42.86-.42,1.44Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-272",
    d: "M400.39,25.87c.64,0,1.17.07,1.59.22.42.15.77.35,1.02.62.26.27.44.6.54.99.11.39.16.82.16,1.29v4.5c-.31.07-.74.15-1.29.24-.55.09-1.22.14-2,.14-.49,0-.94-.04-1.34-.13-.4-.09-.75-.23-1.04-.43-.29-.2-.51-.46-.67-.78-.15-.32-.23-.71-.23-1.17s.09-.82.27-1.13c.18-.31.42-.56.72-.74.3-.18.64-.32,1.03-.4.39-.08.79-.12,1.2-.12.28,0,.53.01.75.04.22.02.39.06.53.09v-.2c0-.37-.11-.66-.33-.88-.22-.22-.61-.33-1.16-.33-.37,0-.73.03-1.09.08-.36.05-.67.13-.93.22l-.28-1.74c.13-.04.28-.08.47-.12s.39-.08.62-.12c.22-.03.46-.06.7-.09.25-.02.5-.04.75-.04ZM400.57,32.19c.21,0,.42,0,.61-.01s.35-.02.46-.04v-1.64c-.09-.02-.22-.04-.39-.06-.17-.02-.33-.03-.48-.03-.2,0-.39.01-.57.04-.18.02-.34.07-.47.14s-.24.16-.32.28c-.08.12-.12.26-.12.43,0,.34.11.57.34.7.23.13.54.2.94.2Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-272",
    d: "M412.19,33.84c-.63,0-1.14-.08-1.53-.2s-.7-.3-.93-.53c-.23-.23-.38-.5-.46-.83-.08-.32-.12-.69-.12-1.09v-8.4l2.16-.35v8.31c0,.19.01.37.04.52.03.15.08.29.17.39s.2.19.36.26c.15.07.36.11.62.13l-.3,1.78Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-272",
    d: "M416.09,23.86c0,.4-.13.71-.38.94-.26.23-.56.34-.91.34s-.65-.11-.91-.34c-.26-.23-.38-.54-.38-.94s.13-.71.38-.94.56-.34.91-.34.65.11.91.34.38.54.38.94ZM415.89,33.7h-2.16v-7.63h2.16v7.63Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-272",
    d: "M417.92,26.33c.37-.11.84-.21,1.42-.3.58-.09,1.19-.14,1.83-.14s1.19.08,1.62.25c.43.17.77.41,1.02.72.25.31.43.68.54,1.1s.16.9.16,1.42v4.31h-2.16v-4.05c0-.7-.09-1.19-.28-1.48s-.53-.44-1.03-.44c-.16,0-.32,0-.49.02-.17.01-.33.03-.46.05v5.89h-2.16v-7.37Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-272",
    d: "M428.62,28.81c.21-.23.43-.47.66-.72.23-.25.45-.5.66-.74.21-.25.41-.48.6-.7s.35-.41.49-.58h2.57c-.51.59-1.01,1.15-1.5,1.69s-1.02,1.09-1.6,1.66c.29.26.59.57.9.94.31.36.61.74.9,1.13s.56.77.8,1.16c.24.39.44.74.61,1.06h-2.48c-.16-.25-.33-.53-.53-.84-.2-.31-.41-.61-.63-.92s-.46-.6-.7-.88c-.25-.28-.49-.52-.73-.71v3.34h-2.16v-10.9l2.16-.35v6.36Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-272",
    d: "M440.7,23.86c0,.4-.13.71-.38.94-.26.23-.56.34-.91.34s-.65-.11-.91-.34c-.26-.23-.38-.54-.38-.94s.13-.71.38-.94.56-.34.91-.34.65.11.91.34.38.54.38.94ZM440.5,33.7h-2.16v-7.63h2.16v7.63Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-272",
    d: "M442.53,26.33c.37-.11.84-.21,1.42-.3.58-.09,1.19-.14,1.83-.14s1.19.08,1.62.25c.43.17.77.41,1.02.72.25.31.43.68.54,1.1s.16.9.16,1.42v4.31h-2.16v-4.05c0-.7-.09-1.19-.28-1.48s-.53-.44-1.03-.44c-.16,0-.32,0-.49.02-.17.01-.33.03-.46.05v5.89h-2.16v-7.37Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-272",
    d: "M454.47,24.17l2.16-.35v2.25h2.6v1.8h-2.6v2.68c0,.45.08.82.24,1.09.16.27.48.41.96.41.23,0,.47-.02.72-.07.25-.04.47-.1.67-.18l.3,1.68c-.26.11-.55.2-.87.28-.32.08-.71.12-1.17.12-.59,0-1.08-.08-1.46-.24-.39-.16-.7-.38-.93-.67-.23-.28-.39-.63-.49-1.04-.09-.41-.14-.86-.14-1.35v-6.41Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-272",
    d: "M460.98,33.7v-10.9l2.16-.35v3.65c.14-.05.33-.09.56-.14.23-.04.45-.07.66-.07.62,0,1.13.08,1.54.25.41.17.74.41.99.72.25.31.42.68.52,1.1.1.43.15.9.15,1.42v4.31h-2.16v-4.05c0-.7-.09-1.19-.27-1.48s-.51-.44-.99-.44c-.19,0-.37.02-.54.05-.17.03-.32.07-.46.11v5.8h-2.16Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-272",
    d: "M469.16,29.94c0-.68.1-1.27.31-1.78s.48-.93.82-1.27c.34-.34.73-.59,1.17-.77.44-.17.89-.26,1.36-.26,1.08,0,1.94.33,2.57.99.63.66.94,1.64.94,2.92,0,.13,0,.26-.01.41,0,.15-.02.28-.03.4h-4.9c.05.44.26.8.62,1.06.37.26.86.39,1.48.39.4,0,.79-.04,1.17-.11.38-.07.69-.16.94-.27l.29,1.75c-.12.06-.27.12-.46.17s-.41.11-.65.15c-.24.04-.49.08-.76.11-.27.03-.54.04-.81.04-.69,0-1.28-.1-1.79-.3-.51-.2-.93-.48-1.26-.83-.33-.35-.58-.77-.74-1.25s-.24-1.01-.24-1.57ZM474.24,29.11c0-.18-.04-.36-.09-.54-.05-.17-.13-.33-.25-.46s-.25-.25-.42-.33c-.17-.09-.38-.13-.63-.13s-.45.04-.62.12c-.17.08-.32.19-.43.33-.12.14-.21.29-.27.47-.06.18-.11.36-.14.54h2.86Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-272",
    d: "M481.11,29.94c0-.68.1-1.27.31-1.78s.48-.93.82-1.27c.34-.34.73-.59,1.17-.77.44-.17.89-.26,1.36-.26,1.08,0,1.94.33,2.57.99.63.66.94,1.64.94,2.92,0,.13,0,.26-.01.41,0,.15-.02.28-.03.4h-4.9c.05.44.26.8.62,1.06.37.26.86.39,1.48.39.4,0,.79-.04,1.17-.11.38-.07.69-.16.94-.27l.29,1.75c-.12.06-.27.12-.46.17s-.41.11-.65.15c-.24.04-.49.08-.76.11-.27.03-.54.04-.81.04-.69,0-1.28-.1-1.79-.3-.51-.2-.93-.48-1.26-.83-.33-.35-.58-.77-.74-1.25s-.24-1.01-.24-1.57ZM486.19,29.11c0-.18-.04-.36-.09-.54-.05-.17-.13-.33-.25-.46s-.25-.25-.42-.33c-.17-.09-.38-.13-.63-.13s-.45.04-.62.12c-.17.08-.32.19-.43.33-.12.14-.21.29-.27.47-.06.18-.11.36-.14.54h2.86Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-272",
    d: "M494.13,29.65c0-.7-.09-1.19-.27-1.48s-.49-.44-.92-.44c-.14,0-.28,0-.42.02-.14.01-.29.03-.42.05v5.89h-2.16v-7.37c.18-.05.4-.1.65-.15.25-.05.51-.1.78-.15.28-.04.56-.08.85-.1.29-.02.57-.04.86-.04.55,0,1,.07,1.34.21s.63.31.85.5c.31-.22.66-.4,1.07-.52.4-.13.77-.19,1.11-.19.61,0,1.11.08,1.5.25.39.17.7.41.93.72.23.31.39.68.48,1.1s.13.9.13,1.42v4.31h-2.16v-4.05c0-.7-.09-1.19-.27-1.48s-.49-.44-.92-.44c-.12,0-.28.03-.49.09-.21.06-.38.13-.51.22.07.22.11.46.13.7s.03.51.03.79v4.16h-2.16v-4.05Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-272",
    d: "M505.18,25.87c.64,0,1.17.07,1.59.22.42.15.77.35,1.02.62.26.27.44.6.54.99.11.39.16.82.16,1.29v4.5c-.31.07-.74.15-1.29.24-.55.09-1.22.14-2,.14-.49,0-.94-.04-1.34-.13-.4-.09-.75-.23-1.04-.43-.29-.2-.51-.46-.67-.78-.15-.32-.23-.71-.23-1.17s.09-.82.27-1.13c.18-.31.42-.56.72-.74.3-.18.64-.32,1.03-.4.39-.08.79-.12,1.2-.12.28,0,.53.01.75.04.22.02.39.06.53.09v-.2c0-.37-.11-.66-.33-.88-.22-.22-.61-.33-1.16-.33-.37,0-.73.03-1.09.08-.36.05-.67.13-.93.22l-.28-1.74c.13-.04.28-.08.47-.12s.39-.08.62-.12c.22-.03.46-.06.7-.09.25-.02.5-.04.75-.04ZM505.36,32.19c.21,0,.42,0,.61-.01s.35-.02.46-.04v-1.64c-.09-.02-.22-.04-.39-.06-.17-.02-.33-.03-.48-.03-.2,0-.39.01-.57.04-.18.02-.34.07-.47.14s-.24.16-.32.28c-.08.12-.12.26-.12.43,0,.34.11.57.34.7.23.13.54.2.94.2Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-272",
    d: "M512.82,23.86c0,.4-.13.71-.38.94-.26.23-.56.34-.91.34s-.65-.11-.91-.34c-.26-.23-.38-.54-.38-.94s.13-.71.38-.94.56-.34.91-.34.65.11.91.34.38.54.38.94ZM512.62,33.7h-2.16v-7.63h2.16v7.63Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-272",
    d: "M517.69,33.84c-.63,0-1.14-.08-1.53-.2s-.7-.3-.93-.53c-.23-.23-.38-.5-.46-.83-.08-.32-.12-.69-.12-1.09v-8.4l2.16-.35v8.31c0,.19.01.37.04.52.03.15.08.29.17.39s.2.19.36.26c.15.07.36.11.62.13l-.3,1.78Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-272",
    d: "M647.15,311.46c-.4-.84-.79-1.72-1.18-2.63-.39-.91-.76-1.81-1.11-2.69-.35-.89-.67-1.74-.96-2.55-.29-.81-.55-1.54-.76-2.17h2.49c.19.58.4,1.21.63,1.88.23.67.46,1.34.7,2.01.24.67.47,1.3.69,1.92s.43,1.14.63,1.58c.19-.44.4-.97.62-1.58s.46-1.25.69-1.91c.24-.67.47-1.33.7-2.01s.44-1.3.63-1.88h2.41c-.23.64-.48,1.37-.78,2.18s-.61,1.66-.96,2.55c-.35.89-.72,1.79-1.1,2.7-.39.91-.78,1.78-1.18,2.62h-2.16Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-272",
    d: "M656.84,301.63c0,.4-.13.71-.38.94s-.56.34-.91.34-.65-.11-.91-.34-.38-.54-.38-.94.13-.71.38-.93c.26-.23.56-.34.91-.34s.65.11.91.34c.26.23.38.54.38.93ZM656.63,311.46h-2.16v-7.63h2.16v7.63Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-272",
    d: "M658.3,307.65c0-.55.09-1.07.27-1.56s.44-.91.78-1.28c.34-.36.75-.65,1.23-.86s1.03-.32,1.65-.32c.41,0,.78.04,1.12.11.34.07.67.18.99.31l-.45,1.73c-.2-.08-.43-.15-.67-.2-.24-.06-.51-.09-.81-.09-.64,0-1.11.2-1.43.59-.31.4-.47.92-.47,1.57,0,.69.15,1.22.44,1.59s.81.57,1.54.57c.26,0,.54-.02.84-.07.3-.05.58-.12.83-.23l.3,1.77c-.25.11-.57.2-.94.28-.38.08-.79.12-1.25.12-.7,0-1.3-.1-1.8-.31-.5-.21-.92-.49-1.24-.85-.32-.36-.56-.78-.71-1.27-.15-.49-.22-1.02-.22-1.59Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-272",
    d: "M665.84,301.94l2.16-.35v2.25h2.6v1.8h-2.6v2.68c0,.45.08.82.24,1.09.16.27.48.41.96.41.23,0,.47-.02.72-.07.25-.04.47-.1.67-.18l.3,1.68c-.26.11-.55.2-.87.28-.32.08-.71.12-1.17.12-.59,0-1.08-.08-1.46-.24-.39-.16-.7-.38-.93-.67-.23-.29-.39-.63-.49-1.04-.09-.41-.14-.86-.14-1.35v-6.41Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-272",
    d: "M674.72,301.63c0,.4-.13.71-.38.94s-.56.34-.91.34-.65-.11-.91-.34-.38-.54-.38-.94.13-.71.38-.93c.26-.23.56-.34.91-.34s.65.11.91.34c.26.23.38.54.38.93ZM674.51,311.46h-2.16v-7.63h2.16v7.63Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-272",
    d: "M680.73,307.42c0-.7-.09-1.19-.27-1.48s-.49-.44-.92-.44c-.14,0-.28,0-.42.02-.14.01-.29.03-.42.05v5.89h-2.16v-7.37c.18-.05.4-.1.65-.15.25-.05.51-.1.78-.14.28-.04.56-.08.85-.1.29-.02.57-.04.86-.04.55,0,1,.07,1.34.21.34.14.63.31.85.5.31-.22.66-.4,1.07-.52s.77-.19,1.11-.19c.61,0,1.11.08,1.5.25.39.17.7.41.93.72.23.31.39.68.48,1.1.09.43.13.9.13,1.42v4.31h-2.16v-4.05c0-.7-.09-1.19-.27-1.48s-.49-.44-.92-.44c-.12,0-.28.03-.49.09-.21.06-.38.13-.51.22.07.22.11.46.13.7.02.25.03.51.03.79v4.16h-2.16v-4.05Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-272",
    d: "M699.03,311.2c-.37.11-.84.21-1.42.3s-1.19.14-1.83.14-1.19-.09-1.62-.26c-.43-.17-.77-.42-1.02-.73-.25-.31-.43-.69-.54-1.12-.11-.43-.16-.91-.16-1.44v-4.25h2.16v3.99c0,.7.09,1.2.28,1.51.18.31.53.46,1.03.46.15,0,.32,0,.49-.02.17-.01.33-.03.46-.05v-5.89h2.16v7.37Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-272",
    d: "M703.25,309.91c.4,0,.68-.04.84-.12.16-.08.25-.23.25-.45,0-.17-.11-.33-.32-.46-.21-.13-.54-.28-.97-.44-.34-.13-.65-.26-.92-.39-.28-.14-.51-.3-.7-.49-.19-.19-.34-.41-.45-.67s-.16-.58-.16-.94c0-.72.27-1.28.8-1.7.53-.42,1.26-.62,2.19-.62.46,0,.91.04,1.33.12.42.08.76.17,1.01.27l-.38,1.68c-.25-.09-.52-.16-.82-.23s-.63-.1-.99-.1c-.68,0-1.01.19-1.01.57,0,.09.01.16.04.23.03.07.09.13.17.2s.21.13.36.2.34.15.57.24c.47.17.86.35,1.17.52.31.17.55.35.73.55.18.2.3.42.38.66s.11.52.11.84c0,.75-.28,1.32-.85,1.71s-1.37.58-2.4.58c-.68,0-1.24-.06-1.69-.17-.45-.12-.76-.21-.94-.29l.36-1.75c.37.15.74.26,1.13.34s.77.12,1.15.12Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-272",
    d: "M707.73,307.71c0-.68.1-1.27.31-1.78.21-.51.48-.93.82-1.27.34-.34.73-.59,1.17-.77.44-.17.89-.26,1.36-.26,1.08,0,1.94.33,2.57.99.63.66.94,1.64.94,2.92,0,.13,0,.26-.01.41,0,.15-.02.28-.03.4h-4.9c.05.44.26.8.62,1.06.37.26.86.39,1.48.39.4,0,.79-.04,1.17-.11s.69-.16.94-.27l.29,1.75c-.12.06-.27.12-.46.17s-.41.11-.65.15c-.24.04-.49.08-.76.11-.27.03-.54.04-.81.04-.69,0-1.28-.1-1.79-.3-.51-.2-.93-.48-1.26-.83-.33-.35-.58-.77-.74-1.25s-.24-1-.24-1.57ZM712.81,306.88c0-.18-.04-.36-.09-.54-.05-.17-.13-.33-.25-.46-.11-.13-.25-.25-.42-.33-.17-.09-.38-.13-.63-.13s-.45.04-.62.12-.32.19-.43.33c-.12.13-.21.29-.27.47-.06.18-.11.36-.14.54h2.86Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-272",
    d: "M721.16,305.75c-.19-.05-.42-.1-.68-.15-.26-.05-.54-.08-.84-.08-.14,0-.3.01-.49.04-.19.02-.33.05-.43.08v5.83h-2.16v-7.22c.39-.14.84-.26,1.37-.38.53-.12,1.11-.18,1.76-.18.12,0,.26,0,.42.02s.33.03.49.06c.16.02.33.05.49.09.16.03.3.08.42.12l-.36,1.78Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-272",
    d: "M733.3,307.64c0,.6-.09,1.15-.26,1.65-.17.5-.42.92-.75,1.28-.33.35-.72.63-1.18.82s-.97.29-1.54.29-1.07-.1-1.53-.29-.85-.47-1.18-.82c-.33-.35-.58-.78-.77-1.28-.18-.5-.28-1.05-.28-1.65s.09-1.15.28-1.64.45-.91.78-1.26c.33-.35.73-.62,1.19-.81s.96-.29,1.5-.29,1.06.1,1.51.29.85.46,1.18.81c.33.35.58.77.77,1.26.18.49.28,1.04.28,1.64ZM731.09,307.64c0-.67-.13-1.19-.4-1.57-.27-.38-.64-.57-1.14-.57s-.88.19-1.15.57-.41.91-.41,1.57.14,1.2.41,1.59.65.59,1.15.59.87-.2,1.14-.59c.27-.39.4-.92.4-1.59Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-272",
    d: "M742.05,307.65c0,.59-.07,1.13-.22,1.61-.14.48-.36.9-.64,1.25s-.63.62-1.04.81c-.42.19-.89.29-1.44.29-.3,0-.58-.03-.84-.09-.26-.06-.51-.14-.75-.25v2.87h-2.16v-10.05c.19-.06.42-.11.67-.17.25-.05.51-.1.79-.14.28-.04.56-.07.84-.09s.56-.04.82-.04c.63,0,1.19.09,1.68.28s.91.46,1.25.8c.34.34.6.76.78,1.25s.27,1.04.27,1.65ZM739.85,307.71c0-.67-.15-1.2-.45-1.6-.3-.4-.74-.6-1.33-.6-.19,0-.37,0-.54.02-.16.01-.3.03-.41.05v3.9c.13.09.31.16.53.22.22.06.44.09.66.09,1.02,0,1.54-.69,1.54-2.07Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-272",
    d: "M743.36,307.71c0-.68.1-1.27.31-1.78.21-.51.48-.93.82-1.27.34-.34.73-.59,1.17-.77.44-.17.89-.26,1.36-.26,1.08,0,1.94.33,2.57.99.63.66.94,1.64.94,2.92,0,.13,0,.26-.01.41,0,.15-.02.28-.03.4h-4.9c.05.44.26.8.62,1.06.37.26.86.39,1.48.39.4,0,.79-.04,1.17-.11s.69-.16.94-.27l.29,1.75c-.12.06-.27.12-.46.17s-.41.11-.65.15c-.24.04-.49.08-.76.11-.27.03-.54.04-.81.04-.69,0-1.28-.1-1.79-.3-.51-.2-.93-.48-1.26-.83-.33-.35-.58-.77-.74-1.25s-.24-1-.24-1.57ZM748.43,306.88c0-.18-.04-.36-.09-.54-.05-.17-.13-.33-.25-.46-.11-.13-.25-.25-.42-.33-.17-.09-.38-.13-.63-.13s-.45.04-.62.12-.32.19-.43.33c-.12.13-.21.29-.27.47-.06.18-.11.36-.14.54h2.86Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-272",
    d: "M752.19,304.1c.37-.11.84-.21,1.42-.3.58-.09,1.19-.14,1.83-.14s1.19.08,1.62.25c.43.17.77.41,1.02.72.25.31.43.68.54,1.1.11.43.16.9.16,1.42v4.31h-2.16v-4.05c0-.7-.09-1.19-.28-1.48s-.53-.44-1.03-.44c-.16,0-.32,0-.49.02s-.33.03-.46.05v5.89h-2.16v-7.37Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-272",
    d: "M762.92,309.91c.4,0,.68-.04.84-.12.16-.08.25-.23.25-.45,0-.17-.11-.33-.32-.46-.21-.13-.54-.28-.97-.44-.34-.13-.65-.26-.92-.39-.28-.14-.51-.3-.7-.49-.19-.19-.34-.41-.45-.67s-.16-.58-.16-.94c0-.72.27-1.28.8-1.7.53-.42,1.26-.62,2.19-.62.46,0,.91.04,1.33.12.42.08.76.17,1.01.27l-.38,1.68c-.25-.09-.52-.16-.82-.23s-.63-.1-.99-.1c-.68,0-1.01.19-1.01.57,0,.09.01.16.04.23.03.07.09.13.17.2s.21.13.36.2.34.15.57.24c.47.17.86.35,1.17.52.31.17.55.35.73.55.18.2.3.42.38.66s.11.52.11.84c0,.75-.28,1.32-.85,1.71s-1.37.58-2.4.58c-.68,0-1.24-.06-1.69-.17-.45-.12-.76-.21-.94-.29l.36-1.75c.37.15.74.26,1.13.34s.77.12,1.15.12Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-272",
    d: "M771.17,301.94l2.16-.35v2.25h2.6v1.8h-2.6v2.68c0,.45.08.82.24,1.09.16.27.48.41.96.41.23,0,.47-.02.72-.07.25-.04.47-.1.67-.18l.3,1.68c-.26.11-.55.2-.87.28-.32.08-.71.12-1.17.12-.59,0-1.08-.08-1.46-.24-.39-.16-.7-.38-.93-.67-.23-.29-.39-.63-.49-1.04-.09-.41-.14-.86-.14-1.35v-6.41Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-272",
    d: "M777.68,311.46v-10.9l2.16-.35v3.65c.14-.05.33-.09.56-.14.23-.04.45-.07.66-.07.62,0,1.13.08,1.54.25.41.17.74.41.99.72.25.31.42.68.52,1.1.1.43.15.9.15,1.42v4.31h-2.16v-4.05c0-.7-.09-1.19-.27-1.48s-.51-.44-.99-.44c-.19,0-.37.02-.54.05-.17.03-.32.07-.46.11v5.8h-2.16Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-272",
    d: "M785.86,307.71c0-.68.1-1.27.31-1.78.21-.51.48-.93.82-1.27.34-.34.73-.59,1.17-.77.44-.17.89-.26,1.36-.26,1.08,0,1.94.33,2.57.99.63.66.94,1.64.94,2.92,0,.13,0,.26-.01.41,0,.15-.02.28-.03.4h-4.9c.05.44.26.8.62,1.06.37.26.86.39,1.48.39.4,0,.79-.04,1.17-.11s.69-.16.94-.27l.29,1.75c-.12.06-.27.12-.46.17s-.41.11-.65.15c-.24.04-.49.08-.76.11-.27.03-.54.04-.81.04-.69,0-1.28-.1-1.79-.3-.51-.2-.93-.48-1.26-.83-.33-.35-.58-.77-.74-1.25s-.24-1-.24-1.57ZM790.93,306.88c0-.18-.04-.36-.09-.54-.05-.17-.13-.33-.25-.46-.11-.13-.25-.25-.42-.33-.17-.09-.38-.13-.63-.13s-.45.04-.62.12-.32.19-.43.33c-.12.13-.21.29-.27.47-.06.18-.11.36-.14.54h2.86Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-272",
    d: "M797.8,307.71c0-.68.1-1.27.31-1.78.21-.51.48-.93.82-1.27.34-.34.73-.59,1.17-.77.44-.17.89-.26,1.36-.26,1.08,0,1.94.33,2.57.99.63.66.94,1.64.94,2.92,0,.13,0,.26-.01.41,0,.15-.02.28-.03.4h-4.9c.05.44.26.8.62,1.06.37.26.86.39,1.48.39.4,0,.79-.04,1.17-.11s.69-.16.94-.27l.29,1.75c-.12.06-.27.12-.46.17s-.41.11-.65.15c-.24.04-.49.08-.76.11-.27.03-.54.04-.81.04-.69,0-1.28-.1-1.79-.3-.51-.2-.93-.48-1.26-.83-.33-.35-.58-.77-.74-1.25s-.24-1-.24-1.57ZM802.88,306.88c0-.18-.04-.36-.09-.54-.05-.17-.13-.33-.25-.46-.11-.13-.25-.25-.42-.33-.17-.09-.38-.13-.63-.13s-.45.04-.62.12-.32.19-.43.33c-.12.13-.21.29-.27.47-.06.18-.11.36-.14.54h2.86Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-272",
    d: "M810.83,307.42c0-.7-.09-1.19-.27-1.48s-.49-.44-.92-.44c-.14,0-.28,0-.42.02-.14.01-.29.03-.42.05v5.89h-2.16v-7.37c.18-.05.4-.1.65-.15.25-.05.51-.1.78-.14.28-.04.56-.08.85-.1.29-.02.57-.04.86-.04.55,0,1,.07,1.34.21.34.14.63.31.85.5.31-.22.66-.4,1.07-.52s.77-.19,1.11-.19c.61,0,1.11.08,1.5.25.39.17.7.41.93.72.23.31.39.68.48,1.1.09.43.13.9.13,1.42v4.31h-2.16v-4.05c0-.7-.09-1.19-.27-1.48s-.49-.44-.92-.44c-.12,0-.28.03-.49.09-.21.06-.38.13-.51.22.07.22.11.46.13.7.02.25.03.51.03.79v4.16h-2.16v-4.05Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-272",
    d: "M821.87,303.63c.64,0,1.17.07,1.59.22.42.14.77.35,1.02.62.26.27.44.6.54.99.11.39.16.82.16,1.29v4.5c-.31.07-.74.15-1.29.24-.55.09-1.22.14-2,.14-.49,0-.94-.04-1.34-.13s-.75-.23-1.04-.43-.51-.46-.67-.78c-.15-.32-.23-.71-.23-1.17s.09-.82.27-1.13c.18-.31.42-.56.72-.74s.64-.32,1.03-.4c.39-.08.79-.12,1.2-.12.28,0,.53.01.75.04.22.02.39.06.53.09v-.2c0-.37-.11-.66-.33-.88s-.61-.33-1.16-.33c-.37,0-.73.03-1.09.08-.36.05-.67.13-.93.22l-.28-1.74c.13-.04.28-.08.47-.12s.39-.08.62-.12c.22-.03.46-.06.7-.09.25-.02.5-.04.75-.04ZM822.05,309.96c.21,0,.42,0,.61-.01s.35-.02.46-.04v-1.64c-.09-.02-.22-.04-.39-.06s-.33-.03-.48-.03c-.2,0-.39.01-.57.04-.18.02-.34.07-.47.14-.14.07-.24.16-.32.28s-.12.26-.12.43c0,.34.11.57.34.7.23.13.54.2.94.2Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-272",
    d: "M829.52,301.63c0,.4-.13.71-.38.94s-.56.34-.91.34-.65-.11-.91-.34-.38-.54-.38-.94.13-.71.38-.93c.26-.23.56-.34.91-.34s.65.11.91.34c.26.23.38.54.38.93ZM829.31,311.46h-2.16v-7.63h2.16v7.63Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-272",
    d: "M834.39,311.61c-.63,0-1.14-.08-1.53-.2-.39-.13-.7-.3-.93-.53s-.38-.5-.46-.83c-.08-.32-.12-.69-.12-1.09v-8.4l2.16-.35v8.31c0,.19.01.37.04.52.03.16.08.29.17.39s.2.19.36.26c.15.07.36.11.62.13l-.3,1.78Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-272",
    d: "M841.77,301.63c0,.4-.13.71-.38.94s-.56.34-.91.34-.65-.11-.91-.34-.38-.54-.38-.94.13-.71.38-.93c.26-.23.56-.34.91-.34s.65.11.91.34c.26.23.38.54.38.93ZM841.57,311.46h-2.16v-7.63h2.16v7.63Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-272",
    d: "M843.59,304.1c.37-.11.84-.21,1.42-.3.58-.09,1.19-.14,1.83-.14s1.19.08,1.62.25c.43.17.77.41,1.02.72.25.31.43.68.54,1.1.11.43.16.9.16,1.42v4.31h-2.16v-4.05c0-.7-.09-1.19-.28-1.48s-.53-.44-1.03-.44c-.16,0-.32,0-.49.02s-.33.03-.46.05v5.89h-2.16v-7.37Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-272",
    d: "M855.54,301.94l2.16-.35v2.25h2.6v1.8h-2.6v2.68c0,.45.08.82.24,1.09.16.27.48.41.96.41.23,0,.47-.02.72-.07.25-.04.47-.1.67-.18l.3,1.68c-.26.11-.55.2-.87.28-.32.08-.71.12-1.17.12-.59,0-1.08-.08-1.46-.24-.39-.16-.7-.38-.93-.67-.23-.29-.39-.63-.49-1.04-.09-.41-.14-.86-.14-1.35v-6.41Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-272",
    d: "M862.05,311.46v-10.9l2.16-.35v3.65c.14-.05.33-.09.56-.14.23-.04.45-.07.66-.07.62,0,1.13.08,1.54.25.41.17.74.41.99.72.25.31.42.68.52,1.1.1.43.15.9.15,1.42v4.31h-2.16v-4.05c0-.7-.09-1.19-.27-1.48s-.51-.44-.99-.44c-.19,0-.37.02-.54.05-.17.03-.32.07-.46.11v5.8h-2.16Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-272",
    d: "M870.23,307.71c0-.68.1-1.27.31-1.78.21-.51.48-.93.82-1.27.34-.34.73-.59,1.17-.77.44-.17.89-.26,1.36-.26,1.08,0,1.94.33,2.57.99.63.66.94,1.64.94,2.92,0,.13,0,.26-.01.41,0,.15-.02.28-.03.4h-4.9c.05.44.26.8.62,1.06.37.26.86.39,1.48.39.4,0,.79-.04,1.17-.11s.69-.16.94-.27l.29,1.75c-.12.06-.27.12-.46.17s-.41.11-.65.15c-.24.04-.49.08-.76.11-.27.03-.54.04-.81.04-.69,0-1.28-.1-1.79-.3-.51-.2-.93-.48-1.26-.83-.33-.35-.58-.77-.74-1.25s-.24-1-.24-1.57ZM875.31,306.88c0-.18-.04-.36-.09-.54-.05-.17-.13-.33-.25-.46-.11-.13-.25-.25-.42-.33-.17-.09-.38-.13-.63-.13s-.45.04-.62.12-.32.19-.43.33c-.12.13-.21.29-.27.47-.06.18-.11.36-.14.54h2.86Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-272",
    d: "M884.73,309.91c.4,0,.68-.04.84-.12.16-.08.25-.23.25-.45,0-.17-.11-.33-.32-.46-.21-.13-.54-.28-.97-.44-.34-.13-.65-.26-.92-.39-.28-.14-.51-.3-.7-.49-.19-.19-.34-.41-.45-.67s-.16-.58-.16-.94c0-.72.27-1.28.8-1.7.53-.42,1.26-.62,2.19-.62.46,0,.91.04,1.33.12.42.08.76.17,1.01.27l-.38,1.68c-.25-.09-.52-.16-.82-.23s-.63-.1-.99-.1c-.68,0-1.01.19-1.01.57,0,.09.01.16.04.23.03.07.09.13.17.2s.21.13.36.2.34.15.57.24c.47.17.86.35,1.17.52.31.17.55.35.73.55.18.2.3.42.38.66s.11.52.11.84c0,.75-.28,1.32-.85,1.71s-1.37.58-2.4.58c-.68,0-1.24-.06-1.69-.17-.45-.12-.76-.21-.94-.29l.36-1.75c.37.15.74.26,1.13.34s.77.12,1.15.12Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-272",
    d: "M892.32,303.63c.64,0,1.17.07,1.59.22.42.14.77.35,1.02.62.26.27.44.6.54.99.11.39.16.82.16,1.29v4.5c-.31.07-.74.15-1.29.24-.55.09-1.22.14-2,.14-.49,0-.94-.04-1.34-.13s-.75-.23-1.04-.43-.51-.46-.67-.78c-.15-.32-.23-.71-.23-1.17s.09-.82.27-1.13c.18-.31.42-.56.72-.74s.64-.32,1.03-.4c.39-.08.79-.12,1.2-.12.28,0,.53.01.75.04.22.02.39.06.53.09v-.2c0-.37-.11-.66-.33-.88s-.61-.33-1.16-.33c-.37,0-.73.03-1.09.08-.36.05-.67.13-.93.22l-.28-1.74c.13-.04.28-.08.47-.12s.39-.08.62-.12c.22-.03.46-.06.7-.09.25-.02.5-.04.75-.04ZM892.49,309.96c.21,0,.42,0,.61-.01s.35-.02.46-.04v-1.64c-.09-.02-.22-.04-.39-.06s-.33-.03-.48-.03c-.2,0-.39.01-.57.04-.18.02-.34.07-.47.14-.14.07-.24.16-.32.28s-.12.26-.12.43c0,.34.11.57.34.7.23.13.54.2.94.2Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-272",
    d: "M901.78,307.42c0-.7-.09-1.19-.27-1.48s-.49-.44-.92-.44c-.14,0-.28,0-.42.02-.14.01-.29.03-.42.05v5.89h-2.16v-7.37c.18-.05.4-.1.65-.15.25-.05.51-.1.78-.14.28-.04.56-.08.85-.1.29-.02.57-.04.86-.04.55,0,1,.07,1.34.21.34.14.63.31.85.5.31-.22.66-.4,1.07-.52s.77-.19,1.11-.19c.61,0,1.11.08,1.5.25.39.17.7.41.93.72.23.31.39.68.48,1.1.09.43.13.9.13,1.42v4.31h-2.16v-4.05c0-.7-.09-1.19-.27-1.48s-.49-.44-.92-.44c-.12,0-.28.03-.49.09-.21.06-.38.13-.51.22.07.22.11.46.13.7.02.25.03.51.03.79v4.16h-2.16v-4.05Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-272",
    d: "M909.73,307.71c0-.68.1-1.27.31-1.78.21-.51.48-.93.82-1.27.34-.34.73-.59,1.17-.77.44-.17.89-.26,1.36-.26,1.08,0,1.94.33,2.57.99.63.66.94,1.64.94,2.92,0,.13,0,.26-.01.41,0,.15-.02.28-.03.4h-4.9c.05.44.26.8.62,1.06.37.26.86.39,1.48.39.4,0,.79-.04,1.17-.11s.69-.16.94-.27l.29,1.75c-.12.06-.27.12-.46.17s-.41.11-.65.15c-.24.04-.49.08-.76.11-.27.03-.54.04-.81.04-.69,0-1.28-.1-1.79-.3-.51-.2-.93-.48-1.26-.83-.33-.35-.58-.77-.74-1.25s-.24-1-.24-1.57ZM914.8,306.88c0-.18-.04-.36-.09-.54-.05-.17-.13-.33-.25-.46-.11-.13-.25-.25-.42-.33-.17-.09-.38-.13-.63-.13s-.45.04-.62.12-.32.19-.43.33c-.12.13-.21.29-.27.47-.06.18-.11.36-.14.54h2.86Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-272",
    d: "M929.13,307.65c0,.61-.09,1.16-.27,1.65-.18.49-.44.91-.78,1.26-.34.35-.75.62-1.25.8-.49.19-1.05.28-1.68.28-.26,0-.53-.01-.82-.04-.29-.02-.57-.06-.84-.09-.28-.04-.54-.08-.79-.14-.25-.05-.47-.11-.67-.17v-10.66l2.16-.35v3.8c.24-.11.49-.19.75-.25.26-.06.54-.09.84-.09.54,0,1.02.09,1.44.28.42.19.76.46,1.04.8.28.35.49.77.64,1.25.15.49.22,1.03.22,1.63ZM926.93,307.59c0-1.39-.51-2.09-1.54-2.09-.22,0-.44.03-.66.09-.22.06-.39.13-.53.22v3.93c.11.02.24.04.41.05.17.01.34.02.54.02.59,0,1.03-.2,1.33-.61.3-.41.45-.94.45-1.61Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-272",
    d: "M935.39,305.75c-.19-.05-.42-.1-.68-.15-.26-.05-.54-.08-.84-.08-.14,0-.3.01-.49.04-.19.02-.33.05-.43.08v5.83h-2.16v-7.22c.39-.14.84-.26,1.37-.38.53-.12,1.11-.18,1.76-.18.12,0,.26,0,.42.02s.33.03.49.06c.16.02.33.05.49.09.16.03.3.08.42.12l-.36,1.78Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-272",
    d: "M943.91,307.64c0,.6-.09,1.15-.26,1.65-.17.5-.42.92-.75,1.28-.33.35-.72.63-1.18.82s-.97.29-1.54.29-1.07-.1-1.53-.29-.85-.47-1.18-.82c-.33-.35-.58-.78-.77-1.28-.18-.5-.28-1.05-.28-1.65s.09-1.15.28-1.64.45-.91.78-1.26c.33-.35.73-.62,1.19-.81s.96-.29,1.5-.29,1.06.1,1.51.29.85.46,1.18.81c.33.35.58.77.77,1.26.18.49.28,1.04.28,1.64ZM941.7,307.64c0-.67-.13-1.19-.4-1.57-.27-.38-.64-.57-1.14-.57s-.88.19-1.15.57-.41.91-.41,1.57.14,1.2.41,1.59.65.59,1.15.59.87-.2,1.14-.59c.27-.39.4-.92.4-1.59Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-272",
    d: "M950.05,307.09c-.19.73-.4,1.46-.62,2.19s-.45,1.46-.69,2.19h-1.68c-.17-.41-.36-.89-.57-1.45-.2-.56-.42-1.17-.63-1.83s-.44-1.36-.67-2.1-.45-1.49-.66-2.24h2.28c.08.35.16.73.25,1.14.09.41.19.83.29,1.27.1.43.21.87.32,1.31.11.44.23.86.34,1.27.13-.43.25-.86.37-1.31.12-.44.24-.88.35-1.31.11-.43.22-.85.32-1.25.1-.4.19-.78.27-1.12h1.57c.08.35.17.72.26,1.12.1.4.2.82.3,1.25.11.43.22.87.33,1.31.12.45.24.88.36,1.31.12-.41.23-.83.35-1.27.12-.44.23-.88.33-1.31.1-.44.2-.86.29-1.27.09-.41.18-.79.26-1.14h2.25c-.21.75-.43,1.5-.66,2.24-.23.74-.45,1.44-.67,2.1-.22.66-.43,1.27-.64,1.83-.21.56-.4,1.04-.58,1.45h-1.68c-.24-.73-.48-1.46-.71-2.19-.23-.72-.45-1.46-.64-2.19Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-272",
    d: "M958.96,309.91c.4,0,.68-.04.84-.12.16-.08.25-.23.25-.45,0-.17-.11-.33-.32-.46-.21-.13-.54-.28-.97-.44-.34-.13-.65-.26-.92-.39-.28-.14-.51-.3-.7-.49-.19-.19-.34-.41-.45-.67s-.16-.58-.16-.94c0-.72.27-1.28.8-1.7.53-.42,1.26-.62,2.19-.62.46,0,.91.04,1.33.12.42.08.76.17,1.01.27l-.38,1.68c-.25-.09-.52-.16-.82-.23s-.63-.1-.99-.1c-.68,0-1.01.19-1.01.57,0,.09.01.16.04.23.03.07.09.13.17.2s.21.13.36.2.34.15.57.24c.47.17.86.35,1.17.52.31.17.55.35.73.55.18.2.3.42.38.66s.11.52.11.84c0,.75-.28,1.32-.85,1.71s-1.37.58-2.4.58c-.68,0-1.24-.06-1.69-.17-.45-.12-.76-.21-.94-.29l.36-1.75c.37.15.74.26,1.13.34s.77.12,1.15.12Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-272",
    d: "M963.44,307.71c0-.68.1-1.27.31-1.78.21-.51.48-.93.82-1.27.34-.34.73-.59,1.17-.77.44-.17.89-.26,1.36-.26,1.08,0,1.94.33,2.57.99.63.66.94,1.64.94,2.92,0,.13,0,.26-.01.41,0,.15-.02.28-.03.4h-4.9c.05.44.26.8.62,1.06.37.26.86.39,1.48.39.4,0,.79-.04,1.17-.11s.69-.16.94-.27l.29,1.75c-.12.06-.27.12-.46.17s-.41.11-.65.15c-.24.04-.49.08-.76.11-.27.03-.54.04-.81.04-.69,0-1.28-.1-1.79-.3-.51-.2-.93-.48-1.26-.83-.33-.35-.58-.77-.74-1.25s-.24-1-.24-1.57ZM968.51,306.88c0-.18-.04-.36-.09-.54-.05-.17-.13-.33-.25-.46-.11-.13-.25-.25-.42-.33-.17-.09-.38-.13-.63-.13s-.45.04-.62.12-.32.19-.43.33c-.12.13-.21.29-.27.47-.06.18-.11.36-.14.54h2.86Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-272",
    d: "M976.86,305.75c-.19-.05-.42-.1-.68-.15-.26-.05-.54-.08-.84-.08-.14,0-.3.01-.49.04-.19.02-.33.05-.43.08v5.83h-2.16v-7.22c.39-.14.84-.26,1.37-.38.53-.12,1.11-.18,1.76-.18.12,0,.26,0,.42.02s.33.03.49.06c.16.02.33.05.49.09.16.03.3.08.42.12l-.36,1.78Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-272",
    d: "M181,377.87c-1.63,0-2.88-.45-3.73-1.36-.86-.91-1.28-2.2-1.28-3.87,0-.83.13-1.57.39-2.23.26-.65.62-1.2,1.07-1.65s1-.79,1.62-1.02c.63-.23,1.31-.35,2.04-.35.42,0,.81.03,1.16.09.35.06.65.14.91.22s.48.17.65.25.3.15.38.2l-.65,1.83c-.31-.17-.67-.3-1.08-.42-.41-.12-.88-.17-1.4-.17-.35,0-.69.06-1.02.17-.33.12-.63.3-.88.56s-.46.59-.62.99c-.15.41-.23.9-.23,1.48,0,.46.05.9.15,1.3s.27.75.49,1.04c.23.29.52.52.89.69.37.17.81.25,1.33.25.33,0,.62-.02.88-.06.26-.04.49-.08.7-.14.2-.05.38-.11.54-.18.15-.07.29-.13.42-.19l.62,1.81c-.32.19-.77.37-1.35.52-.58.16-1.25.23-2.02.23Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-272",
    d: "M190.27,371.96c-.19-.05-.42-.1-.68-.15-.26-.05-.54-.08-.84-.08-.14,0-.3.01-.49.04-.19.02-.33.05-.43.08v5.83h-2.16v-7.22c.39-.14.84-.26,1.37-.38.53-.12,1.11-.18,1.76-.18.12,0,.26,0,.42.02s.33.03.49.06c.16.02.33.05.49.09.16.03.3.08.42.12l-.36,1.78Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-272",
    d: "M191.28,373.91c0-.68.1-1.27.31-1.78.21-.51.48-.93.82-1.27.34-.34.73-.59,1.17-.77.44-.17.89-.26,1.36-.26,1.08,0,1.94.33,2.57.99.63.66.94,1.64.94,2.92,0,.13,0,.26-.01.41,0,.15-.02.28-.03.4h-4.9c.05.44.26.8.62,1.06.37.26.86.39,1.48.39.4,0,.79-.04,1.17-.11s.69-.16.94-.27l.29,1.75c-.12.06-.27.12-.46.17s-.41.11-.65.15c-.24.04-.49.08-.76.11-.27.03-.54.04-.81.04-.69,0-1.28-.1-1.79-.3-.51-.2-.93-.48-1.26-.83-.33-.35-.58-.77-.74-1.25s-.24-1-.24-1.57ZM196.36,373.09c0-.18-.04-.36-.09-.54-.05-.17-.13-.33-.25-.46-.11-.13-.25-.25-.42-.33-.17-.09-.38-.13-.63-.13s-.45.04-.62.12-.32.19-.43.33c-.12.13-.21.29-.27.47-.06.18-.11.36-.14.54h2.86Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-272",
    d: "M202.85,369.84c.64,0,1.17.07,1.59.22.42.14.77.35,1.02.62.26.27.44.6.54.99.11.39.16.82.16,1.29v4.5c-.31.07-.74.15-1.29.24-.55.09-1.22.14-2,.14-.49,0-.94-.04-1.34-.13s-.75-.23-1.04-.43-.51-.46-.67-.78c-.15-.32-.23-.71-.23-1.17s.09-.82.27-1.13c.18-.31.42-.56.72-.74s.64-.32,1.03-.4c.39-.08.79-.12,1.2-.12.28,0,.53.01.75.04.22.02.39.06.53.09v-.2c0-.37-.11-.66-.33-.88s-.61-.33-1.16-.33c-.37,0-.73.03-1.09.08-.36.05-.67.13-.93.22l-.28-1.74c.13-.04.28-.08.47-.12s.39-.08.62-.12c.22-.03.46-.06.7-.09.25-.02.5-.04.75-.04ZM203.03,376.16c.21,0,.42,0,.61-.01s.35-.02.46-.04v-1.64c-.09-.02-.22-.04-.39-.06s-.33-.03-.48-.03c-.2,0-.39.01-.57.04-.18.02-.34.07-.47.14-.14.07-.24.16-.32.28s-.12.26-.12.43c0,.34.11.57.34.7.23.13.54.2.94.2Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-272",
    d: "M208.06,368.14l2.16-.35v2.25h2.6v1.8h-2.6v2.68c0,.45.08.82.24,1.09.16.27.48.41.96.41.23,0,.47-.02.72-.07.25-.04.47-.1.67-.18l.3,1.68c-.26.11-.55.2-.87.28-.32.08-.71.12-1.17.12-.59,0-1.08-.08-1.46-.24-.39-.16-.7-.38-.93-.67-.23-.29-.39-.63-.49-1.04-.09-.41-.14-.86-.14-1.35v-6.41Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-272",
    d: "M213.92,373.91c0-.68.1-1.27.31-1.78.21-.51.48-.93.82-1.27.34-.34.73-.59,1.17-.77.44-.17.89-.26,1.36-.26,1.08,0,1.94.33,2.57.99.63.66.94,1.64.94,2.92,0,.13,0,.26-.01.41,0,.15-.02.28-.03.4h-4.9c.05.44.26.8.62,1.06.37.26.86.39,1.48.39.4,0,.79-.04,1.17-.11s.69-.16.94-.27l.29,1.75c-.12.06-.27.12-.46.17s-.41.11-.65.15c-.24.04-.49.08-.76.11-.27.03-.54.04-.81.04-.69,0-1.28-.1-1.79-.3-.51-.2-.93-.48-1.26-.83-.33-.35-.58-.77-.74-1.25s-.24-1-.24-1.57ZM218.99,373.09c0-.18-.04-.36-.09-.54-.05-.17-.13-.33-.25-.46-.11-.13-.25-.25-.42-.33-.17-.09-.38-.13-.63-.13s-.45.04-.62.12-.32.19-.43.33c-.12.13-.21.29-.27.47-.06.18-.11.36-.14.54h2.86Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-272",
    d: "M224.94,376.12c.4,0,.68-.04.84-.12.16-.08.25-.23.25-.45,0-.17-.11-.33-.32-.46-.21-.13-.54-.28-.97-.44-.34-.13-.65-.26-.92-.39-.28-.14-.51-.3-.7-.49-.19-.19-.34-.41-.45-.67s-.16-.58-.16-.94c0-.72.27-1.28.8-1.7.53-.42,1.26-.62,2.19-.62.46,0,.91.04,1.33.12.42.08.76.17,1.01.27l-.38,1.68c-.25-.09-.52-.16-.82-.23s-.63-.1-.99-.1c-.68,0-1.01.19-1.01.57,0,.09.01.16.04.23.03.07.09.13.17.2s.21.13.36.2.34.15.57.24c.47.17.86.35,1.17.52.31.17.55.35.73.55.18.2.3.42.38.66s.11.52.11.84c0,.75-.28,1.32-.85,1.71s-1.37.58-2.4.58c-.68,0-1.24-.06-1.69-.17-.45-.12-.76-.21-.94-.29l.36-1.75c.37.15.74.26,1.13.34s.77.12,1.15.12Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-272",
    d: "M232.9,373.86c0-.55.09-1.07.27-1.56s.44-.91.78-1.28c.34-.36.75-.65,1.23-.86s1.03-.32,1.65-.32c.41,0,.78.04,1.12.11.34.07.67.18.99.31l-.45,1.73c-.2-.08-.43-.15-.67-.2-.24-.06-.51-.09-.81-.09-.64,0-1.11.2-1.43.59-.31.4-.47.92-.47,1.57,0,.69.15,1.22.44,1.59s.81.57,1.54.57c.26,0,.54-.02.84-.07.3-.05.58-.12.83-.23l.3,1.77c-.25.11-.57.2-.94.28-.38.08-.79.12-1.25.12-.7,0-1.3-.1-1.8-.31-.5-.21-.92-.49-1.24-.85-.32-.36-.56-.78-.71-1.27-.15-.49-.22-1.02-.22-1.59Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-272",
    d: "M245.11,371.96c-.19-.05-.42-.1-.68-.15-.26-.05-.54-.08-.84-.08-.14,0-.3.01-.49.04-.19.02-.33.05-.43.08v5.83h-2.16v-7.22c.39-.14.84-.26,1.37-.38.53-.12,1.11-.18,1.76-.18.12,0,.26,0,.42.02s.33.03.49.06c.16.02.33.05.49.09.16.03.3.08.42.12l-.36,1.78Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-272",
    d: "M249.22,369.84c.64,0,1.17.07,1.59.22.42.14.77.35,1.02.62.26.27.44.6.54.99.11.39.16.82.16,1.29v4.5c-.31.07-.74.15-1.29.24-.55.09-1.22.14-2,.14-.49,0-.94-.04-1.34-.13s-.75-.23-1.04-.43-.51-.46-.67-.78c-.15-.32-.23-.71-.23-1.17s.09-.82.27-1.13c.18-.31.42-.56.72-.74s.64-.32,1.03-.4c.39-.08.79-.12,1.2-.12.28,0,.53.01.75.04.22.02.39.06.53.09v-.2c0-.37-.11-.66-.33-.88s-.61-.33-1.16-.33c-.37,0-.73.03-1.09.08-.36.05-.67.13-.93.22l-.28-1.74c.13-.04.28-.08.47-.12s.39-.08.62-.12c.22-.03.46-.06.7-.09.25-.02.5-.04.75-.04ZM249.4,376.16c.21,0,.42,0,.61-.01s.35-.02.46-.04v-1.64c-.09-.02-.22-.04-.39-.06s-.33-.03-.48-.03c-.2,0-.39.01-.57.04-.18.02-.34.07-.47.14-.14.07-.24.16-.32.28s-.12.26-.12.43c0,.34.11.57.34.7.23.13.54.2.94.2Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-272",
    d: "M257.81,366.42c.41,0,.78.04,1.12.12.34.08.6.16.78.24l-.42,1.73c-.19-.09-.4-.15-.63-.2-.23-.04-.44-.07-.63-.07-.26,0-.48.04-.66.11s-.32.17-.42.3c-.1.13-.17.28-.22.45-.04.17-.07.36-.07.57v.38h2.67v1.8h-2.67v5.83h-2.16v-8.03c0-.99.28-1.77.83-2.35s1.38-.87,2.47-.87Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-272",
    d: "M260.55,368.14l2.16-.35v2.25h2.6v1.8h-2.6v2.68c0,.45.08.82.24,1.09.16.27.48.41.96.41.23,0,.47-.02.72-.07.25-.04.47-.1.67-.18l.3,1.68c-.26.11-.55.2-.87.28-.32.08-.71.12-1.17.12-.59,0-1.08-.08-1.46-.24-.39-.16-.7-.38-.93-.67-.23-.29-.39-.63-.49-1.04-.09-.41-.14-.86-.14-1.35v-6.41Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-272",
    d: "M266.41,373.91c0-.68.1-1.27.31-1.78.21-.51.48-.93.82-1.27.34-.34.73-.59,1.17-.77.44-.17.89-.26,1.36-.26,1.08,0,1.94.33,2.57.99.63.66.94,1.64.94,2.92,0,.13,0,.26-.01.41,0,.15-.02.28-.03.4h-4.9c.05.44.26.8.62,1.06.37.26.86.39,1.48.39.4,0,.79-.04,1.17-.11s.69-.16.94-.27l.29,1.75c-.12.06-.27.12-.46.17s-.41.11-.65.15c-.24.04-.49.08-.76.11-.27.03-.54.04-.81.04-.69,0-1.28-.1-1.79-.3-.51-.2-.93-.48-1.26-.83-.33-.35-.58-.77-.74-1.25s-.24-1-.24-1.57ZM271.48,373.09c0-.18-.04-.36-.09-.54-.05-.17-.13-.33-.25-.46-.11-.13-.25-.25-.42-.33-.17-.09-.38-.13-.63-.13s-.45.04-.62.12-.32.19-.43.33c-.12.13-.21.29-.27.47-.06.18-.11.36-.14.54h2.86Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-272",
    d: "M281.97,377.42c-.19.06-.42.11-.67.17-.25.05-.51.1-.79.14-.28.04-.56.07-.84.09-.29.02-.56.04-.82.04-.63,0-1.19-.09-1.68-.28s-.91-.45-1.25-.79c-.34-.34-.6-.76-.78-1.25s-.27-1.04-.27-1.65.08-1.18.23-1.67c.15-.5.38-.92.67-1.27.29-.35.64-.61,1.07-.8s.9-.28,1.44-.28c.3,0,.57.03.81.09.24.06.48.14.72.25v-3.45l2.16-.35v11.01ZM277.08,373.8c0,.67.15,1.2.45,1.61.3.41.74.61,1.33.61.19,0,.37,0,.54-.02.16-.01.3-.03.41-.05v-3.93c-.14-.09-.31-.16-.53-.22-.22-.06-.44-.09-.66-.09-1.02,0-1.54.7-1.54,2.09Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-272",
    d: "M286.04,375.47c.02.23.03.4.04.49s0,.18,0,.25c0,.29-.03.6-.08.92-.05.32-.13.65-.22.98-.1.33-.22.66-.36.99-.14.33-.31.64-.49.94l-1.7-.42c.22-.64.38-1.24.46-1.8.09-.56.13-1.02.13-1.39,0-.06,0-.13,0-.22s0-.19-.01-.28c0-.1,0-.19-.01-.28s0-.14,0-.17h2.26Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-272",
    d: "M294.09,377.81c-.63,0-1.14-.08-1.53-.2-.39-.13-.7-.3-.93-.53s-.38-.5-.46-.83c-.08-.32-.12-.69-.12-1.09v-8.4l2.16-.35v8.31c0,.19.01.37.04.52.03.16.08.29.17.39s.2.19.36.26c.15.07.36.11.62.13l-.3,1.78Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-272",
    d: "M295.26,373.91c0-.68.1-1.27.31-1.78.21-.51.48-.93.82-1.27.34-.34.73-.59,1.17-.77.44-.17.89-.26,1.36-.26,1.08,0,1.94.33,2.57.99.63.66.94,1.64.94,2.92,0,.13,0,.26-.01.41,0,.15-.02.28-.03.4h-4.9c.05.44.26.8.62,1.06.37.26.86.39,1.48.39.4,0,.79-.04,1.17-.11s.69-.16.94-.27l.29,1.75c-.12.06-.27.12-.46.17s-.41.11-.65.15c-.24.04-.49.08-.76.11-.27.03-.54.04-.81.04-.69,0-1.28-.1-1.79-.3-.51-.2-.93-.48-1.26-.83-.33-.35-.58-.77-.74-1.25s-.24-1-.24-1.57ZM300.34,373.09c0-.18-.04-.36-.09-.54-.05-.17-.13-.33-.25-.46-.11-.13-.25-.25-.42-.33-.17-.09-.38-.13-.63-.13s-.45.04-.62.12-.32.19-.43.33c-.12.13-.21.29-.27.47-.06.18-.11.36-.14.54h2.86Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-272",
    d: "M310.67,376.71c0,1.25-.32,2.17-.95,2.78-.63.6-1.61.91-2.94.91-.46,0-.93-.04-1.39-.12s-.89-.19-1.29-.33l.38-1.81c.34.14.69.24,1.07.32.37.08.79.12,1.27.12.62,0,1.06-.14,1.31-.41.26-.27.38-.62.38-1.04v-.28c-.23.11-.47.19-.72.24-.25.05-.51.08-.8.08-1.05,0-1.86-.31-2.42-.93-.56-.62-.84-1.5-.84-2.62,0-.56.09-1.07.26-1.53.17-.46.43-.85.76-1.18.33-.33.74-.58,1.23-.76.48-.18,1.03-.27,1.64-.27.26,0,.53.01.81.04.28.02.55.06.82.09.27.04.53.08.78.14.25.05.47.11.66.17v6.41ZM305.93,373.61c0,1.21.49,1.81,1.46,1.81.22,0,.43-.03.62-.09.19-.06.36-.12.49-.2v-3.45c-.11-.02-.23-.04-.38-.05s-.31-.02-.51-.02c-.57,0-1,.19-1.28.57-.28.38-.42.86-.42,1.44Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-272",
    d: "M315.07,367.84c0,.4-.13.71-.38.94-.26.23-.56.34-.91.34s-.65-.11-.91-.34c-.26-.23-.38-.54-.38-.94s.13-.71.38-.94c.26-.23.56-.34.91-.34s.65.11.91.34c.26.23.38.54.38.94ZM314.87,377.67h-2.16v-7.63h2.16v7.63Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-272",
    d: "M316.82,368.14l2.16-.35v2.25h2.6v1.8h-2.6v2.68c0,.45.08.82.24,1.09.16.27.48.41.96.41.23,0,.47-.02.72-.07.25-.04.47-.1.67-.18l.3,1.68c-.26.11-.55.2-.87.28-.32.08-.71.12-1.17.12-.59,0-1.08-.08-1.46-.24-.39-.16-.7-.38-.93-.67-.23-.29-.39-.63-.49-1.04-.09-.41-.14-.86-.14-1.35v-6.41Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-272",
    d: "M325.7,367.84c0,.4-.13.71-.38.94-.26.23-.56.34-.91.34s-.65-.11-.91-.34c-.26-.23-.38-.54-.38-.94s.13-.71.38-.94c.26-.23.56-.34.91-.34s.65.11.91.34c.26.23.38.54.38.94ZM325.49,377.67h-2.16v-7.63h2.16v7.63Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-272",
    d: "M331.71,373.62c0-.7-.09-1.19-.27-1.48s-.49-.44-.92-.44c-.14,0-.28,0-.42.02-.14.01-.29.03-.42.05v5.89h-2.16v-7.37c.18-.05.4-.1.65-.15.25-.05.51-.1.78-.14.28-.04.56-.08.85-.1.29-.02.57-.04.86-.04.55,0,1,.07,1.34.21.34.14.63.31.85.5.31-.22.66-.4,1.07-.52s.77-.19,1.11-.19c.61,0,1.11.08,1.5.25.39.17.7.41.93.72.23.31.39.68.48,1.1.09.43.13.9.13,1.42v4.31h-2.16v-4.05c0-.7-.09-1.19-.27-1.48s-.49-.44-.92-.44c-.12,0-.28.03-.49.09-.21.06-.38.13-.51.22.07.22.11.46.13.7.02.25.03.51.03.79v4.16h-2.16v-4.05Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-272",
    d: "M342.76,369.84c.64,0,1.17.07,1.59.22.42.14.77.35,1.02.62.26.27.44.6.54.99.11.39.16.82.16,1.29v4.5c-.31.07-.74.15-1.29.24-.55.09-1.22.14-2,.14-.49,0-.94-.04-1.34-.13s-.75-.23-1.04-.43-.51-.46-.67-.78c-.15-.32-.23-.71-.23-1.17s.09-.82.27-1.13c.18-.31.42-.56.72-.74s.64-.32,1.03-.4c.39-.08.79-.12,1.2-.12.28,0,.53.01.75.04.22.02.39.06.53.09v-.2c0-.37-.11-.66-.33-.88s-.61-.33-1.16-.33c-.37,0-.73.03-1.09.08-.36.05-.67.13-.93.22l-.28-1.74c.13-.04.28-.08.47-.12s.39-.08.62-.12c.22-.03.46-.06.7-.09.25-.02.5-.04.75-.04ZM342.94,376.16c.21,0,.42,0,.61-.01s.35-.02.46-.04v-1.64c-.09-.02-.22-.04-.39-.06s-.33-.03-.48-.03c-.2,0-.39.01-.57.04-.18.02-.34.07-.47.14-.14.07-.24.16-.32.28s-.12.26-.12.43c0,.34.11.57.34.7.23.13.54.2.94.2Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-272",
    d: "M347.97,368.14l2.16-.35v2.25h2.6v1.8h-2.6v2.68c0,.45.08.82.24,1.09.16.27.48.41.96.41.23,0,.47-.02.72-.07.25-.04.47-.1.67-.18l.3,1.68c-.26.11-.55.2-.87.28-.32.08-.71.12-1.17.12-.59,0-1.08-.08-1.46-.24-.39-.16-.7-.38-.93-.67-.23-.29-.39-.63-.49-1.04-.09-.41-.14-.86-.14-1.35v-6.41Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-272",
    d: "M353.83,373.91c0-.68.1-1.27.31-1.78.21-.51.48-.93.82-1.27.34-.34.73-.59,1.17-.77.44-.17.89-.26,1.36-.26,1.08,0,1.94.33,2.57.99.63.66.94,1.64.94,2.92,0,.13,0,.26-.01.41,0,.15-.02.28-.03.4h-4.9c.05.44.26.8.62,1.06.37.26.86.39,1.48.39.4,0,.79-.04,1.17-.11s.69-.16.94-.27l.29,1.75c-.12.06-.27.12-.46.17s-.41.11-.65.15c-.24.04-.49.08-.76.11-.27.03-.54.04-.81.04-.69,0-1.28-.1-1.79-.3-.51-.2-.93-.48-1.26-.83-.33-.35-.58-.77-.74-1.25s-.24-1-.24-1.57ZM358.9,373.09c0-.18-.04-.36-.09-.54-.05-.17-.13-.33-.25-.46-.11-.13-.25-.25-.42-.33-.17-.09-.38-.13-.63-.13s-.45.04-.62.12-.32.19-.43.33c-.12.13-.21.29-.27.47-.06.18-.11.36-.14.54h2.86Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-272",
    d: "M362,372.36h4.21v1.96h-4.21v-1.96Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-272",
    d: "M370.63,377.81c-.63,0-1.14-.08-1.53-.2-.39-.13-.7-.3-.93-.53s-.38-.5-.46-.83c-.08-.32-.12-.69-.12-1.09v-8.4l2.16-.35v8.31c0,.19.01.37.04.52.03.16.08.29.17.39s.2.19.36.26c.15.07.36.11.62.13l-.3,1.78Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-272",
    d: "M379.3,373.84c0,.6-.09,1.15-.26,1.65-.17.5-.42.92-.75,1.28-.33.35-.72.63-1.18.82s-.97.29-1.54.29-1.07-.1-1.53-.29-.85-.47-1.18-.82c-.33-.35-.58-.78-.77-1.28-.18-.5-.28-1.05-.28-1.65s.09-1.15.28-1.64.45-.91.78-1.26c.33-.35.73-.62,1.19-.81s.96-.29,1.5-.29,1.06.1,1.51.29.85.46,1.18.81c.33.35.58.77.77,1.26.18.49.28,1.04.28,1.64ZM377.1,373.84c0-.67-.13-1.19-.4-1.57-.27-.38-.64-.57-1.14-.57s-.88.19-1.15.57-.41.91-.41,1.57.14,1.2.41,1.59.65.59,1.15.59.87-.2,1.14-.59c.27-.39.4-.92.4-1.59Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-272",
    d: "M388.1,373.84c0,.6-.09,1.15-.26,1.65-.17.5-.42.92-.75,1.28-.33.35-.72.63-1.18.82s-.97.29-1.54.29-1.07-.1-1.53-.29-.85-.47-1.18-.82c-.33-.35-.58-.78-.77-1.28-.18-.5-.28-1.05-.28-1.65s.09-1.15.28-1.64.45-.91.78-1.26c.33-.35.73-.62,1.19-.81s.96-.29,1.5-.29,1.06.1,1.51.29.85.46,1.18.81c.33.35.58.77.77,1.26.18.49.28,1.04.28,1.64ZM385.9,373.84c0-.67-.13-1.19-.4-1.57-.27-.38-.64-.57-1.14-.57s-.88.19-1.15.57-.41.91-.41,1.57.14,1.2.41,1.59.65.59,1.15.59.87-.2,1.14-.59c.27-.39.4-.92.4-1.59Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-272",
    d: "M391.93,372.78c.21-.23.43-.47.66-.72.23-.25.45-.5.66-.74.21-.25.41-.48.6-.7.19-.22.35-.41.49-.58h2.57c-.51.59-1.01,1.15-1.5,1.69s-1.02,1.09-1.6,1.66c.29.26.59.57.9.94.31.36.61.74.9,1.13.29.39.56.77.8,1.16.24.39.44.74.61,1.06h-2.48c-.16-.25-.33-.53-.53-.84-.2-.3-.41-.61-.63-.92-.22-.31-.46-.6-.7-.88-.25-.28-.49-.52-.73-.71v3.34h-2.16v-10.9l2.16-.35v6.36Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-272",
    d: "M400.53,367.84c0,.4-.13.71-.38.94-.26.23-.56.34-.91.34s-.65-.11-.91-.34c-.26-.23-.38-.54-.38-.94s.13-.71.38-.94c.26-.23.56-.34.91-.34s.65.11.91.34c.26.23.38.54.38.94ZM400.33,377.67h-2.16v-7.63h2.16v7.63Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-272",
    d: "M402.36,370.3c.37-.11.84-.21,1.42-.3.58-.09,1.19-.14,1.83-.14s1.19.08,1.62.25c.43.17.77.41,1.02.72.25.31.43.68.54,1.1.11.43.16.9.16,1.42v4.31h-2.16v-4.05c0-.7-.09-1.19-.28-1.48s-.53-.44-1.03-.44c-.16,0-.32,0-.49.02s-.33.03-.46.05v5.89h-2.16v-7.37Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-272",
    d: "M417.48,376.71c0,1.25-.32,2.17-.95,2.78-.63.6-1.61.91-2.94.91-.46,0-.93-.04-1.39-.12s-.89-.19-1.29-.33l.38-1.81c.34.14.69.24,1.07.32.37.08.79.12,1.27.12.62,0,1.06-.14,1.31-.41.26-.27.38-.62.38-1.04v-.28c-.23.11-.47.19-.72.24-.25.05-.51.08-.8.08-1.05,0-1.86-.31-2.42-.93-.56-.62-.84-1.5-.84-2.62,0-.56.09-1.07.26-1.53.17-.46.43-.85.76-1.18.33-.33.74-.58,1.23-.76.48-.18,1.03-.27,1.64-.27.26,0,.53.01.81.04.28.02.55.06.82.09.27.04.53.08.78.14.25.05.47.11.66.17v6.41ZM412.74,373.61c0,1.21.49,1.81,1.46,1.81.22,0,.43-.03.62-.09.19-.06.36-.12.49-.2v-3.45c-.11-.02-.23-.04-.38-.05s-.31-.02-.51-.02c-.57,0-1,.19-1.28.57-.28.38-.42.86-.42,1.44Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-272",
    d: "M180.87,389.36c-.19-.05-.42-.1-.68-.15-.26-.05-.54-.08-.84-.08-.14,0-.3.01-.49.04-.19.02-.33.05-.43.08v5.83h-2.16v-7.22c.39-.14.84-.26,1.37-.38.53-.12,1.11-.18,1.76-.18.12,0,.26,0,.42.02s.33.03.49.06c.16.02.33.05.49.09.16.03.3.08.42.12l-.36,1.78Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-272",
    d: "M181.89,391.31c0-.68.1-1.27.31-1.78.21-.51.48-.93.82-1.27.34-.34.73-.59,1.17-.77.44-.17.89-.26,1.36-.26,1.08,0,1.94.33,2.57.99.63.66.94,1.64.94,2.92,0,.13,0,.26-.01.41,0,.15-.02.28-.03.4h-4.9c.05.44.26.8.62,1.06.37.26.86.39,1.48.39.4,0,.79-.04,1.17-.11s.69-.16.94-.27l.29,1.75c-.12.06-.27.12-.46.17s-.41.11-.65.15c-.24.04-.49.08-.76.11-.27.03-.54.04-.81.04-.69,0-1.28-.1-1.79-.3-.51-.2-.93-.48-1.26-.83-.33-.35-.58-.77-.74-1.25s-.24-1-.24-1.57ZM186.96,390.49c0-.18-.04-.36-.09-.54-.05-.17-.13-.33-.25-.46-.11-.13-.25-.25-.42-.33-.17-.09-.38-.13-.63-.13s-.45.04-.62.12-.32.19-.43.33c-.12.13-.21.29-.27.47-.06.18-.11.36-.14.54h2.86Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-272",
    d: "M190.35,391.26c0-.59.09-1.13.27-1.62.18-.49.44-.91.78-1.26.34-.35.75-.63,1.25-.82s1.05-.29,1.68-.29c.26,0,.53.01.82.04s.57.06.84.09c.28.04.54.08.79.14.25.05.47.11.67.17v10.05h-2.16v-2.87c-.24.11-.49.19-.75.25-.26.06-.54.09-.84.09-1.08,0-1.91-.35-2.48-1.07-.57-.71-.86-1.67-.86-2.89ZM192.56,391.31c0,1.38.51,2.07,1.54,2.07.22,0,.44-.03.66-.09.22-.06.39-.13.53-.22v-3.9c-.11-.02-.24-.04-.41-.05-.17-.01-.34-.02-.54-.02-.59,0-1.03.2-1.33.6-.3.4-.45.93-.45,1.6Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-272",
    d: "M205.99,394.81c-.37.11-.84.21-1.42.3s-1.19.14-1.83.14-1.19-.09-1.62-.26c-.43-.17-.77-.42-1.02-.73-.25-.31-.43-.69-.54-1.12-.11-.43-.16-.91-.16-1.44v-4.25h2.16v3.99c0,.7.09,1.2.28,1.51.18.31.53.46,1.03.46.15,0,.32,0,.49-.02.17-.01.33-.03.46-.05v-5.89h2.16v7.37Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-272",
    d: "M207.65,391.31c0-.68.1-1.27.31-1.78.21-.51.48-.93.82-1.27.34-.34.73-.59,1.17-.77.44-.17.89-.26,1.36-.26,1.08,0,1.94.33,2.57.99.63.66.94,1.64.94,2.92,0,.13,0,.26-.01.41,0,.15-.02.28-.03.4h-4.9c.05.44.26.8.62,1.06.37.26.86.39,1.48.39.4,0,.79-.04,1.17-.11s.69-.16.94-.27l.29,1.75c-.12.06-.27.12-.46.17s-.41.11-.65.15c-.24.04-.49.08-.76.11-.27.03-.54.04-.81.04-.69,0-1.28-.1-1.79-.3-.51-.2-.93-.48-1.26-.83-.33-.35-.58-.77-.74-1.25s-.24-1-.24-1.57ZM212.73,390.49c0-.18-.04-.36-.09-.54-.05-.17-.13-.33-.25-.46-.11-.13-.25-.25-.42-.33-.17-.09-.38-.13-.63-.13s-.45.04-.62.12-.32.19-.43.33c-.12.13-.21.29-.27.47-.06.18-.11.36-.14.54h2.86Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-272",
    d: "M218.67,393.52c.4,0,.68-.04.84-.12.16-.08.25-.23.25-.45,0-.17-.11-.33-.32-.46-.21-.13-.54-.28-.97-.44-.34-.13-.65-.26-.92-.39-.28-.14-.51-.3-.7-.49-.19-.19-.34-.41-.45-.67s-.16-.58-.16-.94c0-.72.27-1.28.8-1.7.53-.42,1.26-.62,2.19-.62.46,0,.91.04,1.33.12.42.08.76.17,1.01.27l-.38,1.68c-.25-.09-.52-.16-.82-.23s-.63-.1-.99-.1c-.68,0-1.01.19-1.01.57,0,.09.01.16.04.23.03.07.09.13.17.2s.21.13.36.2.34.15.57.24c.47.17.86.35,1.17.52.31.17.55.35.73.55.18.2.3.42.38.66s.11.52.11.84c0,.75-.28,1.32-.85,1.71s-1.37.58-2.4.58c-.68,0-1.24-.06-1.69-.17-.45-.12-.76-.21-.94-.29l.36-1.75c.37.15.74.26,1.13.34s.77.12,1.15.12Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-272",
    d: "M223.44,385.54l2.16-.35v2.25h2.6v1.8h-2.6v2.68c0,.45.08.82.24,1.09.16.27.48.41.96.41.23,0,.47-.02.72-.07.25-.04.47-.1.67-.18l.3,1.68c-.26.11-.55.2-.87.28-.32.08-.71.12-1.17.12-.59,0-1.08-.08-1.46-.24-.39-.16-.7-.38-.93-.67-.23-.29-.39-.63-.49-1.04-.09-.41-.14-.86-.14-1.35v-6.41Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-272",
    d: "M236.17,387.24c.64,0,1.17.07,1.59.22.42.14.77.35,1.02.62.26.27.44.6.54.99.11.39.16.82.16,1.29v4.5c-.31.07-.74.15-1.29.24-.55.09-1.22.14-2,.14-.49,0-.94-.04-1.34-.13s-.75-.23-1.04-.43-.51-.46-.67-.78c-.15-.32-.23-.71-.23-1.17s.09-.82.27-1.13c.18-.31.42-.56.72-.74s.64-.32,1.03-.4c.39-.08.79-.12,1.2-.12.28,0,.53.01.75.04.22.02.39.06.53.09v-.2c0-.37-.11-.66-.33-.88s-.61-.33-1.16-.33c-.37,0-.73.03-1.09.08-.36.05-.67.13-.93.22l-.28-1.74c.13-.04.28-.08.47-.12s.39-.08.62-.12c.22-.03.46-.06.7-.09.25-.02.5-.04.75-.04ZM236.35,393.56c.21,0,.42,0,.61-.01s.35-.02.46-.04v-1.64c-.09-.02-.22-.04-.39-.06s-.33-.03-.48-.03c-.2,0-.39.01-.57.04-.18.02-.34.07-.47.14-.14.07-.24.16-.32.28s-.12.26-.12.43c0,.34.11.57.34.7.23.13.54.2.94.2Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-272",
    d: "M241.45,387.7c.37-.11.84-.21,1.42-.3.58-.09,1.19-.14,1.83-.14s1.19.08,1.62.25c.43.17.77.41,1.02.72.25.31.43.68.54,1.1.11.43.16.9.16,1.42v4.31h-2.16v-4.05c0-.7-.09-1.19-.28-1.48s-.53-.44-1.03-.44c-.16,0-.32,0-.49.02s-.33.03-.46.05v5.89h-2.16v-7.37Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-272",
    d: "M256.72,394.82c-.19.06-.42.11-.67.17-.25.05-.51.1-.79.14-.28.04-.56.07-.84.09-.29.02-.56.04-.82.04-.63,0-1.19-.09-1.68-.28s-.91-.45-1.25-.79c-.34-.34-.6-.76-.78-1.25s-.27-1.04-.27-1.65.08-1.18.23-1.67c.15-.5.38-.92.67-1.27.29-.35.64-.61,1.07-.8s.9-.28,1.44-.28c.3,0,.57.03.81.09.24.06.48.14.72.25v-3.45l2.16-.35v11.01ZM251.83,391.2c0,.67.15,1.2.45,1.61.3.41.74.61,1.33.61.19,0,.37,0,.54-.02.16-.01.3-.03.41-.05v-3.93c-.14-.09-.31-.16-.53-.22-.22-.06-.44-.09-.66-.09-1.02,0-1.54.7-1.54,2.09Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-272",
    d: "M264.42,393.52c.4,0,.68-.04.84-.12.16-.08.25-.23.25-.45,0-.17-.11-.33-.32-.46-.21-.13-.54-.28-.97-.44-.34-.13-.65-.26-.92-.39-.28-.14-.51-.3-.7-.49-.19-.19-.34-.41-.45-.67s-.16-.58-.16-.94c0-.72.27-1.28.8-1.7.53-.42,1.26-.62,2.19-.62.46,0,.91.04,1.33.12.42.08.76.17,1.01.27l-.38,1.68c-.25-.09-.52-.16-.82-.23s-.63-.1-.99-.1c-.68,0-1.01.19-1.01.57,0,.09.01.16.04.23.03.07.09.13.17.2s.21.13.36.2.34.15.57.24c.47.17.86.35,1.17.52.31.17.55.35.73.55.18.2.3.42.38.66s.11.52.11.84c0,.75-.28,1.32-.85,1.71s-1.37.58-2.4.58c-.68,0-1.24-.06-1.69-.17-.45-.12-.76-.21-.94-.29l.36-1.75c.37.15.74.26,1.13.34s.77.12,1.15.12Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-272",
    d: "M268.9,391.31c0-.68.1-1.27.31-1.78.21-.51.48-.93.82-1.27.34-.34.73-.59,1.17-.77.44-.17.89-.26,1.36-.26,1.08,0,1.94.33,2.57.99.63.66.94,1.64.94,2.92,0,.13,0,.26-.01.41,0,.15-.02.28-.03.4h-4.9c.05.44.26.8.62,1.06.37.26.86.39,1.48.39.4,0,.79-.04,1.17-.11s.69-.16.94-.27l.29,1.75c-.12.06-.27.12-.46.17s-.41.11-.65.15c-.24.04-.49.08-.76.11-.27.03-.54.04-.81.04-.69,0-1.28-.1-1.79-.3-.51-.2-.93-.48-1.26-.83-.33-.35-.58-.77-.74-1.25s-.24-1-.24-1.57ZM273.97,390.49c0-.18-.04-.36-.09-.54-.05-.17-.13-.33-.25-.46-.11-.13-.25-.25-.42-.33-.17-.09-.38-.13-.63-.13s-.45.04-.62.12-.32.19-.43.33c-.12.13-.21.29-.27.47-.06.18-.11.36-.14.54h2.86Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-272",
    d: "M277.73,387.7c.37-.11.84-.21,1.42-.3.58-.09,1.19-.14,1.83-.14s1.19.08,1.62.25c.43.17.77.41,1.02.72.25.31.43.68.54,1.1.11.43.16.9.16,1.42v4.31h-2.16v-4.05c0-.7-.09-1.19-.28-1.48s-.53-.44-1.03-.44c-.16,0-.32,0-.49.02s-.33.03-.46.05v5.89h-2.16v-7.37Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-272",
    d: "M293,394.82c-.19.06-.42.11-.67.17-.25.05-.51.1-.79.14-.28.04-.56.07-.84.09-.29.02-.56.04-.82.04-.63,0-1.19-.09-1.68-.28s-.91-.45-1.25-.79c-.34-.34-.6-.76-.78-1.25s-.27-1.04-.27-1.65.08-1.18.23-1.67c.15-.5.38-.92.67-1.27.29-.35.64-.61,1.07-.8s.9-.28,1.44-.28c.3,0,.57.03.81.09.24.06.48.14.72.25v-3.45l2.16-.35v11.01ZM288.11,391.2c0,.67.15,1.2.45,1.61.3.41.74.61,1.33.61.19,0,.37,0,.54-.02.16-.01.3-.03.41-.05v-3.93c-.14-.09-.31-.16-.53-.22-.22-.06-.44-.09-.66-.09-1.02,0-1.54.7-1.54,2.09Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-272",
    d: "M298.44,385.54l2.16-.35v2.25h2.6v1.8h-2.6v2.68c0,.45.08.82.24,1.09.16.27.48.41.96.41.23,0,.47-.02.72-.07.25-.04.47-.1.67-.18l.3,1.68c-.26.11-.55.2-.87.28-.32.08-.71.12-1.17.12-.59,0-1.08-.08-1.46-.24-.39-.16-.7-.38-.93-.67-.23-.29-.39-.63-.49-1.04-.09-.41-.14-.86-.14-1.35v-6.41Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-272",
    d: "M304.95,395.07v-10.9l2.16-.35v3.65c.14-.05.33-.09.56-.14.23-.04.45-.07.66-.07.62,0,1.13.08,1.54.25.41.17.74.41.99.72.25.31.42.68.52,1.1.1.43.15.9.15,1.42v4.31h-2.16v-4.05c0-.7-.09-1.19-.27-1.48s-.51-.44-.99-.44c-.19,0-.37.02-.54.05-.17.03-.32.07-.46.11v5.8h-2.16Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-272",
    d: "M313.12,391.31c0-.68.1-1.27.31-1.78.21-.51.48-.93.82-1.27.34-.34.73-.59,1.17-.77.44-.17.89-.26,1.36-.26,1.08,0,1.94.33,2.57.99.63.66.94,1.64.94,2.92,0,.13,0,.26-.01.41,0,.15-.02.28-.03.4h-4.9c.05.44.26.8.62,1.06.37.26.86.39,1.48.39.4,0,.79-.04,1.17-.11s.69-.16.94-.27l.29,1.75c-.12.06-.27.12-.46.17s-.41.11-.65.15c-.24.04-.49.08-.76.11-.27.03-.54.04-.81.04-.69,0-1.28-.1-1.79-.3-.51-.2-.93-.48-1.26-.83-.33-.35-.58-.77-.74-1.25s-.24-1-.24-1.57ZM318.2,390.49c0-.18-.04-.36-.09-.54-.05-.17-.13-.33-.25-.46-.11-.13-.25-.25-.42-.33-.17-.09-.38-.13-.63-.13s-.45.04-.62.12-.32.19-.43.33c-.12.13-.21.29-.27.47-.06.18-.11.36-.14.54h2.86Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-272",
    d: "M328.48,395.21c-.63,0-1.14-.08-1.53-.2-.39-.13-.7-.3-.93-.53s-.38-.5-.46-.83c-.08-.32-.12-.69-.12-1.09v-8.4l2.16-.35v8.31c0,.19.01.37.04.52.03.16.08.29.17.39s.2.19.36.26c.15.07.36.11.62.13l-.3,1.78Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-272",
    d: "M332.38,385.24c0,.4-.13.71-.38.94-.26.23-.56.34-.91.34s-.65-.11-.91-.34c-.26-.23-.38-.54-.38-.94s.13-.71.38-.94c.26-.23.56-.34.91-.34s.65.11.91.34c.26.23.38.54.38.94ZM332.18,395.07h-2.16v-7.63h2.16v7.63Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-272",
    d: "M334.21,387.7c.37-.11.84-.21,1.42-.3.58-.09,1.19-.14,1.83-.14s1.19.08,1.62.25c.43.17.77.41,1.02.72.25.31.43.68.54,1.1.11.43.16.9.16,1.42v4.31h-2.16v-4.05c0-.7-.09-1.19-.28-1.48s-.53-.44-1.03-.44c-.16,0-.32,0-.49.02s-.33.03-.46.05v5.89h-2.16v-7.37Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-272",
    d: "M344.91,390.18c.21-.23.43-.47.66-.72.23-.25.45-.5.66-.74.21-.25.41-.48.6-.7.19-.22.35-.41.49-.58h2.57c-.51.59-1.01,1.15-1.5,1.69s-1.02,1.09-1.6,1.66c.29.26.59.57.9.94.31.36.61.74.9,1.13.29.39.56.77.8,1.16.24.39.44.74.61,1.06h-2.48c-.16-.25-.33-.53-.53-.84-.2-.3-.41-.61-.63-.92-.22-.31-.46-.6-.7-.88-.25-.28-.49-.52-.73-.71v3.34h-2.16v-10.9l2.16-.35v6.36Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-272",
    d: "M361.71,391.26c0,.61-.09,1.16-.27,1.65-.18.49-.44.91-.78,1.26-.34.35-.75.62-1.25.8-.49.19-1.05.28-1.68.28-.26,0-.53-.01-.82-.04-.29-.02-.57-.06-.84-.09-.28-.04-.54-.08-.79-.14-.25-.05-.47-.11-.67-.17v-10.66l2.16-.35v3.8c.24-.11.49-.19.75-.25.26-.06.54-.09.84-.09.54,0,1.02.09,1.44.28.42.19.76.46,1.04.8.28.35.49.77.64,1.25.15.49.22,1.03.22,1.63ZM359.51,391.2c0-1.39-.51-2.09-1.54-2.09-.22,0-.44.03-.66.09-.22.06-.39.13-.53.22v3.93c.11.02.24.04.41.05.17.01.34.02.54.02.59,0,1.03-.2,1.33-.61.3-.41.45-.94.45-1.61Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-272",
    d: "M369.96,387.44c-.44,1.47-.89,2.85-1.37,4.13-.47,1.29-.99,2.53-1.56,3.74-.2.44-.41.8-.61,1.11-.2.3-.43.56-.67.75-.24.2-.51.34-.82.44-.3.09-.66.14-1.07.14-.34,0-.65-.03-.94-.09-.29-.06-.52-.13-.7-.21l.38-1.73c.22.08.42.13.59.16.17.03.36.04.55.04.39,0,.68-.1.89-.31s.38-.5.53-.86c-.49-.97-.99-2.05-1.48-3.25s-.96-2.55-1.39-4.05h2.29c.1.38.21.79.34,1.23.13.44.27.88.42,1.33.15.45.29.89.44,1.31.15.43.29.81.43,1.16.13-.35.26-.73.39-1.16.14-.42.27-.86.4-1.31.13-.45.26-.89.38-1.33.12-.44.23-.85.33-1.23h2.23Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-272",
    d: "M374.23,391.31c0-.68.1-1.27.31-1.78.21-.51.48-.93.82-1.27.34-.34.73-.59,1.17-.77.44-.17.89-.26,1.36-.26,1.08,0,1.94.33,2.57.99.63.66.94,1.64.94,2.92,0,.13,0,.26-.01.41,0,.15-.02.28-.03.4h-4.9c.05.44.26.8.62,1.06.37.26.86.39,1.48.39.4,0,.79-.04,1.17-.11s.69-.16.94-.27l.29,1.75c-.12.06-.27.12-.46.17s-.41.11-.65.15c-.24.04-.49.08-.76.11-.27.03-.54.04-.81.04-.69,0-1.28-.1-1.79-.3-.51-.2-.93-.48-1.26-.83-.33-.35-.58-.77-.74-1.25s-.24-1-.24-1.57ZM379.3,390.49c0-.18-.04-.36-.09-.54-.05-.17-.13-.33-.25-.46-.11-.13-.25-.25-.42-.33-.17-.09-.38-.13-.63-.13s-.45.04-.62.12-.32.19-.43.33c-.12.13-.21.29-.27.47-.06.18-.11.36-.14.54h2.86Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-272",
    d: "M387.25,391.02c0-.7-.09-1.19-.27-1.48s-.49-.44-.92-.44c-.14,0-.28,0-.42.02-.14.01-.29.03-.42.05v5.89h-2.16v-7.37c.18-.05.4-.1.65-.15.25-.05.51-.1.78-.14.28-.04.56-.08.85-.1.29-.02.57-.04.86-.04.55,0,1,.07,1.34.21.34.14.63.31.85.5.31-.22.66-.4,1.07-.52s.77-.19,1.11-.19c.61,0,1.11.08,1.5.25.39.17.7.41.93.72.23.31.39.68.48,1.1.09.43.13.9.13,1.42v4.31h-2.16v-4.05c0-.7-.09-1.19-.27-1.48s-.49-.44-.92-.44c-.12,0-.28.03-.49.09-.21.06-.38.13-.51.22.07.22.11.46.13.7.02.25.03.51.03.79v4.16h-2.16v-4.05Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-272",
    d: "M398.3,387.24c.64,0,1.17.07,1.59.22.42.14.77.35,1.02.62.26.27.44.6.54.99.11.39.16.82.16,1.29v4.5c-.31.07-.74.15-1.29.24-.55.09-1.22.14-2,.14-.49,0-.94-.04-1.34-.13s-.75-.23-1.04-.43-.51-.46-.67-.78c-.15-.32-.23-.71-.23-1.17s.09-.82.27-1.13c.18-.31.42-.56.72-.74s.64-.32,1.03-.4c.39-.08.79-.12,1.2-.12.28,0,.53.01.75.04.22.02.39.06.53.09v-.2c0-.37-.11-.66-.33-.88s-.61-.33-1.16-.33c-.37,0-.73.03-1.09.08-.36.05-.67.13-.93.22l-.28-1.74c.13-.04.28-.08.47-.12s.39-.08.62-.12c.22-.03.46-.06.7-.09.25-.02.5-.04.75-.04ZM398.47,393.56c.21,0,.42,0,.61-.01s.35-.02.46-.04v-1.64c-.09-.02-.22-.04-.39-.06s-.33-.03-.48-.03c-.2,0-.39.01-.57.04-.18.02-.34.07-.47.14-.14.07-.24.16-.32.28s-.12.26-.12.43c0,.34.11.57.34.7.23.13.54.2.94.2Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-272",
    d: "M405.94,385.24c0,.4-.13.71-.38.94-.26.23-.56.34-.91.34s-.65-.11-.91-.34c-.26-.23-.38-.54-.38-.94s.13-.71.38-.94c.26-.23.56-.34.91-.34s.65.11.91.34c.26.23.38.54.38.94ZM405.74,395.07h-2.16v-7.63h2.16v7.63Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-272",
    d: "M410.81,395.21c-.63,0-1.14-.08-1.53-.2-.39-.13-.7-.3-.93-.53s-.38-.5-.46-.83c-.08-.32-.12-.69-.12-1.09v-8.4l2.16-.35v8.31c0,.19.01.37.04.52.03.16.08.29.17.39s.2.19.36.26c.15.07.36.11.62.13l-.3,1.78Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-272",
    d: "M251.08,177.45c-.71,0-1.32-.1-1.83-.3-.51-.2-.94-.47-1.27-.83-.33-.35-.58-.77-.74-1.26-.16-.49-.24-1.03-.24-1.62v-6.25h2.26v6.06c0,.41.05.75.14,1.04s.22.52.38.7c.16.18.35.31.58.38.23.08.48.12.75.12.55,0,1-.17,1.34-.51.34-.34.51-.91.51-1.73v-6.06h2.26v6.25c0,.59-.08,1.13-.25,1.62-.17.49-.42.92-.75,1.27-.34.35-.77.63-1.29.82-.52.19-1.14.29-1.86.29Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-272",
    d: "M259.44,175.7c.4,0,.68-.04.84-.12.16-.08.25-.23.25-.45,0-.17-.11-.33-.32-.46-.21-.13-.54-.28-.97-.44-.34-.13-.65-.26-.92-.39-.28-.14-.51-.3-.7-.49-.19-.19-.34-.41-.45-.67-.11-.26-.16-.58-.16-.94,0-.71.27-1.28.8-1.7.53-.42,1.26-.62,2.19-.62.46,0,.91.04,1.33.12.42.08.76.17,1.01.27l-.38,1.68c-.25-.09-.52-.16-.82-.23-.29-.07-.63-.1-.99-.1-.68,0-1.01.19-1.01.57,0,.09.01.16.04.23.03.07.09.13.17.2s.21.13.36.2c.15.07.34.15.57.24.47.18.86.35,1.17.52.31.17.55.35.73.55.18.2.3.42.38.66.07.24.11.52.11.84,0,.75-.28,1.32-.85,1.71-.57.39-1.37.58-2.4.58-.68,0-1.24-.06-1.69-.17-.45-.12-.76-.21-.94-.29l.36-1.75c.37.15.74.26,1.13.34.39.08.77.12,1.15.12Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-272",
    d: "M263.92,173.49c0-.68.1-1.27.31-1.78s.48-.93.82-1.27c.34-.34.73-.59,1.17-.77.44-.17.89-.26,1.36-.26,1.08,0,1.94.33,2.57.99.63.66.94,1.64.94,2.92,0,.13,0,.26-.01.41,0,.15-.02.28-.03.4h-4.9c.05.44.26.8.62,1.06.37.26.86.39,1.48.39.4,0,.79-.04,1.17-.11.38-.07.69-.16.94-.27l.29,1.75c-.12.06-.27.12-.46.17s-.41.11-.65.15c-.24.04-.49.08-.76.11-.27.03-.54.04-.81.04-.69,0-1.28-.1-1.79-.3-.51-.2-.93-.48-1.26-.83-.33-.35-.58-.77-.74-1.25s-.24-1.01-.24-1.57ZM269,172.67c0-.18-.04-.36-.09-.54-.05-.17-.13-.33-.25-.46s-.25-.25-.42-.33c-.17-.09-.38-.13-.63-.13s-.45.04-.62.12c-.17.08-.32.19-.43.33-.12.14-.21.29-.27.47-.06.18-.11.36-.14.54h2.86Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-272",
    d: "M277.35,171.54c-.19-.05-.42-.1-.68-.15-.26-.05-.54-.08-.84-.08-.14,0-.3.01-.49.04s-.33.05-.43.08v5.83h-2.16v-7.22c.39-.14.84-.26,1.37-.38.53-.12,1.11-.18,1.76-.18.12,0,.26,0,.42.02.16.01.33.03.49.06.16.02.33.05.49.09.16.03.3.07.42.12l-.36,1.78Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-272",
    d: "M289.21,175.31v1.94h-6.71v-10.05h2.26v8.11h4.45Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-272",
    d: "M297.65,173.42c0,.6-.09,1.15-.26,1.65-.17.5-.42.92-.75,1.28-.33.35-.72.63-1.18.82s-.97.29-1.54.29-1.07-.1-1.53-.29-.85-.47-1.18-.82c-.33-.35-.58-.78-.77-1.28s-.28-1.05-.28-1.65.09-1.15.28-1.64c.19-.49.45-.91.78-1.26.33-.35.73-.62,1.19-.81s.96-.29,1.5-.29,1.06.1,1.51.29.85.46,1.18.81c.33.35.58.77.77,1.26.18.49.28,1.04.28,1.64ZM295.45,173.42c0-.67-.13-1.19-.4-1.57-.27-.38-.64-.57-1.14-.57s-.88.19-1.15.57-.41.91-.41,1.57.14,1.2.41,1.59.65.59,1.15.59.87-.2,1.14-.59c.27-.39.4-.92.4-1.59Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-272",
    d: "M305.9,176.29c0,1.25-.32,2.17-.95,2.78-.63.6-1.61.91-2.94.91-.46,0-.93-.04-1.39-.12s-.89-.19-1.29-.33l.38-1.81c.34.14.69.24,1.07.32.37.08.79.12,1.27.12.62,0,1.06-.14,1.31-.41.26-.27.38-.62.38-1.04v-.28c-.23.11-.47.19-.72.24-.25.05-.51.08-.8.08-1.05,0-1.86-.31-2.42-.94s-.84-1.5-.84-2.62c0-.56.09-1.07.26-1.53.17-.46.43-.85.76-1.18.33-.33.74-.58,1.23-.76.48-.18,1.03-.27,1.64-.27.26,0,.53.01.81.04.28.02.55.06.82.09s.53.08.78.14c.25.05.47.11.66.17v6.41ZM301.16,173.19c0,1.21.49,1.81,1.46,1.81.22,0,.43-.03.62-.09s.36-.13.49-.2v-3.45c-.11-.02-.23-.04-.38-.05-.14-.01-.31-.02-.51-.02-.57,0-1,.19-1.28.57-.28.38-.42.86-.42,1.44Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-272",
    d: "M310.12,175.7c.4,0,.68-.04.84-.12.16-.08.25-.23.25-.45,0-.17-.11-.33-.32-.46-.21-.13-.54-.28-.97-.44-.34-.13-.65-.26-.92-.39-.28-.14-.51-.3-.7-.49-.19-.19-.34-.41-.45-.67-.11-.26-.16-.58-.16-.94,0-.71.27-1.28.8-1.7.53-.42,1.26-.62,2.19-.62.46,0,.91.04,1.33.12.42.08.76.17,1.01.27l-.38,1.68c-.25-.09-.52-.16-.82-.23-.29-.07-.63-.1-.99-.1-.68,0-1.01.19-1.01.57,0,.09.01.16.04.23.03.07.09.13.17.2s.21.13.36.2c.15.07.34.15.57.24.47.18.86.35,1.17.52.31.17.55.35.73.55.18.2.3.42.38.66.07.24.11.52.11.84,0,.75-.28,1.32-.85,1.71-.57.39-1.37.58-2.4.58-.68,0-1.24-.06-1.69-.17-.45-.12-.76-.21-.94-.29l.36-1.75c.37.15.74.26,1.13.34.39.08.77.12,1.15.12Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-272",
    d: "M320.81,167.42c0,.4-.13.71-.38.94-.26.23-.56.34-.91.34s-.65-.11-.91-.34c-.26-.23-.38-.54-.38-.94s.13-.71.38-.94.56-.34.91-.34.65.11.91.34.38.54.38.94ZM320.61,177.25h-2.16v-7.63h2.16v7.63Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-272",
    d: "M322.63,169.88c.37-.11.84-.21,1.42-.3.58-.09,1.19-.14,1.83-.14s1.19.08,1.62.25c.43.17.77.41,1.02.72.25.31.43.68.54,1.1s.16.9.16,1.42v4.31h-2.16v-4.05c0-.7-.09-1.19-.28-1.48s-.53-.44-1.03-.44c-.16,0-.32,0-.49.02-.17.01-.33.03-.46.05v5.89h-2.16v-7.37Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-272",
    d: "M773.72,390.94h2.26v10.05h-2.26v-4.26h-3.8v4.26h-2.26v-10.05h2.26v3.84h3.8v-3.84Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-272",
    d: "M785.75,390.94v1.93h-3.03v8.12h-2.26v-8.12h-3.03v-1.93h8.32Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-272",
    d: "M789.73,390.94c.17.32.38.71.6,1.18.23.47.46.98.71,1.52.25.55.49,1.1.73,1.67.24.57.47,1.11.68,1.61.21-.5.44-1.04.68-1.61.24-.57.49-1.13.73-1.67.25-.55.48-1.05.71-1.52.23-.47.43-.86.6-1.18h2.06c.1.67.19,1.41.27,2.24.08.83.15,1.69.22,2.58.06.89.12,1.79.17,2.69.05.9.1,1.74.14,2.54h-2.2c-.03-.98-.07-2.04-.12-3.19-.05-1.15-.12-2.31-.22-3.48-.17.41-.37.86-.58,1.35-.21.49-.42.99-.63,1.48-.21.49-.41.96-.6,1.41-.19.45-.36.83-.49,1.15h-1.58c-.14-.32-.3-.7-.5-1.15-.19-.45-.4-.92-.6-1.41-.21-.49-.42-.99-.63-1.48s-.41-.94-.58-1.35c-.1,1.17-.17,2.33-.22,3.48-.05,1.15-.09,2.21-.12,3.19h-2.2c.04-.79.08-1.64.14-2.54.05-.9.11-1.8.17-2.69.06-.89.14-1.75.22-2.58.08-.83.17-1.57.27-2.24h2.16Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-272",
    d: "M806.78,399.05v1.94h-6.71v-10.05h2.26v8.11h4.45Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path32",
    className: "cls-223",
    d: "M1100.86,510.13v-2.06l-.52.4-.35-.47.92-.68h.61v2.81h-.66"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path34",
    className: "cls-223",
    d: "M1103.59,508.72c0-.09,0-.18-.02-.29-.01-.11-.03-.2-.06-.3-.03-.09-.07-.17-.13-.23-.05-.06-.12-.09-.21-.09s-.16.03-.21.09c-.06.06-.1.14-.13.23-.03.09-.05.19-.06.3-.01.11-.02.2-.02.29s0,.19.02.3c.01.11.03.21.06.3.03.09.07.17.13.23.06.06.13.09.21.09s.16-.03.21-.09c.05-.06.1-.14.13-.23.03-.09.05-.19.06-.3.01-.11.02-.21.02-.3ZM1104.27,508.72c0,.2-.02.39-.06.57-.04.18-.1.34-.19.47-.09.14-.2.24-.34.33-.14.08-.31.12-.51.12s-.37-.04-.51-.12c-.14-.08-.25-.19-.34-.33-.09-.14-.15-.29-.19-.47-.04-.18-.06-.37-.06-.57s.02-.39.06-.57c.04-.18.1-.33.19-.47.09-.13.2-.24.34-.32.14-.08.31-.12.51-.12s.37.04.51.12c.14.08.25.19.34.32.09.13.15.29.19.47.04.18.06.37.06.57"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path36",
    className: "cls-223",
    d: "M1107.99,510.13v-2.06l-.52.4-.35-.47.92-.68h.61v2.81h-.66"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path38",
    className: "cls-223",
    d: "M1110.71,508.72c0-.09,0-.18-.02-.29-.01-.11-.03-.2-.06-.3-.03-.09-.07-.17-.13-.23-.05-.06-.13-.09-.21-.09s-.16.03-.21.09c-.06.06-.1.14-.13.23-.03.09-.05.19-.06.3-.01.11-.02.2-.02.29s0,.19.02.3c.01.11.03.21.06.3.03.09.07.17.13.23.06.06.13.09.21.09s.16-.03.21-.09c.05-.06.1-.14.13-.23.03-.09.05-.19.06-.3.01-.11.02-.21.02-.3ZM1111.4,508.72c0,.2-.02.39-.06.57-.04.18-.1.34-.19.47-.09.14-.2.24-.34.33-.14.08-.31.12-.51.12s-.37-.04-.51-.12c-.14-.08-.25-.19-.34-.33-.09-.14-.15-.29-.19-.47-.04-.18-.06-.37-.06-.57s.02-.39.06-.57c.04-.18.1-.33.19-.47s.2-.24.34-.32c.14-.08.31-.12.51-.12s.37.04.51.12c.14.08.25.19.34.32.09.13.15.29.19.47.04.18.06.37.06.57"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path40",
    className: "cls-223",
    d: "M1100.8,514.55v-2.06l-.52.4-.35-.47.92-.68h.61v2.81h-.66"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path42",
    className: "cls-223",
    d: "M1103.14,514.55v-2.06l-.52.4-.35-.47.92-.68h.61v2.81h-.66"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path44",
    className: "cls-223",
    d: "M1105.46,514.55v-2.06l-.52.4-.34-.47.92-.68h.61v2.81h-.66"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path46",
    className: "cls-223",
    d: "M1108.31,513.14c0-.09,0-.18-.02-.29-.01-.11-.03-.2-.06-.3-.03-.09-.07-.17-.13-.23-.05-.06-.13-.09-.21-.09s-.16.03-.21.09c-.06.06-.1.14-.13.23-.03.09-.05.19-.06.3-.01.11-.02.2-.02.29s0,.19.02.3c.01.11.03.21.06.3.03.09.07.17.13.23.06.06.13.09.21.09s.16-.03.21-.09c.05-.06.1-.14.13-.23.03-.09.05-.19.06-.3.01-.11.02-.21.02-.3ZM1108.99,513.14c0,.2-.02.39-.06.57-.04.18-.1.34-.19.47-.09.14-.2.24-.34.32-.14.08-.31.12-.51.12s-.37-.04-.51-.12c-.14-.08-.25-.19-.34-.32-.09-.14-.15-.29-.19-.47-.04-.18-.06-.37-.06-.57s.02-.39.06-.57c.04-.18.1-.33.19-.47.09-.13.2-.24.34-.32.14-.08.31-.12.51-.12s.37.04.51.12c.14.08.25.19.34.32.09.13.15.29.19.47.04.18.06.37.06.57"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path48",
    className: "cls-223",
    d: "M1102.15,517.7v-1.5l-.38.29-.25-.34.67-.49h.44v2.04h-.48"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path50",
    className: "cls-223",
    d: "M1105.52,517.7v-1.5l-.38.29-.25-.34.67-.49h.44v2.04h-.48"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path52",
    className: "cls-223",
    d: "M1100.8,516.68c0-.06,0-.13-.01-.21,0-.08-.02-.15-.04-.21-.02-.07-.05-.12-.09-.17-.04-.04-.09-.07-.15-.07s-.12.02-.16.07c-.04.05-.07.1-.09.17-.02.07-.04.14-.04.21,0,.08-.01.15-.01.21s0,.14.01.21c0,.08.02.15.04.22.02.07.05.12.09.17.04.05.09.07.16.07s.11-.02.15-.07c.04-.05.07-.1.09-.17.02-.07.04-.14.04-.22,0-.08.01-.15.01-.21ZM1101.29,516.68c0,.14-.01.28-.04.41-.03.13-.08.25-.14.34-.06.1-.15.18-.25.24-.1.06-.22.09-.37.09s-.27-.03-.37-.09c-.1-.06-.18-.14-.25-.24-.06-.1-.11-.21-.14-.34-.03-.13-.04-.27-.04-.41s.01-.28.04-.41c.03-.13.08-.24.14-.34.06-.1.15-.17.25-.23.1-.06.22-.09.37-.09s.27.03.37.09c.1.06.18.14.25.23.06.1.11.21.14.34.03.13.04.27.04.41"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path54",
    className: "cls-223",
    d: "M1104.19,516.68c0-.06,0-.13-.01-.21,0-.08-.02-.15-.04-.21-.02-.07-.05-.12-.09-.17-.04-.04-.09-.07-.15-.07s-.12.02-.16.07c-.04.05-.07.1-.09.17-.02.07-.04.14-.04.21,0,.08-.01.15-.01.21s0,.14.01.21c0,.08.02.15.04.22.02.07.05.12.09.17.04.05.09.07.16.07s.11-.02.15-.07c.04-.05.07-.1.09-.17.02-.07.04-.14.04-.22,0-.08.01-.15.01-.21ZM1104.68,516.68c0,.14-.01.28-.04.41-.03.13-.08.25-.14.34-.06.1-.15.18-.25.24-.1.06-.22.09-.37.09s-.27-.03-.37-.09c-.1-.06-.18-.14-.25-.24-.06-.1-.11-.21-.14-.34-.03-.13-.04-.27-.04-.41s.01-.28.04-.41c.03-.13.08-.24.14-.34.06-.1.15-.17.25-.23.1-.06.22-.09.37-.09s.27.03.37.09c.1.06.18.14.25.23.06.1.11.21.14.34.03.13.04.27.04.41"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path56",
    className: "cls-223",
    d: "M1111.13,517.7v-1.5l-.38.29-.25-.34.67-.49h.44v2.04h-.48"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path58",
    className: "cls-223",
    d: "M1109.8,516.68c0-.06,0-.13-.01-.21,0-.08-.02-.15-.04-.21-.02-.07-.05-.12-.09-.17-.04-.04-.09-.07-.15-.07s-.12.02-.16.07c-.04.05-.07.1-.09.17-.02.07-.04.14-.04.21,0,.08-.01.15-.01.21s0,.14.01.21c0,.08.02.15.04.22.02.07.05.12.09.17.04.05.09.07.16.07s.11-.02.15-.07c.04-.05.07-.1.09-.17.02-.07.04-.14.04-.22,0-.08.01-.15.01-.21ZM1110.3,516.68c0,.14-.01.28-.04.41-.03.13-.08.25-.14.34-.06.1-.15.18-.25.24-.1.06-.22.09-.37.09s-.27-.03-.37-.09c-.1-.06-.18-.14-.25-.24-.06-.1-.11-.21-.14-.34-.03-.13-.04-.27-.04-.41s.01-.28.04-.41c.03-.13.08-.24.14-.34.06-.1.15-.17.25-.23.1-.06.22-.09.37-.09s.27.03.37.09c.1.06.18.14.25.23.06.1.11.21.14.34.03.13.04.27.04.41"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path60",
    className: "cls-223",
    d: "M1109.28,520.11v-1.5l-.38.29-.25-.34.67-.49h.44v2.04h-.48"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path62",
    className: "cls-223",
    d: "M1107.95,519.08c0-.06,0-.13-.01-.21,0-.08-.02-.15-.04-.21-.02-.07-.05-.12-.09-.17-.04-.04-.09-.07-.15-.07s-.12.02-.16.07c-.04.05-.07.1-.09.17-.02.07-.04.14-.04.21,0,.08-.01.15-.01.21s0,.14.01.21c0,.08.02.15.04.22.02.07.05.12.09.17.04.05.09.07.16.07s.11-.02.15-.07c.04-.05.07-.1.09-.17.02-.07.04-.14.04-.22,0-.08.01-.15.01-.21ZM1108.45,519.08c0,.14-.01.28-.04.41-.03.13-.08.25-.14.34-.06.1-.15.18-.25.24-.1.06-.22.09-.37.09s-.27-.03-.37-.09c-.1-.06-.18-.14-.25-.24-.06-.1-.11-.21-.14-.34-.03-.13-.04-.27-.04-.41s.01-.28.04-.41c.03-.13.08-.24.14-.34.06-.1.15-.17.25-.23.1-.06.22-.09.37-.09s.27.03.37.09c.1.06.18.14.25.23.06.1.11.21.14.34.03.13.04.27.04.41"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path64",
    className: "cls-223",
    d: "M1101.47,520.08v-1.04l-.26.2-.17-.24.46-.34h.31v1.41h-.33"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path66",
    className: "cls-223",
    d: "M1100.55,519.37s0-.09,0-.15c0-.05-.02-.1-.03-.15-.01-.05-.04-.08-.06-.12-.03-.03-.06-.05-.11-.05s-.08.02-.11.05c-.03.03-.05.07-.07.12-.02.05-.03.1-.03.15,0,.05,0,.1,0,.15s0,.09,0,.15c0,.05.02.1.03.15.02.05.04.08.07.12.03.03.06.05.11.05s.08-.02.11-.05c.03-.03.05-.07.06-.12.01-.05.02-.1.03-.15,0-.05,0-.1,0-.15ZM1100.9,519.37c0,.1-.01.19-.03.29-.02.09-.05.17-.1.24-.04.07-.1.12-.17.16-.07.04-.15.06-.25.06s-.19-.02-.26-.06c-.07-.04-.13-.09-.17-.16-.04-.07-.08-.15-.1-.24-.02-.09-.03-.19-.03-.29s0-.19.03-.28c.02-.09.05-.17.1-.24.04-.07.1-.12.17-.16.07-.04.16-.06.26-.06s.18.02.25.06c.07.04.13.09.17.16.04.07.08.15.1.24.02.09.03.18.03.28"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path68",
    className: "cls-223",
    d: "M1105.62,521.89v-1.04l-.26.2-.17-.24.47-.34h.31v1.41h-.33"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path70",
    className: "cls-223",
    d: "M1104.7,521.18s0-.09,0-.15c0-.05-.01-.1-.03-.15s-.04-.08-.06-.12c-.03-.03-.06-.05-.11-.05s-.08.02-.11.05c-.03.03-.05.07-.07.12-.02.05-.03.1-.03.15,0,.05,0,.1,0,.15s0,.09,0,.15c0,.05.02.1.03.15.01.05.04.08.07.12.03.03.06.05.11.05s.08-.02.11-.05c.03-.03.05-.07.06-.12.01-.05.02-.1.03-.15,0-.05,0-.1,0-.15ZM1105.04,521.18c0,.1-.01.19-.03.29-.02.09-.05.17-.1.24-.04.07-.1.12-.17.16-.07.04-.15.06-.25.06s-.18-.02-.26-.06c-.07-.04-.13-.1-.17-.16-.04-.07-.08-.15-.1-.24-.02-.09-.03-.19-.03-.29s.01-.2.03-.28c.02-.09.05-.17.1-.24.04-.07.1-.12.17-.16.07-.04.16-.06.26-.06s.18.02.25.06c.07.04.13.09.17.16.04.07.08.15.1.24.02.09.03.18.03.28"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path72",
    className: "cls-223",
    d: "M1111.32,519.08c0-.06,0-.13-.01-.21,0-.08-.02-.15-.04-.21-.02-.07-.05-.12-.09-.17-.04-.04-.09-.07-.15-.07s-.12.02-.16.07c-.04.05-.07.1-.09.17-.02.07-.04.14-.04.21,0,.08-.01.15-.01.21s0,.14.01.21c0,.08.02.15.04.22.02.07.05.12.09.17.04.05.09.07.16.07s.11-.02.15-.07c.04-.05.07-.1.09-.17.02-.07.04-.14.04-.22,0-.08.01-.15.01-.21ZM1111.81,519.08c0,.14-.01.28-.04.41-.03.13-.08.25-.14.34-.06.1-.15.18-.25.24-.1.06-.22.09-.37.09s-.27-.03-.37-.09c-.1-.06-.18-.14-.25-.24-.06-.1-.11-.21-.14-.34-.03-.13-.04-.27-.04-.41s.01-.28.04-.41c.03-.13.08-.24.14-.34.06-.1.15-.17.25-.23.1-.06.22-.09.37-.09s.27.03.37.09c.1.06.18.14.25.23.06.1.11.21.14.34.03.13.04.27.04.41"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path74",
    className: "cls-223",
    d: "M1110.39,505.31c-.47-2.3-2.52-3.97-4.87-3.97-.36,0-.71.04-1.05.11-.57-3.35-3.49-5.91-7-5.91s-6.38,2.51-6.99,5.82c-2.53.23-4.51,2.36-4.51,4.95,0,2.74,2.23,4.97,4.97,4.97h7.43c.38,0,.69-.31.69-.69s-.31-.69-.69-.69h-7.43c-1.98,0-3.59-1.61-3.59-3.59s1.61-3.59,3.59-3.59c.72,0,1.41.21,2.01.61.31.21.74.13.95-.18.21-.31.13-.74-.18-.95-.56-.38-1.19-.63-1.85-.76.56-2.58,2.86-4.51,5.6-4.51,2.92,0,5.34,2.2,5.69,5.02-.18.1-.36.21-.54.33-.31.22-.38.65-.16.96.22.31.65.38.96.15.61-.44,1.34-.68,2.1-.68,1.7,0,3.18,1.21,3.52,2.87.07.32.35.55.67.55.05,0,.09,0,.14-.01.37-.08.61-.44.54-.81"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-70",
    cx: 287.28,
    cy: 224.23,
    r: 14.35
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-223",
    d: "M283.44,220.17c.35-.14.71-.31,1.09-.49s.75-.39,1.1-.61c.36-.22.7-.45,1.03-.7s.62-.51.89-.78h1.87v12.44h-2.67v-8.95c-.36.24-.76.46-1.2.65-.44.2-.87.37-1.29.51l-.81-2.06Z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-70",
    cx: 287.28,
    cy: 441.94,
    r: 14.35
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-223",
    d: "M291.08,438.56c0,.45-.09.89-.27,1.31s-.41.82-.7,1.21c-.29.39-.61.76-.97,1.12-.36.36-.71.7-1.06,1.02-.18.17-.37.36-.58.57-.21.21-.41.42-.6.64-.19.21-.36.42-.51.6s-.24.34-.28.46h5.35v2.24h-8.29c-.02-.13-.04-.3-.04-.5v-.43c0-.57.09-1.1.28-1.58s.43-.92.73-1.34.64-.8,1.01-1.16c.38-.36.75-.72,1.12-1.08.29-.27.56-.54.81-.78.25-.25.47-.48.66-.72.19-.23.34-.47.45-.7s.16-.47.16-.71c0-.53-.15-.9-.45-1.11-.3-.21-.67-.32-1.11-.32-.32,0-.63.05-.91.15-.28.1-.54.22-.77.36-.23.14-.43.28-.6.41-.17.14-.29.25-.38.33l-1.33-1.87c.53-.49,1.14-.89,1.84-1.21.7-.32,1.45-.48,2.25-.48.73,0,1.36.08,1.88.25.53.17.96.4,1.3.71.34.31.59.68.75,1.11.16.44.24.93.24,1.48Z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-70",
    cx: 880.06,
    cy: 262.25,
    r: 14.35
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-223",
    d: "M879.96,268.31c-.32,0-.66-.02-1.02-.06-.36-.04-.71-.1-1.04-.17-.33-.07-.64-.15-.92-.23s-.49-.16-.65-.23l.52-2.23c.31.13.71.27,1.19.42.48.15,1.08.22,1.8.22.83,0,1.43-.16,1.81-.47.38-.31.57-.73.57-1.26,0-.32-.07-.6-.21-.82-.14-.22-.33-.4-.57-.54s-.52-.23-.85-.29-.68-.08-1.05-.08h-1.04v-2.15h1.18c.26,0,.52-.02.76-.07.25-.05.46-.13.66-.24s.34-.27.46-.47c.11-.2.17-.45.17-.75,0-.23-.05-.42-.14-.59-.1-.17-.22-.3-.37-.41-.15-.11-.32-.19-.52-.24s-.4-.08-.6-.08c-.51,0-.99.08-1.43.23-.44.16-.83.35-1.19.57l-.95-1.96c.19-.12.42-.25.67-.38.26-.13.54-.25.85-.36.31-.11.64-.2,1-.27s.73-.11,1.12-.11c.73,0,1.36.09,1.89.26s.97.42,1.32.73c.35.32.6.69.77,1.11.17.42.25.89.25,1.39s-.14.96-.41,1.42c-.28.46-.65.81-1.11,1.05.65.26,1.15.66,1.5,1.18.35.52.53,1.15.53,1.88,0,.58-.1,1.1-.29,1.59-.19.49-.49.9-.9,1.26-.41.35-.92.63-1.55.83-.63.2-1.37.3-2.23.3Z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-70",
    cx: 287.28,
    cy: 79.07,
    r: 14.35
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-223",
    d: "M290.53,72.42v7.47h1.33v2.19h-1.33v2.78h-2.62v-2.78h-5.37v-1.96c.26-.53.59-1.12.99-1.79s.83-1.35,1.32-2.05,1-1.38,1.53-2.05,1.08-1.27,1.62-1.81h2.53ZM287.91,75.68c-.47.61-.96,1.27-1.49,1.99s-.97,1.45-1.33,2.21h2.82v-4.2Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-370",
    d: "M767.53,528.08l5.06,2.08-.37,1.1-6.16-2.61v-1.14l6.16-2.61.37,1.1-5.06,2.08Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-370",
    d: "M776.87,524.74c.53,0,.98.07,1.35.21.37.14.66.33.88.58.22.25.38.55.48.9.09.35.14.73.14,1.15v4.63c-.11.02-.27.04-.48.08s-.43.06-.69.09-.53.05-.83.08c-.3.02-.6.04-.89.04-.42,0-.8-.04-1.15-.13-.35-.08-.66-.22-.91-.41-.26-.18-.46-.43-.6-.73-.14-.3-.21-.67-.21-1.1s.08-.76.25-1.05c.17-.29.39-.53.68-.71.29-.18.62-.31,1-.4.38-.09.78-.13,1.2-.13.13,0,.27,0,.41.02.14.01.28.03.41.06.13.02.24.04.33.06.1.02.16.03.2.04v-.37c0-.22-.02-.43-.07-.65-.05-.21-.13-.4-.26-.57s-.29-.3-.51-.4c-.21-.1-.49-.15-.83-.15-.44,0-.82.03-1.15.09-.33.06-.57.13-.73.19l-.16-1.1c.17-.08.46-.15.85-.22.4-.07.83-.11,1.3-.11ZM776.99,531.38c.31,0,.59,0,.83-.02.24-.01.44-.04.61-.08v-2.21c-.1-.05-.25-.09-.46-.12-.21-.03-.47-.05-.78-.05-.2,0-.41.01-.63.04-.22.03-.43.09-.61.18-.18.09-.34.21-.46.37-.12.16-.19.36-.19.62,0,.48.15.81.46.99.3.18.72.28,1.24.28Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-370",
    d: "M785.21,532.34v-10.83l1.33-.23v3.79c.25-.09.51-.17.79-.22.28-.05.56-.08.83-.08.59,0,1.08.08,1.47.25.39.17.7.4.93.7.23.3.4.66.49,1.08.09.42.14.88.14,1.38v4.16h-1.33v-3.88c0-.46-.03-.85-.09-1.17-.06-.32-.16-.58-.31-.78-.14-.2-.33-.34-.57-.43-.24-.09-.53-.13-.88-.13-.14,0-.29,0-.44.03-.15.02-.3.04-.43.06-.14.02-.26.05-.37.08s-.19.05-.23.07v6.16h-1.33Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-370",
    d: "M796.08,524.77c.11,0,.25,0,.39.02.15.01.29.03.43.06.14.02.27.05.39.07.12.02.21.05.26.06l-.23,1.15c-.11-.04-.28-.08-.52-.14-.24-.05-.55-.08-.93-.08-.25,0-.49.03-.73.08-.24.05-.4.09-.48.11v6.23h-1.33v-7.1c.31-.11.7-.22,1.17-.32s.99-.15,1.57-.15Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-370",
    d: "M798.44,528.65c0-.66.09-1.23.29-1.72s.44-.9.76-1.22c.31-.32.67-.57,1.08-.73.41-.16.83-.24,1.25-.24,1,0,1.76.31,2.29.93s.8,1.57.8,2.84v.22c0,.09,0,.17-.01.25h-5.07c.06.77.28,1.35.67,1.75.39.4,1,.6,1.82.6.46,0,.86-.04,1.18-.12.32-.08.56-.16.72-.23l.18,1.11c-.16.08-.44.18-.85.27-.4.09-.86.14-1.38.14-.65,0-1.2-.1-1.67-.29s-.86-.46-1.16-.81c-.3-.34-.53-.75-.68-1.22-.15-.47-.22-.99-.22-1.55ZM803.52,527.92c0-.6-.14-1.09-.45-1.47s-.73-.58-1.28-.58c-.3,0-.57.06-.8.18-.23.12-.43.27-.59.46-.16.19-.29.41-.38.66-.09.25-.15.5-.18.75h3.68Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-370",
    d: "M809.71,521.28c.39,0,.72.03,1,.08.28.06.48.11.59.16l-.24,1.14c-.11-.06-.28-.11-.48-.16-.21-.05-.47-.08-.77-.08-.62,0-1.05.17-1.3.51-.25.34-.37.79-.37,1.36v.64h2.85v1.11h-2.85v6.3h-1.33v-8.08c0-.95.23-1.68.7-2.2.46-.52,1.2-.78,2.19-.78Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-370",
    d: "M811.93,526h6.53v1.13h-6.53v-1.13ZM811.93,529.03h6.53v1.13h-6.53v-1.13Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-370",
    d: "M821.62,521.51v.71c0,.47-.03.95-.08,1.46-.06.51-.13,1.01-.21,1.52h-.78c-.08-.5-.16-1.01-.21-1.52-.06-.51-.08-1-.08-1.48v-.7h1.38ZM824.14,521.51v.71c0,.47-.03.95-.08,1.46-.06.51-.13,1.01-.21,1.52h-.78c-.08-.5-.16-1.01-.21-1.52-.06-.51-.08-1-.08-1.48v-.7h1.38Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-370",
    d: "M826.31,532.34v-10.83l1.33-.23v3.79c.25-.09.51-.17.79-.22.28-.05.56-.08.83-.08.59,0,1.08.08,1.47.25.39.17.7.4.93.7.23.3.4.66.49,1.08.09.42.14.88.14,1.38v4.16h-1.33v-3.88c0-.46-.03-.85-.09-1.17-.06-.32-.16-.58-.31-.78-.14-.2-.33-.34-.57-.43-.24-.09-.53-.13-.88-.13-.14,0-.29,0-.44.03-.15.02-.3.04-.43.06-.14.02-.26.05-.37.08s-.19.05-.23.07v6.16h-1.33Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-370",
    d: "M835.69,524.93h2.81v1.11h-2.81v3.42c0,.37.03.68.09.92.06.24.14.43.26.57.11.14.26.24.43.29.17.06.37.09.6.09.4,0,.72-.04.96-.14.24-.09.41-.15.51-.19l.26,1.1c-.13.07-.37.15-.7.25-.33.1-.71.15-1.14.15-.5,0-.92-.06-1.25-.19-.33-.13-.59-.32-.79-.58-.2-.26-.34-.57-.42-.95-.08-.38-.12-.81-.12-1.3v-6.61l1.33-.23v2.29Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-370",
    d: "M841.42,524.93h2.81v1.11h-2.81v3.42c0,.37.03.68.09.92.06.24.14.43.26.57.11.14.26.24.43.29.17.06.37.09.6.09.4,0,.72-.04.96-.14.24-.09.41-.15.51-.19l.26,1.1c-.13.07-.37.15-.7.25-.33.1-.71.15-1.14.15-.5,0-.92-.06-1.25-.19-.33-.13-.59-.32-.79-.58-.2-.26-.34-.57-.42-.95-.08-.38-.12-.81-.12-1.3v-6.61l1.33-.23v2.29Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-370",
    d: "M852.43,528.65c0,.56-.07,1.08-.22,1.55-.15.48-.36.88-.65,1.23s-.63.61-1.05.8c-.41.19-.89.29-1.42.29-.43,0-.8-.06-1.13-.17-.33-.11-.57-.22-.73-.33v2.96h-1.33v-9.82c.31-.08.71-.16,1.18-.25.47-.09,1.01-.14,1.63-.14.57,0,1.08.09,1.54.27.46.18.85.44,1.17.77.32.33.57.74.75,1.22s.26,1.02.26,1.62ZM851.05,528.65c0-.86-.21-1.53-.64-2-.43-.46-1-.7-1.71-.7-.4,0-.71.01-.93.04-.22.03-.4.06-.53.1v4.67c.16.13.39.26.7.38.3.12.64.18,1,.18.38,0,.71-.07.98-.21s.49-.33.66-.57c.17-.24.29-.53.37-.85.08-.33.11-.68.11-1.06Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-370",
    d: "M855.87,525.88c0,.26-.09.48-.26.67-.17.19-.4.29-.7.29s-.53-.09-.7-.29c-.17-.19-.26-.41-.26-.67s.09-.48.26-.67c.17-.19.4-.28.7-.28s.53.09.7.28c.17.19.26.41.26.67ZM855.87,531.57c0,.26-.09.48-.26.67-.17.19-.4.29-.7.29s-.53-.1-.7-.29c-.17-.19-.26-.41-.26-.67s.09-.48.26-.67c.17-.19.4-.29.7-.29s.53.1.7.29c.17.19.26.41.26.67Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-370",
    d: "M857.68,534.98h-1.35l4.83-13.8h1.33l-4.8,13.8Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-370",
    d: "M863.15,534.98h-1.35l4.83-13.8h1.33l-4.8,13.8Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-370",
    d: "M868.75,525.14c.3-.08.71-.16,1.21-.24.5-.08,1.08-.13,1.73-.13.47,0,.87.06,1.2.19.32.13.59.32.81.56.07-.05.17-.11.31-.2.14-.08.32-.17.53-.25s.44-.15.7-.21c.26-.06.53-.09.83-.09.57,0,1.04.08,1.4.25.36.17.64.4.85.71.2.3.34.67.41,1.08s.11.87.11,1.37v4.16h-1.33v-3.88c0-.44-.02-.81-.06-1.13s-.12-.58-.24-.78c-.12-.21-.28-.36-.48-.46-.21-.1-.47-.15-.79-.15-.45,0-.81.06-1.1.18-.29.12-.49.23-.59.32.08.25.13.52.17.81.04.29.06.6.06.93v4.16h-1.33v-3.88c0-.44-.02-.81-.07-1.13-.05-.31-.13-.58-.25-.78s-.28-.36-.48-.46-.46-.15-.78-.15c-.13,0-.28,0-.43.01-.15,0-.3.02-.43.04-.14.01-.26.03-.38.05-.11.02-.19.03-.23.04v6.26h-1.33v-7.2Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-370",
    d: "M879.89,533.72c.1.05.24.09.41.13s.33.06.49.06c.52,0,.93-.12,1.23-.35.29-.23.56-.61.8-1.13-.6-1.14-1.16-2.35-1.67-3.63-.52-1.28-.95-2.57-1.29-3.88h1.43c.1.43.23.89.38,1.38.15.49.31,1,.49,1.53s.38,1.04.58,1.57.43,1.03.66,1.51c.36-1,.67-1.99.94-2.96.27-.98.52-1.99.75-3.02h1.37c-.34,1.4-.72,2.74-1.14,4.03-.42,1.29-.87,2.49-1.35,3.61-.19.43-.39.8-.59,1.1-.21.31-.43.56-.68.76-.25.2-.53.35-.83.44-.31.09-.66.14-1.05.14-.1,0-.21,0-.33-.02-.11-.01-.23-.03-.33-.06-.11-.02-.21-.05-.3-.08-.09-.03-.15-.05-.19-.07l.24-1.07Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-370",
    d: "M889.17,525.26c.16-.1.41-.21.73-.33.33-.11.71-.17,1.13-.17.53,0,1,.1,1.42.29.41.19.76.46,1.05.8.29.34.5.75.65,1.23.15.47.22,1,.22,1.57,0,.6-.09,1.14-.26,1.62s-.42.89-.75,1.22c-.32.33-.71.59-1.17.77s-.97.27-1.54.27c-.62,0-1.16-.04-1.64-.13-.47-.09-.86-.17-1.17-.26v-10.62l1.33-.23v3.98ZM889.17,531.19c.13.04.32.07.56.11.24.03.54.05.91.05.71,0,1.28-.23,1.71-.71.43-.47.64-1.14.64-2,0-.38-.04-.74-.11-1.07-.08-.33-.2-.62-.37-.86-.17-.24-.39-.43-.66-.57s-.6-.21-.98-.21-.69.06-1,.19c-.3.12-.54.25-.7.38v4.69Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-370",
    d: "M898.63,524.74c.53,0,.98.07,1.35.21.37.14.66.33.88.58.22.25.38.55.48.9.09.35.14.73.14,1.15v4.63c-.11.02-.27.04-.48.08s-.43.06-.69.09-.53.05-.83.08c-.3.02-.6.04-.89.04-.42,0-.8-.04-1.15-.13-.35-.08-.66-.22-.91-.41-.26-.18-.46-.43-.6-.73-.14-.3-.21-.67-.21-1.1s.08-.76.25-1.05c.17-.29.39-.53.68-.71.29-.18.62-.31,1-.4.38-.09.78-.13,1.2-.13.13,0,.27,0,.41.02.14.01.28.03.41.06.13.02.24.04.33.06.1.02.16.03.2.04v-.37c0-.22-.02-.43-.07-.65-.05-.21-.13-.4-.26-.57s-.29-.3-.51-.4c-.21-.1-.49-.15-.83-.15-.44,0-.82.03-1.15.09-.33.06-.57.13-.73.19l-.16-1.1c.17-.08.46-.15.85-.22.4-.07.83-.11,1.3-.11ZM898.75,531.38c.31,0,.59,0,.83-.02.24-.01.44-.04.61-.08v-2.21c-.1-.05-.25-.09-.46-.12-.21-.03-.47-.05-.78-.05-.2,0-.41.01-.63.04-.22.03-.43.09-.61.18-.18.09-.34.21-.46.37-.12.16-.19.36-.19.62,0,.48.15.81.46.99.3.18.72.28,1.24.28Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-370",
    d: "M903.68,525.14c.3-.08.71-.16,1.21-.24.5-.08,1.08-.13,1.74-.13.59,0,1.08.08,1.47.25.39.17.7.4.93.7.23.3.4.66.49,1.08.09.42.14.88.14,1.38v4.16h-1.33v-3.88c0-.46-.03-.85-.09-1.17-.06-.32-.16-.58-.31-.78-.14-.2-.33-.34-.57-.43-.24-.09-.53-.13-.88-.13-.14,0-.29,0-.44.01-.15,0-.3.02-.43.04-.14.01-.26.03-.37.05-.11.02-.19.03-.23.04v6.26h-1.33v-7.2Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-370",
    d: "M914.54,528.26c.29.22.59.49.91.81.32.32.63.67.94,1.05s.6.75.88,1.14.51.74.7,1.08h-1.55c-.2-.33-.43-.67-.69-1.02-.26-.35-.53-.68-.82-1s-.58-.61-.87-.88c-.29-.27-.58-.49-.84-.67v3.56h-1.33v-10.83l1.33-.23v6.75c.23-.23.48-.48.75-.76.28-.28.55-.56.81-.84.27-.28.52-.56.75-.82.24-.26.44-.49.61-.69h1.55c-.22.24-.46.5-.71.78s-.52.57-.8.86c-.28.29-.55.58-.83.87-.28.29-.54.56-.79.82Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-370",
    d: "M920.87,531.57c0,.26-.09.48-.26.67-.17.19-.4.29-.7.29s-.53-.1-.7-.29c-.17-.19-.26-.41-.26-.67s.09-.48.26-.67c.17-.19.4-.29.7-.29s.53.1.7.29c.17.19.26.41.26.67Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-370",
    d: "M924.04,524.93h2.81v1.11h-2.81v3.42c0,.37.03.68.09.92.06.24.14.43.26.57.11.14.26.24.43.29.17.06.37.09.6.09.4,0,.72-.04.96-.14.24-.09.41-.15.51-.19l.26,1.1c-.13.07-.37.15-.7.25-.33.1-.71.15-1.14.15-.5,0-.92-.06-1.25-.19-.33-.13-.59-.32-.79-.58-.2-.26-.34-.57-.42-.95-.08-.38-.12-.81-.12-1.3v-6.61l1.33-.23v2.29Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-370",
    d: "M928.53,532.34v-10.83l1.33-.23v3.79c.25-.09.51-.17.79-.22.28-.05.56-.08.83-.08.59,0,1.08.08,1.47.25.39.17.7.4.93.7.23.3.4.66.49,1.08.09.42.14.88.14,1.38v4.16h-1.33v-3.88c0-.46-.03-.85-.09-1.17-.06-.32-.16-.58-.31-.78-.14-.2-.33-.34-.57-.43-.24-.09-.53-.13-.88-.13-.14,0-.29,0-.44.03-.15.02-.3.04-.43.06-.14.02-.26.05-.37.08s-.19.05-.23.07v6.16h-1.33Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-370",
    d: "M936.67,525.14c.3-.08.71-.16,1.21-.24.5-.08,1.08-.13,1.73-.13.47,0,.87.06,1.2.19.32.13.59.32.81.56.07-.05.17-.11.31-.2.14-.08.32-.17.53-.25s.44-.15.7-.21c.26-.06.53-.09.83-.09.57,0,1.04.08,1.4.25.36.17.64.4.85.71.2.3.34.67.41,1.08s.11.87.11,1.37v4.16h-1.33v-3.88c0-.44-.02-.81-.06-1.13s-.12-.58-.24-.78c-.12-.21-.28-.36-.48-.46-.21-.1-.47-.15-.79-.15-.45,0-.81.06-1.1.18-.29.12-.49.23-.59.32.08.25.13.52.17.81.04.29.06.6.06.93v4.16h-1.33v-3.88c0-.44-.02-.81-.07-1.13-.05-.31-.13-.58-.25-.78s-.28-.36-.48-.46-.46-.15-.78-.15c-.13,0-.28,0-.43.01-.15,0-.3.02-.43.04-.14.01-.26.03-.38.05-.11.02-.19.03-.23.04v6.26h-1.33v-7.2Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-370",
    d: "M948.81,534.98h-1.35l4.83-13.8h1.33l-4.8,13.8Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-370",
    d: "M955.65,524.93h2.81v1.11h-2.81v3.42c0,.37.03.68.09.92.06.24.14.43.26.57.11.14.26.24.43.29.17.06.37.09.6.09.4,0,.72-.04.96-.14.24-.09.41-.15.51-.19l.26,1.1c-.13.07-.37.15-.7.25-.33.1-.71.15-1.14.15-.5,0-.92-.06-1.25-.19-.33-.13-.59-.32-.79-.58-.2-.26-.34-.57-.42-.95-.08-.38-.12-.81-.12-1.3v-6.61l1.33-.23v2.29Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-370",
    d: "M962.88,524.77c.11,0,.25,0,.39.02.15.01.29.03.43.06.14.02.27.05.39.07.12.02.21.05.26.06l-.23,1.15c-.11-.04-.28-.08-.52-.14-.24-.05-.55-.08-.93-.08-.25,0-.49.03-.73.08-.24.05-.4.09-.48.11v6.23h-1.33v-7.1c.31-.11.7-.22,1.17-.32s.99-.15,1.57-.15Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-370",
    d: "M968.04,524.74c.53,0,.98.07,1.35.21.37.14.66.33.88.58.22.25.38.55.48.9.09.35.14.73.14,1.15v4.63c-.11.02-.27.04-.48.08s-.43.06-.69.09-.53.05-.83.08c-.3.02-.6.04-.89.04-.42,0-.8-.04-1.15-.13-.35-.08-.66-.22-.91-.41-.26-.18-.46-.43-.6-.73-.14-.3-.21-.67-.21-1.1s.08-.76.25-1.05c.17-.29.39-.53.68-.71.29-.18.62-.31,1-.4.38-.09.78-.13,1.2-.13.13,0,.27,0,.41.02.14.01.28.03.41.06.13.02.24.04.33.06.1.02.16.03.2.04v-.37c0-.22-.02-.43-.07-.65-.05-.21-.13-.4-.26-.57s-.29-.3-.51-.4c-.21-.1-.49-.15-.83-.15-.44,0-.82.03-1.15.09-.33.06-.57.13-.73.19l-.16-1.1c.17-.08.46-.15.85-.22.4-.07.83-.11,1.3-.11ZM968.15,531.38c.31,0,.59,0,.83-.02.24-.01.44-.04.61-.08v-2.21c-.1-.05-.25-.09-.46-.12-.21-.03-.47-.05-.78-.05-.2,0-.41.01-.63.04-.22.03-.43.09-.61.18-.18.09-.34.21-.46.37-.12.16-.19.36-.19.62,0,.48.15.81.46.99.3.18.72.28,1.24.28Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-370",
    d: "M973.08,525.14c.3-.08.71-.16,1.21-.24.5-.08,1.08-.13,1.74-.13.59,0,1.08.08,1.47.25.39.17.7.4.93.7.23.3.4.66.49,1.08.09.42.14.88.14,1.38v4.16h-1.33v-3.88c0-.46-.03-.85-.09-1.17-.06-.32-.16-.58-.31-.78-.14-.2-.33-.34-.57-.43-.24-.09-.53-.13-.88-.13-.14,0-.29,0-.44.01-.15,0-.3.02-.43.04-.14.01-.26.03-.37.05-.11.02-.19.03-.23.04v6.26h-1.33v-7.2Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-370",
    d: "M982.99,531.38c.54,0,.94-.07,1.2-.21.26-.14.39-.37.39-.68s-.13-.58-.38-.77c-.26-.19-.68-.4-1.27-.64-.29-.11-.56-.23-.82-.35-.26-.12-.49-.26-.68-.42-.19-.16-.34-.36-.46-.58-.11-.23-.17-.51-.17-.84,0-.66.24-1.18.73-1.56s1.14-.58,1.98-.58c.21,0,.42.01.63.04.21.02.4.05.58.09.18.03.34.07.48.11.14.04.25.07.32.1l-.24,1.14c-.14-.08-.37-.15-.67-.24-.3-.08-.67-.12-1.1-.12-.37,0-.69.07-.97.22-.28.15-.41.38-.41.69,0,.16.03.3.09.43.06.12.16.24.28.33.13.1.29.19.48.28.19.09.42.18.68.27.35.13.67.26.94.39s.51.28.71.45c.2.17.34.38.45.62.1.24.16.54.16.89,0,.68-.25,1.2-.76,1.55-.51.35-1.23.53-2.17.53-.66,0-1.17-.05-1.54-.16-.37-.11-.62-.19-.75-.25l.24-1.14c.15.06.39.14.73.26s.77.17,1.33.17Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-370",
    d: "M990.51,521.28c.39,0,.72.03,1,.08.28.06.48.11.59.16l-.24,1.14c-.11-.06-.28-.11-.48-.16-.21-.05-.47-.08-.77-.08-.62,0-1.05.17-1.3.51-.25.34-.37.79-.37,1.36v.64h2.85v1.11h-2.85v6.3h-1.33v-8.08c0-.95.23-1.68.7-2.2.46-.52,1.2-.78,2.19-.78Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-370",
    d: "M992.7,528.65c0-.66.09-1.23.29-1.72s.44-.9.76-1.22c.31-.32.67-.57,1.08-.73.41-.16.83-.24,1.25-.24,1,0,1.76.31,2.29.93s.8,1.57.8,2.84v.22c0,.09,0,.17-.01.25h-5.07c.06.77.28,1.35.67,1.75.39.4,1,.6,1.82.6.46,0,.86-.04,1.18-.12.32-.08.56-.16.72-.23l.18,1.11c-.16.08-.44.18-.85.27-.4.09-.86.14-1.38.14-.65,0-1.2-.1-1.67-.29s-.86-.46-1.16-.81c-.3-.34-.53-.75-.68-1.22-.15-.47-.22-.99-.22-1.55ZM997.79,527.92c0-.6-.14-1.09-.45-1.47s-.73-.58-1.28-.58c-.3,0-.57.06-.8.18-.23.12-.43.27-.59.46-.16.19-.29.41-.38.66-.09.25-.15.5-.18.75h3.68Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-370",
    d: "M1003.82,524.77c.11,0,.25,0,.39.02.15.01.29.03.43.06.14.02.27.05.39.07.12.02.21.05.26.06l-.23,1.15c-.11-.04-.28-.08-.52-.14-.24-.05-.55-.08-.93-.08-.25,0-.49.03-.73.08-.24.05-.4.09-.48.11v6.23h-1.33v-7.1c.31-.11.7-.22,1.17-.32s.99-.15,1.57-.15Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-370",
    d: "M1007.31,523.35c-.63,0-1.24.16-1.84.48l-.37-1.03c.32-.17.69-.31,1.09-.41.4-.1.83-.16,1.29-.16.54,0,.99.07,1.33.22s.62.33.83.56c.21.23.35.48.43.76.08.28.12.55.12.8,0,.32-.06.61-.19.86-.12.25-.28.49-.46.71-.18.22-.38.43-.6.63-.22.2-.42.41-.6.62-.18.21-.33.45-.46.7-.12.25-.19.53-.19.85v.16c0,.06,0,.11.01.16h-1.11c-.04-.19-.06-.39-.06-.6,0-.3.05-.58.16-.83s.25-.48.42-.69.35-.41.54-.6c.19-.19.37-.37.54-.56.17-.19.31-.39.42-.6s.16-.44.16-.68c0-.4-.13-.72-.38-.98-.26-.25-.63-.38-1.13-.38ZM1008.21,531.57c0,.26-.09.48-.26.67-.17.19-.4.29-.7.29s-.53-.1-.7-.29c-.17-.19-.26-.41-.26-.67s.09-.48.26-.67c.17-.19.4-.29.7-.29s.53.1.7.29c.17.19.26.41.26.67Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-370",
    d: "M1014.12,524.74c.53,0,.98.07,1.35.21.37.14.66.33.88.58.22.25.38.55.48.9.09.35.14.73.14,1.15v4.63c-.11.02-.27.04-.48.08s-.43.06-.69.09-.53.05-.83.08c-.3.02-.6.04-.89.04-.42,0-.8-.04-1.15-.13-.35-.08-.66-.22-.91-.41-.26-.18-.46-.43-.6-.73-.14-.3-.21-.67-.21-1.1s.08-.76.25-1.05c.17-.29.39-.53.68-.71.29-.18.62-.31,1-.4.38-.09.78-.13,1.2-.13.13,0,.27,0,.41.02.14.01.28.03.41.06.13.02.24.04.33.06.1.02.16.03.2.04v-.37c0-.22-.02-.43-.07-.65-.05-.21-.13-.4-.26-.57s-.29-.3-.51-.4c-.21-.1-.49-.15-.83-.15-.44,0-.82.03-1.15.09-.33.06-.57.13-.73.19l-.16-1.1c.17-.08.46-.15.85-.22.4-.07.83-.11,1.3-.11ZM1014.24,531.38c.31,0,.59,0,.83-.02.24-.01.44-.04.61-.08v-2.21c-.1-.05-.25-.09-.46-.12-.21-.03-.47-.05-.78-.05-.2,0-.41.01-.63.04-.22.03-.43.09-.61.18-.18.09-.34.21-.46.37-.12.16-.19.36-.19.62,0,.48.15.81.46.99.3.18.72.28,1.24.28Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-370",
    d: "M1019.17,525.14c.3-.08.71-.16,1.21-.24.5-.08,1.08-.13,1.73-.13.47,0,.87.06,1.2.19.32.13.59.32.81.56.07-.05.17-.11.31-.2.14-.08.32-.17.53-.25s.44-.15.7-.21c.26-.06.53-.09.83-.09.57,0,1.04.08,1.4.25.36.17.64.4.85.71.2.3.34.67.41,1.08s.11.87.11,1.37v4.16h-1.33v-3.88c0-.44-.02-.81-.06-1.13s-.12-.58-.24-.78c-.12-.21-.28-.36-.48-.46-.21-.1-.47-.15-.79-.15-.45,0-.81.06-1.1.18-.29.12-.49.23-.59.32.08.25.13.52.17.81.04.29.06.6.06.93v4.16h-1.33v-3.88c0-.44-.02-.81-.07-1.13-.05-.31-.13-.58-.25-.78s-.28-.36-.48-.46-.46-.15-.78-.15c-.13,0-.28,0-.43.01-.15,0-.3.02-.43.04-.14.01-.26.03-.38.05-.11.02-.19.03-.23.04v6.26h-1.33v-7.2Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-370",
    d: "M1037.98,528.63c0,.59-.09,1.12-.26,1.6-.17.48-.41.88-.72,1.23s-.68.61-1.1.79-.89.28-1.4.28-.97-.09-1.4-.28-.8-.45-1.1-.79-.55-.75-.72-1.23c-.17-.47-.26-1.01-.26-1.6s.09-1.11.26-1.59c.17-.48.41-.89.72-1.23.31-.34.68-.61,1.1-.79.43-.18.89-.28,1.4-.28s.97.09,1.4.28c.43.19.8.45,1.1.79.31.34.55.75.72,1.23.17.48.26,1.01.26,1.59ZM1036.6,528.63c0-.84-.19-1.5-.56-1.99-.38-.49-.89-.73-1.53-.73s-1.16.25-1.53.73-.56,1.15-.56,1.99.19,1.5.56,1.99.89.73,1.53.73,1.16-.24,1.53-.73c.38-.49.56-1.15.56-1.99Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-370",
    d: "M1045.75,532.13c-.3.08-.71.16-1.2.24-.5.09-1.08.13-1.73.13-.57,0-1.05-.08-1.44-.25s-.7-.4-.94-.71c-.24-.3-.41-.66-.51-1.08s-.16-.87-.16-1.38v-4.16h1.33v3.88c0,.9.14,1.55.43,1.94s.76.58,1.44.58c.14,0,.29,0,.44-.01.15,0,.29-.02.43-.04.13-.01.25-.03.36-.04s.19-.03.24-.05v-6.26h1.33v7.2Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-370",
    d: "M1048.03,525.14c.3-.08.71-.16,1.21-.24.5-.08,1.08-.13,1.74-.13.59,0,1.08.08,1.47.25.39.17.7.4.93.7.23.3.4.66.49,1.08.09.42.14.88.14,1.38v4.16h-1.33v-3.88c0-.46-.03-.85-.09-1.17-.06-.32-.16-.58-.31-.78-.14-.2-.33-.34-.57-.43-.24-.09-.53-.13-.88-.13-.14,0-.29,0-.44.01-.15,0-.3.02-.43.04-.14.01-.26.03-.37.05-.11.02-.19.03-.23.04v6.26h-1.33v-7.2Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-370",
    d: "M1057.45,524.93h2.81v1.11h-2.81v3.42c0,.37.03.68.09.92.06.24.14.43.26.57.11.14.26.24.43.29.17.06.37.09.6.09.4,0,.72-.04.96-.14.24-.09.41-.15.51-.19l.26,1.1c-.13.07-.37.15-.7.25-.33.1-.71.15-1.14.15-.5,0-.92-.06-1.25-.19-.33-.13-.59-.32-.79-.58-.2-.26-.34-.57-.42-.95-.08-.38-.12-.81-.12-1.3v-6.61l1.33-.23v2.29Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-370",
    d: "M1061.55,526h6.53v1.13h-6.53v-1.13ZM1061.55,529.03h6.53v1.13h-6.53v-1.13Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-370",
    d: "M1070.16,524.5c.54-.21,1.07-.48,1.58-.81.51-.33.98-.74,1.41-1.23h.94v9.88h-1.33v-8.04c-.11.11-.25.21-.42.33s-.35.22-.54.33c-.2.1-.4.2-.61.3-.21.1-.42.18-.62.24l-.41-1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-370",
    d: "M1077.58,527.39c0-1.65.29-2.93.88-3.82.58-.89,1.39-1.34,2.43-1.34s1.85.45,2.43,1.34c.58.89.88,2.17.88,3.82s-.29,2.93-.88,3.82c-.58.89-1.39,1.34-2.43,1.34s-1.85-.45-2.43-1.34c-.58-.89-.88-2.17-.88-3.82ZM1082.8,527.39c0-.54-.03-1.05-.09-1.54s-.17-.91-.31-1.27c-.15-.36-.34-.65-.59-.86s-.55-.32-.91-.32-.67.11-.91.32-.44.5-.59.86c-.15.36-.25.78-.31,1.27-.06.48-.09,1-.09,1.54s.03,1.05.09,1.54c.06.48.17.91.31,1.27.15.36.34.65.59.86s.55.32.91.32.67-.11.91-.32.44-.5.59-.86.25-.78.31-1.27.09-1,.09-1.54Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-370",
    d: "M1085.62,527.39c0-1.65.29-2.93.88-3.82.58-.89,1.39-1.34,2.43-1.34s1.85.45,2.43,1.34c.58.89.88,2.17.88,3.82s-.29,2.93-.88,3.82c-.58.89-1.39,1.34-2.43,1.34s-1.85-.45-2.43-1.34c-.58-.89-.88-2.17-.88-3.82ZM1090.84,527.39c0-.54-.03-1.05-.09-1.54s-.17-.91-.31-1.27c-.15-.36-.34-.65-.59-.86s-.55-.32-.91-.32-.67.11-.91.32-.44.5-.59.86c-.15.36-.25.78-.31,1.27-.06.48-.09,1-.09,1.54s.03,1.05.09,1.54c.06.48.17.91.31,1.27.15.36.34.65.59.86s.55.32.91.32.67-.11.91-.32.44-.5.59-.86.25-.78.31-1.27.09-1,.09-1.54Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-370",
    d: "M765.48,546.82c0-.37.06-.7.17-.99.11-.29.27-.55.46-.78.19-.23.42-.44.68-.61.26-.17.52-.33.8-.46-.7-.7-1.05-1.43-1.05-2.18,0-.38.06-.72.19-1.03.13-.3.3-.56.53-.77s.49-.37.8-.48c.31-.11.65-.17,1.02-.17s.72.06,1.02.17c.3.11.55.27.76.46.2.19.36.42.46.68s.16.55.16.84c0,.33-.05.63-.16.9-.11.27-.26.51-.44.73-.18.22-.4.42-.63.6-.24.18-.49.34-.76.48l2.31,2.35c.32-.6.53-1.26.63-2l1.1.14c-.04.39-.13.82-.29,1.28-.16.46-.38.92-.66,1.38.33.36.64.72.92,1.07s.51.69.69,1.03h-1.4c-.11-.19-.25-.38-.42-.58-.17-.2-.34-.4-.52-.6-.39.39-.84.71-1.35.95s-1.1.36-1.77.36c-.62,0-1.13-.09-1.54-.26s-.74-.4-.99-.67c-.25-.27-.43-.57-.53-.89-.1-.32-.16-.63-.16-.93ZM766.81,546.79c0,.17.03.36.1.56.07.2.18.38.33.55.15.17.35.3.59.41s.54.16.91.16c.46,0,.89-.09,1.29-.26s.74-.41,1.05-.73l-2.78-2.81c-.17.08-.34.19-.52.3-.18.11-.33.25-.48.42s-.26.36-.35.59c-.09.23-.14.49-.14.8ZM770.27,541.53c0-.32-.11-.6-.32-.82-.21-.22-.51-.33-.88-.33-.42,0-.74.13-.96.38-.22.25-.33.56-.33.93,0,.62.32,1.22.97,1.81.21-.1.41-.22.59-.34.18-.12.35-.27.48-.43.14-.16.25-.34.33-.54.08-.19.12-.42.12-.66Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-370",
    d: "M777.85,541.85c.53,0,.98.07,1.35.21.37.14.66.33.88.58.22.25.38.55.48.9.09.35.14.73.14,1.15v4.63c-.11.02-.27.04-.48.08s-.43.06-.69.09-.53.05-.83.08c-.3.02-.6.04-.89.04-.42,0-.8-.04-1.15-.13-.35-.08-.66-.22-.91-.41-.26-.18-.46-.43-.6-.73-.14-.3-.21-.67-.21-1.1s.08-.76.25-1.05c.17-.29.39-.53.68-.71.29-.18.62-.31,1-.4.38-.09.78-.13,1.2-.13.13,0,.27,0,.41.02.14.01.28.03.41.06.13.02.24.04.33.06.1.02.16.03.2.04v-.37c0-.22-.02-.43-.07-.65-.05-.21-.13-.4-.26-.57s-.29-.3-.51-.4c-.21-.1-.49-.15-.83-.15-.44,0-.82.03-1.15.09-.33.06-.57.13-.73.19l-.16-1.1c.17-.08.46-.15.85-.22.4-.07.83-.11,1.3-.11ZM777.96,548.49c.31,0,.59,0,.83-.02.24-.01.44-.04.61-.08v-2.21c-.1-.05-.25-.09-.46-.12-.21-.03-.47-.05-.78-.05-.2,0-.41.01-.63.04-.22.03-.43.09-.61.18-.18.09-.34.21-.46.37-.12.16-.19.36-.19.62,0,.48.15.81.46.99.3.18.72.28,1.24.28Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-370",
    d: "M786.12,549.61c-.6,0-1.12-.09-1.58-.29-.45-.19-.83-.46-1.14-.8-.31-.34-.54-.75-.69-1.22-.15-.47-.23-.99-.23-1.56s.08-1.09.25-1.57c.17-.47.4-.89.71-1.23s.68-.62,1.12-.81c.44-.19.93-.29,1.47-.29.33,0,.67.03,1,.08.33.06.65.15.96.27l-.3,1.13c-.2-.1-.43-.17-.69-.23-.26-.06-.54-.09-.83-.09-.74,0-1.31.23-1.7.7-.39.46-.59,1.14-.59,2.04,0,.4.04.77.13,1.1.09.33.23.62.43.86.2.24.44.42.75.55.3.13.67.19,1.11.19.35,0,.67-.03.95-.1.29-.07.51-.14.67-.21l.19,1.11c-.08.05-.19.09-.33.13-.14.04-.3.08-.48.11s-.37.06-.58.09c-.2.02-.4.04-.59.04Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-370",
    d: "M792.74,549.61c-.6,0-1.12-.09-1.58-.29-.45-.19-.83-.46-1.14-.8-.31-.34-.54-.75-.69-1.22-.15-.47-.23-.99-.23-1.56s.08-1.09.25-1.57c.17-.47.4-.89.71-1.23s.68-.62,1.12-.81c.44-.19.93-.29,1.47-.29.33,0,.67.03,1,.08.33.06.65.15.96.27l-.3,1.13c-.2-.1-.43-.17-.69-.23-.26-.06-.54-.09-.83-.09-.74,0-1.31.23-1.7.7-.39.46-.59,1.14-.59,2.04,0,.4.04.77.13,1.1.09.33.23.62.43.86.2.24.44.42.75.55.3.13.67.19,1.11.19.35,0,.67-.03.95-.1.29-.07.51-.14.67-.21l.19,1.11c-.08.05-.19.09-.33.13-.14.04-.3.08-.48.11s-.37.06-.58.09c-.2.02-.4.04-.59.04Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-370",
    d: "M802.5,545.74c0,.59-.09,1.12-.26,1.6-.17.48-.41.88-.72,1.23s-.68.61-1.1.79-.89.28-1.4.28-.97-.09-1.4-.28-.8-.45-1.1-.79-.55-.75-.72-1.23c-.17-.47-.26-1.01-.26-1.6s.09-1.11.26-1.59c.17-.48.41-.89.72-1.23.31-.34.68-.61,1.1-.79.43-.18.89-.28,1.4-.28s.97.09,1.4.28c.43.19.8.45,1.1.79.31.34.55.75.72,1.23.17.48.26,1.01.26,1.59ZM801.12,545.74c0-.84-.19-1.5-.56-1.99-.38-.49-.89-.73-1.53-.73s-1.16.25-1.53.73-.56,1.15-.56,1.99.19,1.5.56,1.99.89.73,1.53.73,1.16-.24,1.53-.73c.38-.49.56-1.15.56-1.99Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-370",
    d: "M810.27,549.23c-.3.08-.71.16-1.2.24-.5.09-1.08.13-1.73.13-.57,0-1.05-.08-1.44-.25s-.7-.4-.94-.71c-.24-.3-.41-.66-.51-1.08s-.16-.87-.16-1.38v-4.16h1.33v3.88c0,.9.14,1.55.43,1.94s.76.58,1.44.58c.14,0,.29,0,.44-.01.15,0,.29-.02.43-.04.13-.01.25-.03.36-.04s.19-.03.24-.05v-6.26h1.33v7.2Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-370",
    d: "M812.55,542.24c.3-.08.71-.16,1.21-.24.5-.08,1.08-.13,1.74-.13.59,0,1.08.08,1.47.25.39.17.7.4.93.7.23.3.4.66.49,1.08.09.42.14.88.14,1.38v4.16h-1.33v-3.88c0-.46-.03-.85-.09-1.17-.06-.32-.16-.58-.31-.78-.14-.2-.33-.34-.57-.43-.24-.09-.53-.13-.88-.13-.14,0-.29,0-.44.01-.15,0-.3.02-.43.04-.14.01-.26.03-.37.05-.11.02-.19.03-.23.04v6.26h-1.33v-7.2Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-370",
    d: "M821.97,542.03h2.81v1.11h-2.81v3.42c0,.37.03.68.09.92.06.24.14.43.26.57.11.14.26.24.43.29.17.06.37.09.6.09.4,0,.72-.04.96-.14.24-.09.41-.15.51-.19l.26,1.1c-.13.07-.37.15-.7.25-.33.1-.71.15-1.14.15-.5,0-.92-.06-1.25-.19-.33-.13-.59-.32-.79-.58-.2-.26-.34-.57-.42-.95-.08-.38-.12-.81-.12-1.3v-6.61l1.33-.23v2.29Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-370",
    d: "M833.32,549.44c-.21-.35-.45-.75-.72-1.18-.27-.44-.56-.89-.88-1.36-.31-.47-.64-.95-.98-1.43-.34-.48-.67-.95-1-1.4-.33-.45-.66-.88-.97-1.28s-.6-.75-.87-1.05v7.71h-1.35v-9.88h1.1c.45.47.92,1.03,1.43,1.66.51.63,1.01,1.28,1.51,1.95s.97,1.33,1.41,1.97c.44.65.81,1.22,1.12,1.72v-7.31h1.35v9.88h-1.15Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-370",
    d: "M842.74,549.23c-.3.08-.71.16-1.2.24-.5.09-1.08.13-1.73.13-.57,0-1.05-.08-1.44-.25s-.7-.4-.94-.71c-.24-.3-.41-.66-.51-1.08s-.16-.87-.16-1.38v-4.16h1.33v3.88c0,.9.14,1.55.43,1.94s.76.58,1.44.58c.14,0,.29,0,.44-.01.15,0,.29-.02.43-.04.13-.01.25-.03.36-.04s.19-.03.24-.05v-6.26h1.33v7.2Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-370",
    d: "M845.02,542.24c.3-.08.71-.16,1.21-.24.5-.08,1.08-.13,1.73-.13.47,0,.87.06,1.2.19.32.13.59.32.81.56.07-.05.17-.11.31-.2.14-.08.32-.17.53-.25s.44-.15.7-.21c.26-.06.53-.09.83-.09.57,0,1.04.08,1.4.25.36.17.64.4.85.71.2.3.34.67.41,1.08s.11.87.11,1.37v4.16h-1.33v-3.88c0-.44-.02-.81-.06-1.13s-.12-.58-.24-.78c-.12-.21-.28-.36-.48-.46-.21-.1-.47-.15-.79-.15-.45,0-.81.06-1.1.18-.29.12-.49.23-.59.32.08.25.13.52.17.81.04.29.06.6.06.93v4.16h-1.33v-3.88c0-.44-.02-.81-.07-1.13-.05-.31-.13-.58-.25-.78s-.28-.36-.48-.46-.46-.15-.78-.15c-.13,0-.28,0-.43.01-.15,0-.3.02-.43.04-.14.01-.26.03-.38.05-.11.02-.19.03-.23.04v6.26h-1.33v-7.2Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-370",
    d: "M858.61,542.36c.16-.1.41-.21.73-.33.33-.11.71-.17,1.13-.17.53,0,1,.1,1.42.29.41.19.76.46,1.05.8.29.34.5.75.65,1.23.15.47.22,1,.22,1.57,0,.6-.09,1.14-.26,1.62s-.42.89-.75,1.22c-.32.33-.71.59-1.17.77s-.97.27-1.54.27c-.62,0-1.16-.04-1.64-.13-.47-.09-.86-.17-1.17-.26v-10.62l1.33-.23v3.98ZM858.61,548.29c.13.04.32.07.56.11.24.03.54.05.91.05.71,0,1.28-.23,1.71-.71.43-.47.64-1.14.64-2,0-.38-.04-.74-.11-1.07-.08-.33-.2-.62-.37-.86-.17-.24-.39-.43-.66-.57s-.6-.21-.98-.21-.69.06-1,.19c-.3.12-.54.25-.7.38v4.69Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-370",
    d: "M865.27,545.75c0-.66.09-1.23.29-1.72s.44-.9.76-1.22c.31-.32.67-.57,1.08-.73.41-.16.83-.24,1.25-.24,1,0,1.76.31,2.29.93s.8,1.57.8,2.84v.22c0,.09,0,.17-.01.25h-5.07c.06.77.28,1.35.67,1.75.39.4,1,.6,1.82.6.46,0,.86-.04,1.18-.12.32-.08.56-.16.72-.23l.18,1.11c-.16.08-.44.18-.85.27-.4.09-.86.14-1.38.14-.65,0-1.2-.1-1.67-.29s-.86-.46-1.16-.81c-.3-.34-.53-.75-.68-1.22-.15-.47-.22-.99-.22-1.55ZM870.35,545.02c0-.6-.14-1.09-.45-1.47s-.73-.58-1.28-.58c-.3,0-.57.06-.8.18-.23.12-.43.27-.59.46-.16.19-.29.41-.38.66-.09.25-.15.5-.18.75h3.68Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-370",
    d: "M876.38,541.87c.11,0,.25,0,.39.02.15.01.29.03.43.06.14.02.27.05.39.07.12.02.21.05.26.06l-.23,1.15c-.11-.04-.28-.08-.52-.14-.24-.05-.55-.08-.93-.08-.25,0-.49.03-.73.08-.24.05-.4.09-.48.11v6.23h-1.33v-7.1c.31-.11.7-.22,1.17-.32s.99-.15,1.57-.15Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-370",
    d: "M878.76,543.1h6.53v1.13h-6.53v-1.13ZM878.76,546.13h6.53v1.13h-6.53v-1.13Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-370",
    d: "M887.37,541.6c.54-.21,1.07-.48,1.58-.81.51-.33.98-.74,1.41-1.23h.94v9.88h-1.33v-8.04c-.11.11-.25.21-.42.33s-.35.22-.54.33c-.2.1-.4.2-.61.3-.21.1-.42.18-.62.24l-.41-1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-370",
    d: "M894.79,544.5c0-1.65.29-2.93.88-3.82.58-.89,1.39-1.34,2.43-1.34s1.85.45,2.43,1.34c.58.89.88,2.17.88,3.82s-.29,2.93-.88,3.82c-.58.89-1.39,1.34-2.43,1.34s-1.85-.45-2.43-1.34c-.58-.89-.88-2.17-.88-3.82ZM900.01,544.5c0-.54-.03-1.05-.09-1.54s-.17-.91-.31-1.27c-.15-.36-.34-.65-.59-.86s-.55-.32-.91-.32-.67.11-.91.32-.44.5-.59.86c-.15.36-.25.78-.31,1.27-.06.48-.09,1-.09,1.54s.03,1.05.09,1.54c.06.48.17.91.31,1.27.15.36.34.65.59.86s.55.32.91.32.67-.11.91-.32.44-.5.59-.86.25-.78.31-1.27.09-1,.09-1.54Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-370",
    d: "M903.44,541.6c.54-.21,1.07-.48,1.58-.81.51-.33.98-.74,1.41-1.23h.94v9.88h-1.33v-8.04c-.11.11-.25.21-.42.33s-.35.22-.54.33c-.2.1-.4.2-.61.3-.21.1-.42.18-.62.24l-.41-1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-370",
    d: "M911.48,541.6c.54-.21,1.07-.48,1.58-.81.51-.33.98-.74,1.41-1.23h.94v9.88h-1.33v-8.04c-.11.11-.25.21-.42.33s-.35.22-.54.33c-.2.1-.4.2-.61.3-.21.1-.42.18-.62.24l-.41-1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-370",
    d: "M920.6,538.61v.71c0,.47-.03.95-.08,1.46-.06.51-.13,1.01-.21,1.52h-.78c-.08-.5-.16-1.01-.21-1.52-.06-.51-.08-1-.08-1.48v-.7h1.38ZM923.12,538.61v.71c0,.47-.03.95-.08,1.46-.06.51-.13,1.01-.21,1.52h-.78c-.08-.5-.16-1.01-.21-1.52-.06-.51-.08-1-.08-1.48v-.7h1.38Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-370",
    d: "M924.91,543.1l.37-1.1,6.16,2.61v1.14l-6.16,2.61-.37-1.1,5.06-2.08-5.06-2.08Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-370",
    d: "M935.77,549.44v-3.96c-.66-1.02-1.27-2.02-1.85-3.01-.58-.99-1.13-1.96-1.64-2.91h1.62c.36.78.76,1.57,1.21,2.37.45.8.91,1.57,1.38,2.32.47-.74.92-1.51,1.37-2.32s.86-1.59,1.23-2.37h1.54c-.51.95-1.06,1.92-1.64,2.9-.58.98-1.19,1.98-1.84,2.99v3.99h-1.38Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-370",
    d: "M947.7,545.74c0,.59-.09,1.12-.26,1.6-.17.48-.41.88-.72,1.23s-.68.61-1.1.79-.89.28-1.4.28-.97-.09-1.4-.28-.8-.45-1.1-.79-.55-.75-.72-1.23c-.17-.47-.26-1.01-.26-1.6s.09-1.11.26-1.59c.17-.48.41-.89.72-1.23.31-.34.68-.61,1.1-.79.43-.18.89-.28,1.4-.28s.97.09,1.4.28c.43.19.8.45,1.1.79.31.34.55.75.72,1.23.17.48.26,1.01.26,1.59ZM946.31,545.74c0-.84-.19-1.5-.56-1.99-.38-.49-.89-.73-1.53-.73s-1.16.25-1.53.73-.56,1.15-.56,1.99.19,1.5.56,1.99.89.73,1.53.73,1.16-.24,1.53-.73c.38-.49.56-1.15.56-1.99Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-370",
    d: "M955.46,549.23c-.3.08-.71.16-1.2.24-.5.09-1.08.13-1.73.13-.57,0-1.05-.08-1.44-.25s-.7-.4-.94-.71c-.24-.3-.41-.66-.51-1.08s-.16-.87-.16-1.38v-4.16h1.33v3.88c0,.9.14,1.55.43,1.94s.76.58,1.44.58c.14,0,.29,0,.44-.01.15,0,.29-.02.43-.04.13-.01.25-.03.36-.04s.19-.03.24-.05v-6.26h1.33v7.2Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-370",
    d: "M961.03,549.44v-10.83l1.33-.23v3.79c.25-.09.51-.17.79-.22.28-.05.56-.08.83-.08.59,0,1.08.08,1.47.25.39.17.7.4.93.7.23.3.4.66.49,1.08.09.42.14.88.14,1.38v4.16h-1.33v-3.88c0-.46-.03-.85-.09-1.17-.06-.32-.16-.58-.31-.78-.14-.2-.33-.34-.57-.43-.24-.09-.53-.13-.88-.13-.14,0-.29,0-.44.03-.15.02-.3.04-.43.06-.14.02-.26.05-.37.08s-.19.05-.23.07v6.16h-1.33Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-370",
    d: "M971.56,541.85c.53,0,.98.07,1.35.21.37.14.66.33.88.58.22.25.38.55.48.9.09.35.14.73.14,1.15v4.63c-.11.02-.27.04-.48.08s-.43.06-.69.09-.53.05-.83.08c-.3.02-.6.04-.89.04-.42,0-.8-.04-1.15-.13-.35-.08-.66-.22-.91-.41-.26-.18-.46-.43-.6-.73-.14-.3-.21-.67-.21-1.1s.08-.76.25-1.05c.17-.29.39-.53.68-.71.29-.18.62-.31,1-.4.38-.09.78-.13,1.2-.13.13,0,.27,0,.41.02.14.01.28.03.41.06.13.02.24.04.33.06.1.02.16.03.2.04v-.37c0-.22-.02-.43-.07-.65-.05-.21-.13-.4-.26-.57s-.29-.3-.51-.4c-.21-.1-.49-.15-.83-.15-.44,0-.82.03-1.15.09-.33.06-.57.13-.73.19l-.16-1.1c.17-.08.46-.15.85-.22.4-.07.83-.11,1.3-.11ZM971.68,548.49c.31,0,.59,0,.83-.02.24-.01.44-.04.61-.08v-2.21c-.1-.05-.25-.09-.46-.12-.21-.03-.47-.05-.78-.05-.2,0-.41.01-.63.04-.22.03-.43.09-.61.18-.18.09-.34.21-.46.37-.12.16-.19.36-.19.62,0,.48.15.81.46.99.3.18.72.28,1.24.28Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-370",
    d: "M982.18,542.03c-.37,1.39-.8,2.72-1.3,3.99-.5,1.27-.98,2.41-1.45,3.42h-1.2c-.47-1.01-.95-2.15-1.45-3.42-.5-1.27-.93-2.6-1.3-3.99h1.43c.11.46.25.96.41,1.49.16.53.32,1.05.5,1.57s.35,1.02.54,1.5c.18.49.35.92.51,1.3.16-.38.33-.81.51-1.3.18-.48.36-.99.54-1.5s.34-1.04.5-1.57c.16-.53.29-1.02.41-1.49h1.37Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-370",
    d: "M982.94,545.75c0-.66.09-1.23.29-1.72s.44-.9.76-1.22c.31-.32.67-.57,1.08-.73.41-.16.83-.24,1.25-.24,1,0,1.76.31,2.29.93s.8,1.57.8,2.84v.22c0,.09,0,.17-.01.25h-5.07c.06.77.28,1.35.67,1.75.39.4,1,.6,1.82.6.46,0,.86-.04,1.18-.12.32-.08.56-.16.72-.23l.18,1.11c-.16.08-.44.18-.85.27-.4.09-.86.14-1.38.14-.65,0-1.2-.1-1.67-.29s-.86-.46-1.16-.81c-.3-.34-.53-.75-.68-1.22-.15-.47-.22-.99-.22-1.55ZM988.03,545.02c0-.6-.14-1.09-.45-1.47s-.73-.58-1.28-.58c-.3,0-.57.06-.8.18-.23.12-.43.27-.59.46-.16.19-.29.41-.38.66-.09.25-.15.5-.18.75h3.68Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-370",
    d: "M1000.67,549.44c-.27-.68-.55-1.47-.85-2.34-.3-.88-.57-1.79-.82-2.74-.25.95-.52,1.87-.81,2.74-.29.88-.57,1.66-.84,2.34h-1.15c-.44-.98-.86-2.09-1.28-3.35-.42-1.25-.81-2.61-1.18-4.06h1.42c.09.45.21.93.34,1.45s.27,1.04.42,1.57c.15.52.3,1.03.46,1.51.16.48.31.91.46,1.27.16-.45.32-.92.48-1.42.16-.5.31-1,.45-1.51.14-.51.28-1.01.41-1.5.13-.49.24-.95.33-1.38h1.1c.09.43.19.89.31,1.38s.26.99.4,1.5c.14.51.29,1.01.45,1.51.16.5.32.97.48,1.42.14-.36.29-.78.45-1.27s.31-.99.46-1.51c.15-.52.29-1.04.43-1.57s.25-1.01.34-1.45h1.37c-.37,1.45-.76,2.81-1.18,4.06-.42,1.25-.85,2.37-1.28,3.35h-1.15Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-370",
    d: "M1012.05,545.74c0,.59-.09,1.12-.26,1.6-.17.48-.41.88-.72,1.23s-.68.61-1.1.79-.89.28-1.4.28-.97-.09-1.4-.28-.8-.45-1.1-.79-.55-.75-.72-1.23c-.17-.47-.26-1.01-.26-1.6s.09-1.11.26-1.59c.17-.48.41-.89.72-1.23.31-.34.68-.61,1.1-.79.43-.18.89-.28,1.4-.28s.97.09,1.4.28c.43.19.8.45,1.1.79.31.34.55.75.72,1.23.17.48.26,1.01.26,1.59ZM1010.67,545.74c0-.84-.19-1.5-.56-1.99-.38-.49-.89-.73-1.53-.73s-1.16.25-1.53.73-.56,1.15-.56,1.99.19,1.5.56,1.99.89.73,1.53.73,1.16-.24,1.53-.73c.38-.49.56-1.15.56-1.99Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-370",
    d: "M1013.92,542.24c.3-.08.71-.16,1.21-.24.5-.08,1.08-.13,1.74-.13.59,0,1.08.08,1.47.25.39.17.7.4.93.7.23.3.4.66.49,1.08.09.42.14.88.14,1.38v4.16h-1.33v-3.88c0-.46-.03-.85-.09-1.17-.06-.32-.16-.58-.31-.78-.14-.2-.33-.34-.57-.43-.24-.09-.53-.13-.88-.13-.14,0-.29,0-.44.01-.15,0-.3.02-.43.04-.14.01-.26.03-.37.05-.11.02-.19.03-.23.04v6.26h-1.33v-7.2Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-370",
    d: "M1027.76,544.13h2.69v1.07h-2.69v.11c0,.48-.02.97-.06,1.5-.04.52-.1,1.02-.17,1.5h4.12v1.14h-5.62c.1-.67.2-1.35.28-2.02.08-.67.12-1.34.12-2.02v-.21h-1.33v-1.07h1.33v-1.18c0-.7.07-1.28.22-1.75s.36-.83.63-1.1.6-.46.98-.56c.38-.1.8-.16,1.25-.16.42,0,.77.04,1.05.11s.56.17.83.27l-.33,1.14c-.5-.24-1.04-.36-1.61-.36-.26,0-.49.04-.7.11s-.39.2-.53.38-.26.42-.34.73-.12.68-.12,1.14v1.21Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-370",
    d: "M1033.61,541.6c.54-.21,1.07-.48,1.58-.81.51-.33.98-.74,1.41-1.23h.94v9.88h-1.33v-8.04c-.11.11-.25.21-.42.33s-.35.22-.54.33c-.2.1-.4.2-.61.3-.21.1-.42.18-.62.24l-.41-1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-370",
    d: "M1041.04,544.5c0-1.65.29-2.93.88-3.82.58-.89,1.39-1.34,2.43-1.34s1.85.45,2.43,1.34c.58.89.88,2.17.88,3.82s-.29,2.93-.88,3.82c-.58.89-1.39,1.34-2.43,1.34s-1.85-.45-2.43-1.34c-.58-.89-.88-2.17-.88-3.82ZM1046.25,544.5c0-.54-.03-1.05-.09-1.54s-.17-.91-.31-1.27c-.15-.36-.34-.65-.59-.86s-.55-.32-.91-.32-.67.11-.91.32-.44.5-.59.86c-.15.36-.25.78-.31,1.27-.06.48-.09,1-.09,1.54s.03,1.05.09,1.54c.06.48.17.91.31,1.27.15.36.34.65.59.86s.55.32.91.32.67-.11.91-.32.44-.5.59-.86.25-.78.31-1.27.09-1,.09-1.54Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-370",
    d: "M1049.08,544.5c0-1.65.29-2.93.88-3.82.58-.89,1.39-1.34,2.43-1.34s1.85.45,2.43,1.34c.58.89.88,2.17.88,3.82s-.29,2.93-.88,3.82c-.58.89-1.39,1.34-2.43,1.34s-1.85-.45-2.43-1.34c-.58-.89-.88-2.17-.88-3.82ZM1054.29,544.5c0-.54-.03-1.05-.09-1.54s-.17-.91-.31-1.27c-.15-.36-.34-.65-.59-.86s-.55-.32-.91-.32-.67.11-.91.32-.44.5-.59.86c-.15.36-.25.78-.31,1.27-.06.48-.09,1-.09,1.54s.03,1.05.09,1.54c.06.48.17.91.31,1.27.15.36.34.65.59.86s.55.32.91.32.67-.11.91-.32.44-.5.59-.86.25-.78.31-1.27.09-1,.09-1.54Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-370",
    d: "M1057.11,544.5c0-1.65.29-2.93.88-3.82.58-.89,1.39-1.34,2.43-1.34s1.85.45,2.43,1.34c.58.89.88,2.17.88,3.82s-.29,2.93-.88,3.82c-.58.89-1.39,1.34-2.43,1.34s-1.85-.45-2.43-1.34c-.58-.89-.88-2.17-.88-3.82ZM1062.33,544.5c0-.54-.03-1.05-.09-1.54s-.17-.91-.31-1.27c-.15-.36-.34-.65-.59-.86s-.55-.32-.91-.32-.67.11-.91.32-.44.5-.59.86c-.15.36-.25.78-.31,1.27-.06.48-.09,1-.09,1.54s.03,1.05.09,1.54c.06.48.17.91.31,1.27.15.36.34.65.59.86s.55.32.91.32.67-.11.91-.32.44-.5.59-.86.25-.78.31-1.27.09-1,.09-1.54Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-370",
    d: "M1066.66,545.18l5.06,2.08-.37,1.1-6.16-2.61v-1.14l6.16-2.61.37,1.1-5.06,2.08Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-370",
    d: "M1073.49,552.08h-1.35l4.83-13.8h1.33l-4.8,13.8Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-370",
    d: "M1081.48,541.85c.53,0,.98.07,1.35.21.37.14.66.33.88.58.22.25.38.55.48.9.09.35.14.73.14,1.15v4.63c-.11.02-.27.04-.48.08s-.43.06-.69.09-.53.05-.83.08c-.3.02-.6.04-.89.04-.42,0-.8-.04-1.15-.13-.35-.08-.66-.22-.91-.41-.26-.18-.46-.43-.6-.73-.14-.3-.21-.67-.21-1.1s.08-.76.25-1.05c.17-.29.39-.53.68-.71.29-.18.62-.31,1-.4.38-.09.78-.13,1.2-.13.13,0,.27,0,.41.02.14.01.28.03.41.06.13.02.24.04.33.06.1.02.16.03.2.04v-.37c0-.22-.02-.43-.07-.65-.05-.21-.13-.4-.26-.57s-.29-.3-.51-.4c-.21-.1-.49-.15-.83-.15-.44,0-.82.03-1.15.09-.33.06-.57.13-.73.19l-.16-1.1c.17-.08.46-.15.85-.22.4-.07.83-.11,1.3-.11ZM1081.6,548.49c.31,0,.59,0,.83-.02.24-.01.44-.04.61-.08v-2.21c-.1-.05-.25-.09-.46-.12-.21-.03-.47-.05-.78-.05-.2,0-.41.01-.63.04-.22.03-.43.09-.61.18-.18.09-.34.21-.46.37-.12.16-.19.36-.19.62,0,.48.15.81.46.99.3.18.72.28,1.24.28Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-370",
    d: "M1086.14,543.1l.37-1.1,6.16,2.61v1.14l-6.16,2.61-.37-1.1,5.06-2.08-5.06-2.08Z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTopic3);
export default __webpack_public_path__ + "static/media/Topic3.e0a6a9ea1302b84e7a1029c78c48ae0e.svg";
export { ForwardRef as ReactComponent };